<template>
  <teleport to="#section-violations">
    <div id="vehicle-dashboard-get-template-button-test" style="margin-left: 140px; color: black; background: unset;">
      <span class="target-show-span" style="opacity: unset; display: block;"></span>
    </div>

    <div id="my-info">
      <button
        class="not-print float-left hidden"
        @click="
            (e) =>
              html_to_excel_helper.export(
              e.target,
              'vehicle-dashboard-template-content',
              'Дашборд по эксплуатации тс (в разработке)',
              'landscape',
              'vehicle_dashboard',
            )
        "
      >
        Экспорт&nbsp;в&nbsp;EXCEL
      </button>

      <button 
        @click="printElement"
      >
        Сохранить в PDF
      </button>
    </div>
    <div
      class="temlate-report"
      id="vehicle-dashboard-template-content"
    >
      <div data-excelsheet="Дашборд по эксплуатации тс (в разработке)"></div>
      <h6 class="footer-desc text-center font-weight-bold" style="min-width: 1861px;">
        Дашборд по эксплуатации тс (в разработке)
      </h6>
      <div class="table-2 table-striped" style="width: 1920px;">
        <div style="display: inline-block;margin-left: 10px;" :class="{ 'disabled-blurred': isRequestingReport }">
          <p class="not-excel footer-desc">
          <span class="footer-desc_period-label"><strong>ПЕРИОД</strong>
            <span style="display: inline-block;">
            <UiDoubleDatepicker
              v-model:date="dateRange"
              type="dashboard"
              @update:date="onDateChange"
            />
            </span>
          </span>
          <span class="footer-desc_group-label"><strong style="font-weight: 700;font-size: 20px;line-height: 20px;">ГРУППИРОВКА</strong>
            <UiSelect
              class="footer-desc_group-val"
              style="display: inline-block;position: relative;top: 6px;min-height: 12px;"
              v-model:select="groupingType2"
              :items="groupingTypeOptions"
              @update:select="onGroupingChange"
            />
          </span>
          <!-- <span>
            <button
              v-if="showRefreshButton"
              @click="refreshData"
              class="refresh-btn"
            >
              Обновить отчет
            </button>
          </span> -->
          <span style="margin-left: 73.5px;">
            <u-i-report-button
              :is-section-button="false"
              :is-form-submit="false"
              :template-button-id="'vehicle-dashboard-get-template-button'"
              :button-additional-class="'vehicle-dashboard-get-template-button-id'"
              :hint-additional-class="'vehicle-dashboard-get-template-button-target'"
              :text="'запросить данные'"
              @execute-report="executeVehicleReport"
            />

            <button
              @click="openSelectModal"
              class="select-ts-btn"
              style="margin-left: 202px"
            >
              выбрать ТС
            </button>
          </span>
          <span
          v-if="errorText !== ''"
          class="error">
            {{ errorText }}
          </span>
        </p>
        <p class="not-excel excel-bottom-indent">
          <span>Количество ТС в парке<span class="park-count">{{ testData ? testData.length : 0 }}</span></span>
          <span class="park-dut-name">Количество ТС с ДУТ<span class="park-dut-count">{{ testData ? calculateTsHeaderData('ts_with_dut') : 0 }}</span></span>
          <span class="park-work-name">Количество ТС в работе<span class="park-work-count">{{ testData ? calculateTsHeaderData('ts_in_work') : 0}}</span></span>
          <span class="park-dutcorrect-name">ТС с исправным ДУТ<span class="park-dutcorrect-count">{{ testData ? calculateTsHeaderData('ts_with_correct_dut') : 0 }}  </span></span>
        </p>
        <!-- Таблица для экспорта в Excel: ПЕРИОД и ГРУППИРОВКА -->
        <table class="excel-bottom-indent hidden">
          <tbody>
            <tr>
              <td class="font-weight-bold">
                ПЕРИОД
              </td>
              <td :colspan="2">
                {{ dateRange[0].getDate().toString().padStart(2, '0') }}:{{ (dateRange[0].getMonth() + 1).toString().padStart(2, '0') }}:{{ dateRange[0].getFullYear().toString().slice(-2) }} - {{ dateRange[1].getDate().toString().padStart(2, '0') }}:{{ (dateRange[1].getMonth() + 1).toString().padStart(2, '0') }}:{{ dateRange[1].getFullYear().toString().slice(-2) }}
              </td>
              <td :colspan="2" class="font-weight-bold">
                ГРУППИРОВКА
              </td>
              <td :colspan="2">
                {{ groupingType2 === 'day' ? 'дни' : groupingType2 === 'week' ? 'недели' : groupingType2 === 'month' ? 'месяц' : groupingType2 === 'quarter' ? 'квартал' : groupingType2 === 'season' ? 'сезон года' : groupingType2 }}
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Таблица для экспорта в Excel: Статистика ТС -->
        <table class="excel-only-table excel-bottom-indent" style="position: absolute; left: -9999px; top: -9999px;">
          <tbody>
            <tr>
              <td :colspan="3" class="font-weight-bold">
                Количество ТС в парке {{ testData ? testData.length : 0 }}
              </td>
              <td :colspan="3" class="font-weight-bold">
                Количество ТС с ДУТ {{ testData ? calculateTsHeaderData('ts_with_dut') : 0 }}
              </td>
              <td :colspan="3" class="font-weight-bold">
                Количество ТС в работе {{ testData ? calculateTsHeaderData('ts_in_work') : 0 }}
              </td>
              <td :colspan="3" class="font-weight-bold">
                ТС с исправным ДУТ {{ testData ? calculateTsHeaderData('ts_with_correct_dut') : 0 }}
              </td>
            </tr>
          </tbody>
        </table>
        </div>
        
        <img style="position: absolute;width: 150px;right: 50px;top: -9px;z-index: -1;" src="../../../../public/images/logos/remex.png">
      </div>
      

      <div class="charts-container" style="height: auto; min-height: 249px;">
        <!-- Заголовок для Excel: Грубые нарушения -->
        <h6 class="footer-desc text-center font-weight-bold hidden" style="font-size: 20px;">
          Грубые нарушения при управлении ТС
        </h6>
        <span class="sub-container grub">
          <p class="sub-container-title">
            <strong>Грубые нарушения при управлении ТС</strong>
          </p>
            <span v-for="(chartData, index) in violationChartsData" :key="index">
              <div class="bg-white rounded-xl chart-container-border" :style="index > 0 ? 'margin-left: -10px;' : ''">
              <img alt="img" src="../../../../public/images/vehicle-dashboard/fix-chart-bottom-right.png" class="fix_grub_border-bottom-right"/>
              <img alt="img" src="../../../../public/images/vehicle-dashboard/fix-chart-bottom-left.png" class="fix_grub_border-bottom-left"/>
              <div class="chart_header flex justify-between items-start">
                <div class="flex items-center gap-2" style="margin-left: 20px;font-weight: 400;font-size: 12px;">
                  <h2 class="text-xl font-semibold text-gray-800" style="font-size: 12px;font-weight: 400; margin-top: 10px;">{{ chartData.title }}</h2>
                  <div class="group relative flex justify-center" style="margin-left: 14px;">
                    <div class="relative flex justify-center">
                      <span
                        v-if="index === 0"
                        @click="showDvsInfoModalFunc"
                        class="cursor-help text-gray-400 hover:text-gray-600"
                      >
                        <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                      </span>
                      <span
                        v-else-if="index === 1"
                        @click="showTransmissionInfoModalFunc"
                        class="cursor-help text-gray-400 hover:text-gray-600"
                      >
                        <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                      </span>
                      <span
                        v-else-if="index === 2"
                        @click="showKomInfoModalFunc"
                        class="cursor-help text-gray-400 hover:text-gray-600"
                      >
                        <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                      </span>
                      <span
                        v-else
                        class="cursor-help text-gray-400 hover:text-gray-600"
                      >
                        <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                      </span>
                      <div v-if="index !== 0 && index !== 1 && index !== 2" class="absolute bottom-full left-1-2 transform hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2 whitespace-nowrap z-10">
                        {{ chartData.tooltipText }}
                        <div class="absolute top-full left-1-2 transform w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-800"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="icons">
                <button @click="showViolationPanelFunc(index)" class="text-gray-600 hover:text-gray-900 transition-colors p-1 rounded hover:bg-gray-100">
                  <img src="../../../../public/images/icon_document.svg" style="width: 16px; height: 16px; margin-right: 3px;" alt="icon">
                </button>
                <button @click="showMapForViolationType(index)" class="text-gray-600 hover:text-gray-900 transition-colors p-1 rounded hover:bg-gray-100">
                  <img src="../../../../public/images/icon_map.svg" style="width: 16px; height: 16px;" alt="icon">
                </button>
                </div>
              </div>

              <div class="chartt relative">
                <span :ref="el => setChartRef(el, index)" class="chart-wrapper chartContainer" data-excelcolspan="2"></span>
              </div>
            </div>
          </span>
        </span>
        <!-- Заголовок для Excel: Неисправности ТС -->
        <h6 class="footer-desc text-center font-weight-bold hidden" style="font-size: 20px;">
          Неисправности ТС, число ТС/среднее время
        </h6>
        <span class="sub-container lampss" data-excelheightratios="1.7" style="margin-right: 23px;margin-top: 5px;">
          <p class="sub-container-title" style="display: flex; align-items: center;"><strong>Неисправности ТС, число ТС/среднее время</strong></p>
          <div class="">
            <span v-for="(chartData, index) in malfunctionChartsData1" :key="'malfunc-' + (index + 2)">
              <div class="bg-white rounded-xl chart-container-border malfunction-chart" :style="index > 0 ? 'margin-left: -10px;' : ''" data-excelheightratios="1.7">
                <img alt="img" src="../../../../public/images/vehicle-dashboard/fix-chart-bottom-right.png" class="fix_lamps_border-bottom-right"/>
                <img alt="img" src="../../../../public/images/vehicle-dashboard/fix-chart-bottom-left.png" class="fix_lamps_border-bottom-left"/>
                <div class="chart_header flex justify-between items-start" style="">
                  <div class="flex items-center gap-2" style="margin-left: 20px;font-weight: 400;font-size: 12px;">
                    <h2 class="text-xl font-semibold text-gray-800" style="font-size: 12px;font-weight: 400; margin-top: 10px;">{{ chartData.title }}</h2>
                    <div class="group relative flex justify-center" style="margin-left: 14px;">
                      <div class="relative flex justify-center">
                        <span
                          v-if="index === 0"
                          @click="showRedLampInfoModalFunc"
                          class="cursor-help text-gray-400 hover:text-gray-600"
                        >
                          <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                        </span>
                        <span
                          v-else-if="index === 1"
                          @click="showYellowLampInfoModalFunc"
                          class="cursor-help text-gray-400 hover:text-gray-600"
                        >
                          <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                        </span>
                        <span
                          v-else
                          class="cursor-help text-gray-400 hover:text-gray-600"
                        >
                          <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                        </span>
                        <div v-if="index !== 0 && index !== 1" class="absolute bottom-full left-1-2 transform hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2 whitespace-nowrap z-10">
                          {{ chartData.tooltipText }}
                          <div class="absolute top-full left-1-2 transform w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-800"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="icons">
                    <button @click="showViolationPanelFunc(index + 4)" class="text-gray-600 hover:text-gray-900 transition-colors p-1 rounded hover:bg-gray-100">
                      <img src="../../../../public/images/icon_document.svg" style="width: 16px; height: 16px;" alt="icon">
                    </button>
                </div>
                </div>
                <div class="chartt relative">
                  <span :ref="el => setMalfunctionChartRef(el, index)" class="chart-wrapper chartContainer"></span>
                </div>
              </div>
            </span>
            <div class=" bottomlamps">
              <span v-for="(chartData, index) in malfunctionChartsData2" :key="'malfunc-' + (index + 2)">
                <div class="bg-white rounded-xl chart-container-border malfunction-chart" :style="index > 0 ? 'margin-left: -10px;' : ''" data-excelheightratios="1.7">
                  <img alt="img" src="../../../../public/images/vehicle-dashboard/fix-chart-bottom-right.png" class="fix_lamps_border-bottom-right"/>
                  <img alt="img" src="../../../../public/images/vehicle-dashboard/fix-chart-bottom-left.png" class="fix_lamps_border-bottom-left"/>
                  <div class="chart_header flex justify-between items-start">
                    <div class="flex items-center gap-2" style="margin-left: 17px;font-weight: 400;font-size: 12px;">
                      <h2 class="text-xl font-semibold text-gray-800" style="font-size: 12px;font-weight: 400; margin-top: 2px;">{{ chartData.title }}</h2>
                      <div class="group relative flex justify-center" :style="index > 0 ? 'margin-left: 6px;margin-bottom: 8px;' : 'margin-left: 14px;margin-bottom: 8px;'">
                        <div class="relative flex justify-center">
                          <span
                            v-if="index === 0"
                            @click="showCo2InfoModalFunc"
                            class="cursor-help text-gray-400 hover:text-gray-600"
                          >
                            <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                          </span>
                          <span
                            v-else-if="index === 1"
                            @click="showNonElectronicInfoModalFunc"
                            class="cursor-help text-gray-400 hover:text-gray-600"
                          >
                            <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                          </span>
                          <span
                            v-else
                            class="cursor-help text-gray-400 hover:text-gray-600"
                          >
                            <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                          </span>
                          <div v-if="index !== 0 && index !== 1" class="absolute bottom-full left-1-2 transform hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2 whitespace-nowrap z-10">
                            {{ chartData.tooltipText }}
                            <div class="absolute top-full left-1-2 transform w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-800"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="icons" style="margin-right: 14px;margin-bottom: 7px;">
                      <button @click="showViolationPanelFunc(index + 6)" class="text-gray-600 hover:text-gray-900 transition-colors p-1 rounded hover:bg-gray-100">
                        <img src="../../../../public/images/icon_document.svg" style="width: 16px; height: 16px;" alt="icon">
                      </button>
                  </div>
                  </div>
                  <div class="chartt relative">
                    <span :ref="el => setMalfunctionChartRef(el, index + 2)" class="chart-wrapper chartContainer"></span>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </span>

        <!-- Модальное окно с информацией о нарушениях ДВС -->
        <div 
          v-if="showDvsInfoModal" 
          class="dvs-info-modal-overlay" 
          :style="{
            top: infoModalConfig.dvs.overlay.top,
            left: infoModalConfig.dvs.overlay.left,
            right: infoModalConfig.dvs.overlay.right,
            bottom: infoModalConfig.dvs.overlay.bottom
          }"
          @click="hideDvsInfoModalFunc"
        >
          <div class="dvs-info-modal" :style="{ maxHeight: infoModalConfig.dvs.modal.maxHeight }" @click.stop>
            <!-- <div class="dvs-info-modal-header">
              <div class="dvs-info-modal-title">
                <strong>Информация о нарушениях ДВС</strong>
              </div>
              
            </div> -->
            <button @click="hideDvsInfoModalFunc" class="dvs-info-modal-close">
              <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
            </button>
            <div class="dvs-info-modal-content">
              <div v-for="(item, itemIndex) in violationChartsData[0]?.info?.items" :key="itemIndex" class="dvs-info-item">
                <div class="dvs-info-item-title">
                  {{ item.title }}
                  <span v-if="item.description">{{ item.description }}</span>
                </div>
                <ul v-if="item.consequences && item.consequences.length > 0" class="dvs-info-item-consequences">
                  <li v-for="(consequence, consIndex) in item.consequences" :key="consIndex">
                    {{ consequence }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Модальное окно с информацией о нарушениях Трансмиссии -->
        <div
          v-if="showTransmissionInfoModal"
          class="dvs-info-modal-overlay"
          :style="{
            top: infoModalConfig.transmission.overlay.top,
            left: infoModalConfig.transmission.overlay.left,
            right: infoModalConfig.transmission.overlay.right,
            bottom: infoModalConfig.transmission.overlay.bottom
          }"
          @click="hideTransmissionInfoModalFunc"
        >
          <div class="dvs-info-modal dvs-info-modal-transmission" :style="{ maxHeight: infoModalConfig.transmission.modal.maxHeight }" @click.stop>
            <!-- <div class="dvs-info-modal-header">
              <div class="dvs-info-modal-title">
                <strong>Информация о нарушениях Трансмиссии</strong>
              </div>
              
            </div> -->
            <button @click="hideTransmissionInfoModalFunc" class="dvs-info-modal-close">
              <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
            </button>
            <div class="dvs-info-modal-content">
              <div v-for="(item, itemIndex) in violationChartsData[1]?.info?.items" :key="itemIndex" class="dvs-info-item">
                <div class="dvs-info-item-title">
                  {{ item.title }}
                  <span v-if="item.description">{{ item.description }}</span>
                </div>
                <ul v-if="item.consequences && item.consequences.length > 0" class="dvs-info-item-consequences">
                  <li v-for="(consequence, consIndex) in item.consequences" :key="consIndex">
                    {{ consequence }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Модальное окно с информацией о нарушениях КОМ -->
        <div 
          v-if="showKomInfoModal" 
          class="dvs-info-modal-overlay" 
          :style="{
            top: infoModalConfig.kom.overlay.top,
            left: infoModalConfig.kom.overlay.left,
            right: infoModalConfig.kom.overlay.right,
            bottom: infoModalConfig.kom.overlay.bottom
          }"
          @click="hideKomInfoModalFunc"
        >
          <div class="dvs-info-modal" :style="{ maxHeight: infoModalConfig.kom.modal.maxHeight }" @click.stop>
            <!-- <div class="dvs-info-modal-header">
              <div class="dvs-info-modal-title">
                <strong>Информация о нарушениях КОМ</strong>
              </div>
              
            </div> -->
            <button @click="hideKomInfoModalFunc" class="dvs-info-modal-close">
              <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
            </button>
            <div class="dvs-info-modal-content">
              <div v-for="(item, itemIndex) in violationChartsData[2]?.info?.items" :key="itemIndex" class="dvs-info-item">
                <div class="dvs-info-item-title">
                  {{ item.title }}
                  <span v-if="item.description">{{ item.description }}</span>
                </div>
                <ul v-if="item.consequences && item.consequences.length > 0" class="dvs-info-item-consequences">
                  <li v-for="(consequence, consIndex) in item.consequences" :key="consIndex">
                    {{ consequence }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Модальное окно с информацией о неисправностях Красная лампа -->
        <div 
          v-if="showRedLampInfoModal" 
          class="dvs-info-modal-overlay" 
          :style="{
            top: infoModalConfig.redLamp.overlay.top,
            left: infoModalConfig.redLamp.overlay.left,
            right: infoModalConfig.redLamp.overlay.right,
            bottom: infoModalConfig.redLamp.overlay.bottom
          }"
          @click="hideRedLampInfoModalFunc"
        >
          <div class="dvs-info-modal" :style="{ maxHeight: infoModalConfig.redLamp.modal.maxHeight }" @click.stop>
            <!-- <div class="dvs-info-modal-header">
              <div class="dvs-info-modal-title">
                <strong>Информация о неисправностях Красная лампа</strong>
              </div>
              
            </div> -->
            <button @click="hideRedLampInfoModalFunc" class="dvs-info-modal-close">
              <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
            </button>
            <div class="dvs-info-modal-content">
              <div v-for="(item, itemIndex) in malfunctionChartsData1[0]?.info?.items" :key="itemIndex" class="dvs-info-item">
                <div class="dvs-info-item-title">
                  {{ item.title }}
                  <span v-if="item.description">{{ item.description }}</span>
                </div>
                <ul v-if="item.consequences && item.consequences.length > 0" class="dvs-info-item-consequences">
                  <li v-for="(consequence, consIndex) in item.consequences" :key="consIndex">
                    {{ consequence }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Модальное окно с информацией о неисправностях Жёлтая лампа -->
        <div 
          v-if="showYellowLampInfoModal" 
          class="dvs-info-modal-overlay" 
          :style="{
            top: infoModalConfig.yellowLamp.overlay.top,
            left: infoModalConfig.yellowLamp.overlay.left,
            right: infoModalConfig.yellowLamp.overlay.right,
            bottom: infoModalConfig.yellowLamp.overlay.bottom
          }"
          @click="hideYellowLampInfoModalFunc"
        >
          <div class="dvs-info-modal" :style="{ maxHeight: infoModalConfig.yellowLamp.modal.maxHeight }" @click.stop>
            <!-- <div class="dvs-info-modal-header">
              <div class="dvs-info-modal-title">
                <strong>Информация о неисправностях Жёлтая лампа</strong>
              </div>
              
            </div> -->
            <button @click="hideYellowLampInfoModalFunc" class="dvs-info-modal-close">
              <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
            </button>
            <div class="dvs-info-modal-content">
              <div v-for="(item, itemIndex) in malfunctionChartsData1[1]?.info?.items" :key="itemIndex" class="dvs-info-item">
                <div class="dvs-info-item-title">
                  {{ item.title }}
                  <span v-if="item.description">{{ item.description }}</span>
                </div>
                <ul v-if="item.consequences && item.consequences.length > 0" class="dvs-info-item-consequences">
                  <li v-for="(consequence, consIndex) in item.consequences" :key="consIndex">
                    {{ consequence }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Модальное окно с информацией о неисправностях Не связана с электрикой -->
        <div 
          v-if="showCo2InfoModal" 
          class="dvs-info-modal-overlay" 
          :style="{
            top: infoModalConfig.co2.overlay.top,
            left: infoModalConfig.co2.overlay.left,
            right: infoModalConfig.co2.overlay.right,
            bottom: infoModalConfig.co2.overlay.bottom
          }"
          @click="hideCo2InfoModalFunc"
        >
          <div class="dvs-info-modal" :style="{ maxHeight: infoModalConfig.co2.modal.maxHeight }" @click.stop>
            <!-- <div class="dvs-info-modal-header">
              <div class="dvs-info-modal-title">
                <strong>Информация о неисправностях Не связана с электрикой</strong>
              </div>
              
            </div> -->
            <button @click="hideCo2InfoModalFunc" class="dvs-info-modal-close">
              <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
            </button>
            <div class="dvs-info-modal-content">
              <div v-for="(item, itemIndex) in malfunctionChartsData2[0]?.info?.items" :key="itemIndex" class="dvs-info-item">
                <div class="dvs-info-item-title">
                  {{ item.title }}
                  <span v-if="item.description">{{ item.description }}</span>
                </div>
                <ul v-if="item.consequences && item.consequences.length > 0" class="dvs-info-item-consequences">
                  <li v-for="(consequence, consIndex) in item.consequences" :key="consIndex">
                    {{ consequence }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Модальное окно с информацией о неисправностях Выбросы СО2 -->
        <div 
          v-if="showNonElectronicInfoModal" 
          class="dvs-info-modal-overlay" 
          :style="{
            top: infoModalConfig.nonElectronic.overlay.top,
            left: infoModalConfig.nonElectronic.overlay.left,
            right: infoModalConfig.nonElectronic.overlay.right,
            bottom: infoModalConfig.nonElectronic.overlay.bottom
          }"
          @click="hideNonElectronicInfoModalFunc"
        >
          <div class="dvs-info-modal" :style="{ maxHeight: infoModalConfig.nonElectronic.modal.maxHeight }" @click.stop>
            <!-- <div class="dvs-info-modal-header">
              <div class="dvs-info-modal-title">
                <strong>Информация о неисправностях Выбросы СО2</strong>
              </div>
              
            </div> -->
            <button @click="hideNonElectronicInfoModalFunc" class="dvs-info-modal-close">
              <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
            </button>
            <div class="dvs-info-modal-content">
              <div v-for="(item, itemIndex) in malfunctionChartsData2[1]?.info?.items" :key="itemIndex" class="dvs-info-item">
                <div class="dvs-info-item-title">
                  {{ item.title }}
                  <span v-if="item.description">{{ item.description }}</span>
                </div>
                <ul v-if="item.consequences && item.consequences.length > 0" class="dvs-info-item-consequences">
                  <li v-for="(consequence, consIndex) in item.consequences" :key="consIndex">
                    {{ consequence }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Модальное окно с информацией о выходе ТС на линию -->
        <div 
          v-if="showOnLineInfoModal" 
          class="dvs-info-modal-overlay" 
          :style="{
            top: infoModalConfig.onLine.overlay.top,
            left: infoModalConfig.onLine.overlay.left,
            right: infoModalConfig.onLine.overlay.right,
            bottom: infoModalConfig.onLine.overlay.bottom
          }"
          @click="hideOnLineInfoModalFunc"
        >
          <div class="dvs-info-modal" :style="{ maxHeight: infoModalConfig.onLine.modal.maxHeight }" @click.stop>
            <!-- <div class="dvs-info-modal-header">
              <div class="dvs-info-modal-title">
                <strong>Информация о выходе ТС на линию</strong>
              </div>
              
            </div> -->
            <button @click="hideOnLineInfoModalFunc" class="dvs-info-modal-close">
              <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
            </button>
            <div class="dvs-info-modal-content">
              <div v-for="(item, itemIndex) in workChartsData[0]?.info?.items" :key="itemIndex" class="dvs-info-item">
                <div class="dvs-info-item-title">
                  {{ item.title }}
                  <span v-if="item.description">{{ item.description }}</span>
                </div>
                <ul v-if="item.consequences && item.consequences.length > 0" class="dvs-info-item-consequences">
                  <li v-for="(consequence, consIndex) in item.consequences" :key="consIndex">
                    {{ consequence }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Модальное окно с информацией о среднесуточном пробеге -->
        <div 
          v-if="showDistanceInfoModal" 
          class="dvs-info-modal-overlay" 
          :style="{
            top: infoModalConfig.distance.overlay.top,
            left: infoModalConfig.distance.overlay.left,
            right: infoModalConfig.distance.overlay.right,
            bottom: infoModalConfig.distance.overlay.bottom
          }"
          @click="hideDistanceInfoModalFunc"
        >
          <div class="dvs-info-modal" :style="{ maxHeight: infoModalConfig.distance.modal.maxHeight }" @click.stop>
            <!-- <div class="dvs-info-modal-header">
              <div class="dvs-info-modal-title">
                <strong>Информация о среднесуточном пробеге</strong>
              </div>
              
            </div> -->
            <button @click="hideDistanceInfoModalFunc" class="dvs-info-modal-close">
              <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
            </button>
            <div class="dvs-info-modal-content">
              <div v-for="(item, itemIndex) in workChartsData[1]?.info?.items" :key="itemIndex" class="dvs-info-item">
                <div class="dvs-info-item-title">
                  {{ item.title }}
                  <span v-if="item.description">{{ item.description }}</span>
                </div>
                <ul v-if="item.consequences && item.consequences.length > 0" class="dvs-info-item-consequences">
                  <li v-for="(consequence, consIndex) in item.consequences" :key="consIndex">
                    {{ consequence }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Модальное окно с информацией о расходе топлива по парку -->
        <div 
          v-if="showFuelVolumeInfoModal" 
          class="dvs-info-modal-overlay" 
          :style="{
            top: infoModalConfig.fuelVolume.overlay.top,
            left: infoModalConfig.fuelVolume.overlay.left,
            right: infoModalConfig.fuelVolume.overlay.right,
            bottom: infoModalConfig.fuelVolume.overlay.bottom
          }"
          @click="hideFuelVolumeInfoModalFunc"
        >
          <div class="dvs-info-modal" :style="{ maxHeight: infoModalConfig.fuelVolume.modal.maxHeight }" @click.stop>
            <!-- <div class="dvs-info-modal-header">
              <div class="dvs-info-modal-title">
                <strong>Информация о расходе топлива по парку</strong>
              </div>
              <button @click="hideFuelVolumeInfoModalFunc" class="dvs-info-modal-close">
                <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
              </button>
            </div> -->
            <button @click="hideFuelVolumeInfoModalFunc" class="dvs-info-modal-close">
              <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
            </button>
            <div class="dvs-info-modal-content">
              <div v-for="(item, itemIndex) in workChartsData[2]?.info?.items" :key="itemIndex" class="dvs-info-item">
                <div class="dvs-info-item-title">
                  {{ item.title }}
                  <span v-if="item.description">{{ item.description }}</span>
                </div>
                <ul v-if="item.consequences && item.consequences.length > 0" class="dvs-info-item-consequences">
                  <li v-for="(consequence, consIndex) in item.consequences" :key="consIndex">
                    {{ consequence }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Модальное окно с информацией о среднем расходе топлива -->
        <div 
          v-if="showFuelConsumptionInfoModal" 
          class="dvs-info-modal-overlay" 
          :style="{
            top: infoModalConfig.fuelConsumption.overlay.top,
            left: infoModalConfig.fuelConsumption.overlay.left,
            right: infoModalConfig.fuelConsumption.overlay.right,
            bottom: infoModalConfig.fuelConsumption.overlay.bottom
          }"
          @click="hideFuelConsumptionInfoModalFunc"
        >
          <div class="dvs-info-modal" :style="{ maxHeight: infoModalConfig.fuelConsumption.modal.maxHeight }" @click.stop>
            <!-- <div class="dvs-info-modal-header">
              <div class="dvs-info-modal-title">
                <strong>Информация о среднем расходе топлива</strong>
              </div>
              
            </div> -->
            <button @click="hideFuelConsumptionInfoModalFunc" class="dvs-info-modal-close">
              <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
            </button>
            <div class="dvs-info-modal-content">
              <div v-for="(item, itemIndex) in workChartsData[3]?.info?.items" :key="itemIndex" class="dvs-info-item">
                <div class="dvs-info-item-title">
                  {{ item.title }}
                  <span v-if="item.description">{{ item.description }}</span>
                </div>
                <ul v-if="item.consequences && item.consequences.length > 0" class="dvs-info-item-consequences">
                  <li v-for="(consequence, consIndex) in item.consequences" :key="consIndex">
                    {{ consequence }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Модальное окно с информацией о времени работы ДВС -->
        <div 
          v-if="showEngineTimeInfoModal" 
          class="dvs-info-modal-overlay" 
          :style="{
            top: infoModalConfig.engineTime.overlay.top,
            left: infoModalConfig.engineTime.overlay.left,
            right: infoModalConfig.engineTime.overlay.right,
            bottom: infoModalConfig.engineTime.overlay.bottom
          }"
          @click="hideEngineTimeInfoModalFunc"
        >
          <div class="dvs-info-modal" :style="{ maxHeight: infoModalConfig.engineTime.modal.maxHeight }" @click.stop>
            <!-- <div class="dvs-info-modal-header">
              <div class="dvs-info-modal-title">
                <strong>Информация о времени работы ДВС</strong>
              </div>
              
            </div> -->
            <button @click="hideEngineTimeInfoModalFunc" class="dvs-info-modal-close">
              <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
            </button>
            <div class="dvs-info-modal-content">
              <div v-for="(item, itemIndex) in workChartsData[4]?.info?.items" :key="itemIndex" class="dvs-info-item">
                <div class="dvs-info-item-title">
                  {{ item.title }}
                  <span v-if="item.description">{{ item.description }}</span>
                </div>
                <ul v-if="item.consequences && item.consequences.length > 0" class="dvs-info-item-consequences">
                  <li v-for="(consequence, consIndex) in item.consequences" :key="consIndex">
                    {{ consequence }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Модальное окно с информацией об объеме сливов -->
        <div 
          v-if="showFuelOutInfoModal" 
          class="dvs-info-modal-overlay" 
          :style="{
            top: infoModalConfig.fuelOut.overlay.top,
            left: infoModalConfig.fuelOut.overlay.left,
            right: infoModalConfig.fuelOut.overlay.right,
            bottom: infoModalConfig.fuelOut.overlay.bottom
          }"
          @click="hideFuelOutInfoModalFunc"
        >
          <div class="dvs-info-modal" :style="{ maxHeight: infoModalConfig.fuelOut.modal.maxHeight }" @click.stop>
            <!-- <div class="dvs-info-modal-header">
              <div class="dvs-info-modal-title">
                <strong>Информация об объеме сливов</strong>
              </div>
              
            </div> -->
            <button @click="hideFuelOutInfoModalFunc" class="dvs-info-modal-close">
              <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
            </button>
            <div class="dvs-info-modal-content">
              <div v-for="(item, itemIndex) in workChartsData[5]?.info?.items" :key="itemIndex" class="dvs-info-item">
                <div class="dvs-info-item-title">
                  {{ item.title }}
                  <span v-if="item.description">{{ item.description }}</span>
                </div>
                <ul v-if="item.consequences && item.consequences.length > 0" class="dvs-info-item-consequences">
                  <li v-for="(consequence, consIndex) in item.consequences" :key="consIndex">
                    {{ consequence }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="charts-container">
        <!-- Заголовок для Excel: Работа ТС -->
        <h6 class="footer-desc text-center font-weight-bold hidden" style="font-size: 20px;">
          Работа ТС
        </h6>
        <span class="sub-container rabts" style="width: 100%;">
          <p class="sub-container-title" style="display: flex; align-items: center; margin: 0 0 9px 0 !important;"><strong>Работа ТС</strong></p>
          <div style="width: 1887px;display: flex; flex-wrap: wrap;justify-content: space-between;">
            <span v-for="(chartData, index) in workChartsData" :key="'work-' + index">
              <div class="bg-white rounded-xl chart-container-border" :style="index > 0 ? 'margin-left: -10px;' : ''">
                <img alt="img" src="../../../../public/images/vehicle-dashboard/fix-chart-bottom-right.png" class="fix_rabts_border-bottom-right"/>
                <img alt="img" src="../../../../public/images/vehicle-dashboard/fix-chart-bottom-left.png" class="fix_rabts_border-bottom-left"/>
                <div class="chart_header flex justify-between items-start">
                  <div class="flex items-center gap-2" style="margin-left: 20px;font-weight: 400;font-size: 12px;">
                    <h2 class="text-xl font-semibold text-gray-800" style="font-size: 12px;font-weight: 400; margin-top: 10px;">{{ chartData.title }}</h2>
                    <div class="group relative flex justify-center" style="margin-left: 14px;">
                      <div class="relative flex justify-center">
                        <span
                          v-if="index === 0"
                          @click="showOnLineInfoModalFunc"
                          class="cursor-help text-gray-400 hover:text-gray-600"
                        >
                          <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                        </span>
                        <span
                          v-else-if="index === 1"
                          @click="showDistanceInfoModalFunc"
                          class="cursor-help text-gray-400 hover:text-gray-600"
                        >
                          <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                        </span>
                        <span
                          v-else-if="index === 2"
                          @click="showFuelVolumeInfoModalFunc"
                          class="cursor-help text-gray-400 hover:text-gray-600"
                        >
                          <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                        </span>
                        <span
                          v-else-if="index === 3"
                          @click="showFuelConsumptionInfoModalFunc"
                          class="cursor-help text-gray-400 hover:text-gray-600"
                        >
                          <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                        </span>
                        <span
                          v-else-if="index === 4"
                          @click="showEngineTimeInfoModalFunc"
                          class="cursor-help text-gray-400 hover:text-gray-600"
                        >
                          <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                        </span>
                        <span
                          v-else-if="index === 5"
                          @click="showFuelOutInfoModalFunc"
                          class="cursor-help text-gray-400 hover:text-gray-600"
                        >
                          <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                        </span>
                        <span
                          v-else
                          class="cursor-help text-gray-400 hover:text-gray-600"
                        >
                          <img src="../../../../public/images/icon_tooltip.svg" style="width: 16px; height: 16px;" alt="icon">
                        </span>
                        <div v-if="index !== 0 && index !== 1 && index !== 2 && index !== 3 && index !== 4 && index !== 5" class="absolute bottom-full left-1-2 transform hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2 whitespace-nowrap z-10">
                          {{ chartData.tooltipText }}
                          <div class="absolute top-full left-1-2 transform w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-800"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="icons">
                    <button @click="showViolationPanelFunc(index + 8)" class="text-gray-600 hover:text-gray-900 transition-colors p-1 rounded hover:bg-gray-100">
                      <img src="../../../../public/images/icon_document.svg" style="width: 16px; height: 16px;" alt="icon">
                    </button>
                    <button v-if="index === workChartsData.length - 1" @click="showMapForViolationType(4)" class="text-gray-600 hover:text-gray-900 transition-colors p-1 rounded hover:bg-gray-100">
                      <img src="../../../../public/images/icon_map.svg" style="width: 16px; height: 16px;" alt="icon">
                    </button>
                  </div>
                </div>
                 <div class="chartt relative">
                   <span :ref="el => setWorkChartRef(el, index)" class="chart-wrapper chartContainer" :class="{'mr-5': index === workChartsData.length - 1}" data-excelcolspan="2"></span>
                 </div>
              </div>
            </span>
          </div>
        </span>
        <div class="heatmap-panel" :class="{ 'heatmap-panel--expanded': isHeatmapExpanded }">
          <span class=""><text style="font-size: 12px;margin-left: 31px;">События на карте</text>
            <UiSelect
              class="s2_footer-desc_group-val"
              style="display: inline-block;position: relative;top: 6px;min-height: 12px;"
              v-model:select="selectedTableType"
              :items="selectedTableTypeOptions"
              @update:select="onGrouping3Change"
            />
          </span>
          <div id="vehicle-heatmap" class="leaflet-map" :class="{ 'map-blur': loading }"></div>
          <div v-if="loading" class="preloader">
            <Preloader />
            <div v-if="progressTotal > 0" class="progress-text">
              {{ progressLoaded >= progressTotal - 1 ? 'Построение карты...' : `Получено ${progressLoaded} из ${progressTotal} объектов` }}
            </div>
          </div>

          <!-- панель поверх .heatmap-panel -->
          <div v-if="showViolationPanel" id="violation-panel-overlay" class="violation-panel-overlay">
            <!-- header -->
            <div class="violation-panel-header">
              <div class="header-left-buttons">
                <div id="my-info">
                  <button
                    class="not-print float-left"
                    style="position: absolute; top: 3px;"
                    @click="
                        (e) =>
                          html_to_excel_helper.export(
                          e.target,
                          'violation-panel-overlay',
                          'Дашборд по эксплуатации тс (таблица)',
                          'landscape',
                                                  )
                    "
                  >
                    Экспорт&nbsp;в&nbsp;EXCEL
                  </button>
                </div>
              </div>
              <div class="header-center-title">
                {{ getTableTitle() }}
              </div>
              <button @click="toggleHeatmapExpand" class="heatmap-expand-btn" :title="isHeatmapExpanded ? 'Свернуть' : 'Расширить'">
                <img src="../../../../public/images/buttons/expand/expand.svg" style="width: 16px; height: 16px;" alt="expand">
              </button>
              <div class="header-right-close">
                <button @click="hideViolationPanel" class="close-panel-btn">
                   <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="icon">
                </button>
              </div>
            </div>

            <h6 class="footer-desc text-center font-weight-bold hidden">
              Дашборд по эксплуатации тс (таблица)
            </h6>

            <h6 class="footer-desc text-center font-weight-bold hidden">
              За период с {{ formatTimeHelper2(dateRange[0], false) }} по {{ formatTimeHelper2(dateRange[1], true) }}
            </h6>

            <p class="text-center excel-bottom-indent hidden">
              Отчет сформирован {{ formatTimeHelper2(new Date()) }}
            </p>

            <h6 class="footer-desc text-center font-weight-bold hidden">
              {{ getTableTitle() }}
            </h6>

            <div class="violation-table-container">
              <!-- Основная таблица(таблица 1 уровня) -->
              <table class="violation-table">
                <thead>
                  <tr>
                    <th data-minwidth="10" data-font-size="18" style="width: 74px;letter-spacing: 1.8px;">№ п/п</th>
                    <th data-minwidth="31" data-font-size="18" style="width: 123px;padding-left: 31px;">
                      <div style="display: flex; align-items: center; gap: 4px;">
                        <button
                          v-if="!showVinColumn"
                          @click="toggleVinColumn"
                          class="not-excel"
                          style="background: none; cursor: pointer; font-size: 10px; opacity: 50%;"
                        >
                          VIN
                        </button>
                        <button
                          v-if="showVinColumn"
                          @click="toggleVinColumn"
                          class="not-excel"
                          style="background: none; cursor: pointer; font-size: 10px; opacity: 50%;"
                        >
                          г.н.
                        </button>
                        <span>
                          {{ showVinColumn ? 'VIN номер' : 'Гос. номер' }}
                        </span>
                      </div>
                    </th>
                    <th data-minwidth="16" data-font-size="18" style="width: 63px;">Тип КПП</th>
                    <th
                      v-for="(date, dateIndex) in violationDates"
                      :key="date"
                      data-minwidth="18"
                      data-font-size="18"
                      style="position: relative;"
                    >
                      <div style="display: flex; align-items: center; gap: 4px;padding-left: 38px;">
                        <div style="display: flex; flex-direction: row; gap: 2px;">
                          <img
                            @click="sortTableByDate(dateIndex, 'desc')"
                            src="../../../../public/images/arrow_up.svg"
                            style="width: 10px; height: 25px; cursor: pointer; opacity: 0.3;"
                            :style="sortColumn === `date_${dateIndex}_desc` ? { opacity: 1 } : {}"
                            alt="↑"
                          >
                          <img
                            @click="sortTableByDate(dateIndex, 'asc')"
                            src="../../../../public/images/arrow_up.svg"
                            style="width: 10px; height: 25px; cursor: pointer; opacity: 0.3; transform: rotate(180deg);"
                            :style="sortColumn === `date_${dateIndex}` ? { opacity: 1 } : {}"
                            alt="↓"
                          >
                        </div>
                        <img
                          v-if="sortColumn === `date_${dateIndex}` || sortColumn === `date_${dateIndex}_desc`"
                          src="../../../../public/images/sort_ascending.svg"
                          style="width: 7.87px; height: 25px;"
                          :style="sortColumn === `date_${dateIndex}_desc` ? { transform: 'scaleX(-1) rotate(180deg)' } : {}"
                          alt="sort"
                        >
                        <span :style="sortColumn === `date_${dateIndex}` || sortColumn === `date_${dateIndex}_desc` ? { paddingLeft: '19.13px'} : {paddingLeft: '31px'}">{{ formatDateByGroupingType(date) }}</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, index) in sortedTableData" :key="item.id">
                    <tr>
                      <td data-font-size="18" data-formatnum="12">{{ index + 1 }}</td>
                      <td
                        data-font-size="18"
                        :style="isDistanceMode || isOnLineMode ? {} : { cursor: 'pointer' }"
                        @click="!isDistanceMode && !isOnLineMode && showDetailedTableFunc(item)"
                      >
                        {{ showVinColumn ? (item.data.objConf?.vin || 'Н/Д') : (item.data.objConf?.state_number || 'Н/Д') }}
                      </td>
                      <td data-font-size="18">{{ item.data.objConf?.gearbox_name?.includes('АКПП') ? 'АКПП' : 'МКПП' }}</td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        :class="getViolationClass(getViolationValue(item, date), getViolationPer100km(item, date))"
                        :style="getViolationCellStyle(getViolationValue(item, date), getViolationPer100km(item, date))"
                        data-font-size="18"
                        :data-formatnum="getDataFormatNum()"
                        data-excelalignh="right"
                        style="text-align: right;"
                      >
                        <span v-if="groupingType2 === 'day' && isTrackRequestAllowed" class="track-request-dots not-print" @click.stop="openHeatmapPopup(currentViolationType, item, date)">...</span>
                        <span :class="groupingType2 === 'day' ? 'violation-value' : '' ">{{ isMalfunctionMode || isEngineTimeMode ? getViolationValue(item, date) : formatNumberWithSpaces(getViolationValue(item, date)) }}</span>
                      </td>
                    </tr>
                    <tr v-if="showMileageRow && !isMalfunctionMode && !isDistanceMode && !isFuelMode && !isFuel100Mode && !isEngineTimeMode && !isFuelOutMode && !isOnLineMode" :key="`${item.id}-mileage`" class="mileage-row">
                      <td data-font-size="12" style="font-size: 12px">пробег:</td>
                      <td data-font-size="12" style="font-size: 12px">{{ showVinColumn ? (item.data.objConf?.vin || 'Н/Д') : (item.data.objConf?.state_number || 'Н/Д') }}</td>
                      <td data-font-size="12" style="font-size: 12px">{{ item.data.objConf?.gearbox_name?.includes('АКПП') ? 'АКПП' : 'МКПП' }}</td>
                      <td data-font-size="12" data-formatnum="12" style="font-size: 12px" v-for="date in violationDates" :key="date">
                        <span v-if="groupingType2 === 'day' && isTrackRequestAllowed" class="track-request-dots not-print" style="font-size: 12px;" @click.stop="openHeatmapPopup(currentViolationType, item, date)">...</span>{{ getMileageValue(item, date) }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Детальная таблица для bezop_cnt (отдельная панель, таблица 2 уровня) -->
          <div id="detailed-table-panel" v-if="showDetailedTable && !isDistanceMode && !isFuelOutMode && !isOnLineMode && currentViolationType === 'bezop_cnt'" class="detailed-table-overlay detailed-table-overlay-bezop">
            <div class="detailed-table-panel detailed-table-panel-bezop">
              <div class="detailed-table-content" style="position: relative;">
                <div id="my-info" style="left: 0; top: 0; position: sticky; z-index: 2;">
                  <button
                    class="not-print float-left"
                    style="z-index: 1; position: absolute;"
                    @click="
                        (e) =>
                          html_to_excel_helper.export(
                          e.target,
                          'detailed-table-panel',
                          'Дашборд по эксплуатации тс (детальная таблица)',
                          'landscape',
                        )
                    "
                  >
                    Экспорт&nbsp;в&nbsp;EXCEL
                  </button>
                </div>

                <h6 class="footer-desc text-center font-weight-bold hidden">
                  Дашборд по эксплуатации тс (таблица)
                </h6>

                <h6 class="footer-desc text-center font-weight-bold hidden">
                  За период с {{ formatTimeHelper2(dateRange[0], false) }} по {{ formatTimeHelper2(dateRange[1], true) }}
                </h6>

                <p class="text-center excel-bottom-indent hidden">
                  Отчет сформирован {{ formatTimeHelper2(new Date()) }}
                </p>

                <!-- <h6 class="footer-desc text-center font-weight-bold hidden">
                  {{ getDetailedTableTitle2() }}
                </h6> -->

                <div class="not-print" style="position: absolute;left: 46%;">
                  <span style="font-weight: 700;font-size: 13px;">
                    {{ getDetailedTableTitle2() }}
                  </span>
                </div>
                <button
                  @click="hideDetailedTable"
                  class="detailed-table-close 1"
                  style="top:0;padding: 0;margin-right: 1px;z-index: 2;"
                >
                  <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
                </button>

                <table class="violation-table detailed-table-inner" style="position: relative;">
                  <thead style="position: sticky; top: 0;">
                    <!-- Первый уровень заголовка -->
                    <tr>
                      <th
                        colspan="2"
                        data-minwidth="44"
                        data-font-size="14"
                        style="text-align: right; border: none; font-weight: 700; font-size: 12px; padding-right: 37px;"
                      > Гос. номер
                        {{ selectedVehicle?.data.objConf?.state_number || 'Н/Д'}}
                        {{ selectedVehicle?.data.objConf?.gearbox_name?.includes('АКПП') ? 'АКПП' : 'МКПП' }}
                      </th>
                      <th
                        :colspan="violationDates.length"
                        style="text-align: left; padding-left: 10px;border: none; padding-top: 0; padding-bottom: 0;"
                        data-font-size="18"
                      >
                        <div style="">
                          <span style="font-weight: 700;font-size: 12px;margin-left: 135px;">VIN </span>
                          <span style="font-weight: 700;font-size: 12px;">
                            {{ (selectedVehicle?.data.objConf?.vin || 'Н/Д') }}
                          </span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Секция ДВС -->
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-bottom: 2px solid black; border-right: 2px solid #000; font-weight: 700; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        ДВС
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-minwidth="18"
                        style="text-align: center; border-bottom: 2px solid black; font-weight: 700; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatDateByGroupingType(date) }}
                      </td>
                    </tr>
                    <!-- Нарушения ДВС -->
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        ДВС >2400 об/мин.
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_excessrpm')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        {{'При движении ДВС <550 об/мин.'}}
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_rpmspdless440cntg')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        {{'ДВС под нагрузкой, заглох при движении'}}
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_enginestalledspdcntg')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        {{'При переключении МКПП ДВС <800 об/мин.'}}
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_gearshiftrpm')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        ДВС >1900 об/мин. без применения моторного тормоза
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_ineffectiverpmwithnomotobrake')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Повышенные обороты ДВС при начале движения: МКПП>1200 об/мин, АКПП>1400 об/мин.
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_rpmstartspdmore1200cnt')) }}
                      </td>
                    </tr>
                    <!-- Итого, количество нарушений ДВС -->
                    <tr style="font-weight: bold;">
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 700; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Итого, количество нарушений ДВС
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        :class="getTotalViolationsClass(getBezopTotal(selectedVehicle, date, 'dvs'), getBezopPer100km(selectedVehicle, date, 'dvs'))"
                        :style="getTotalViolationsStyle(getBezopTotal(selectedVehicle, date, 'dvs'), getBezopPer100km(selectedVehicle, date, 'dvs'))"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 700; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopTotal(selectedVehicle, date, 'dvs')) }}
                      </td>
                    </tr>
                    <!-- Нарушений на 100км., ДВС -->
                    <tr style="font-weight: bold;">
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Нарушений на 100км., ДВС
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        :class="getViolationsPer100kmClass(getBezopPer100km(selectedVehicle, date, 'dvs'))"
                        :style="getViolationsPer100kmStyle(getBezopPer100km(selectedVehicle, date, 'dvs'))"
                        data-font-size="14"
                        data-formatnum="5"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ getBezopPer100km(selectedVehicle, date, 'dvs') }}
                      </td>
                    </tr>

                    <!-- Секция Трансмиссия -->
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-bottom: 2px solid black; border-right: 2px solid #000; font-weight: 700; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Трансмиссия
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-minwidth="18"
                        style="text-align: center; font-weight: 700; border-bottom: 2px solid black; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatDateByGroupingType(date) }}
                      </td>
                    </tr>
                    <!-- Нарушения Трансмиссии -->
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Начало движения, лишняя работа сцепления
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_clutchslipstart')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Начало движения, пережег сцепл., темп.дисков>100 градусов
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_slipping')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Начало движения, правильный выбор передачи в КПП
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_rightgearforstart')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Начало движения, переключение КПП с переднего на задний ход при >0 км/ч.
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_swithgearboxrewersspdcnt')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Вкл./выкл блок мостов/колес при >7км/ч. или газ >0
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_switchlock')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Вкл./выкл пониженной РКП при>0 км/ч. или газ >0
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_switchlower')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Движение с вкл. межколесной блокировкой при >10 км/ч.
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_movelockcrosswheel')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Работа дифференциалов мостов/колес при 0 км/ч.
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_difftransmoverload')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        МКПП: движение с нажатой педалью сцепления
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_moveclutchopen_violations')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        МКПП: движение накатом на нейтральной передаче КПП
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_rollforwardneutral_violations')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Температура масла ретардера 130 и более градусов
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_retarderhitmpr')) }}
                      </td>
                    </tr>
                    <!-- Итого, количество нарушений Трансмиссия -->
                    <tr style="font-weight: bold;">
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 700; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Итого, количество нарушений Трансмиссия
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        :class="getTotalViolationsClass(getBezopTotal(selectedVehicle, date, 'transmission'), getBezopPer100km(selectedVehicle, date, 'transmission'))"
                        :style="getTotalViolationsStyle(getBezopTotal(selectedVehicle, date, 'transmission'), getBezopPer100km(selectedVehicle, date, 'transmission'))"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 700; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopTotal(selectedVehicle, date, 'transmission')) }}
                      </td>
                    </tr>
                    <!-- Нарушений на 100км., Трансмиссия -->
                    <tr style="font-weight: bold;">
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Нарушений на 100км., Трансмиссия
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        :class="getViolationsPer100kmClass(getBezopPer100km(selectedVehicle, date, 'transmission'))"
                        :style="getViolationsPer100kmStyle(getBezopPer100km(selectedVehicle, date, 'transmission'))"
                        data-font-size="14"
                        data-formatnum="5"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ getBezopPer100km(selectedVehicle, date, 'transmission') }}
                      </td>
                    </tr>

                    <!-- Секция Работа КОМ самосвала -->
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-bottom: 2px solid black; border-right: 2px solid #000; font-weight: 700; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Работа КОМ самосвала
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-minwidth="18"
                        style="text-align: center; font-weight: 700; border-bottom: 2px solid black; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatDateByGroupingType(date) }}
                      </td>
                    </tr>
                    <!-- Нарушения КОМ -->
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Крен при работе COM > 5 градусов
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_ptokrenunload')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Движение с включенным COM
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_ptospddistanceg')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Движение с поднятым кузовом
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_backraisedspddistance')) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        {{'Обороты ДВС >1000 или < 800 при работе COM'}}
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopValue(selectedVehicle, date, 't1_ptorpmviolation_violations')) }}
                      </td>
                    </tr>
                    <!-- Итого, количество нарушений КОМ -->
                    <tr style="font-weight: bold;">
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 700; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Итого, количество нарушений КОМ
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        :class="getTotalViolationsClass(getBezopTotal(selectedVehicle, date, 'kom'), getBezopPer100km(selectedVehicle, date, 'kom'))"
                        :style="getTotalViolationsStyle(getBezopTotal(selectedVehicle, date, 'kom'), getBezopPer100km(selectedVehicle, date, 'kom'))"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 700; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopTotal(selectedVehicle, date, 'kom')) }}
                      </td>
                    </tr>
                    <!-- Нарушений на 100км., КОМ -->
                    <tr style="font-weight: bold;">
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Нарушений на 100км., КОМ
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        :class="getViolationsPer100kmClass(getBezopPer100km(selectedVehicle, date, 'kom'))"
                        :style="getViolationsPer100kmStyle(getBezopPer100km(selectedVehicle, date, 'kom'))"
                        data-font-size="14"
                        data-formatnum="5"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ getBezopPer100km(selectedVehicle, date, 'kom') }}
                      </td>
                    </tr>

                    <!-- Итого секция -->
                    <!-- Итого, общее число нарушений -->
                    <tr style="font-weight: bold;">
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 700; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Итого, общее число нарушений
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        :class="getTotalViolationsClass(getBezopTotal(selectedVehicle, date, 'all'), getBezopPer100km(selectedVehicle, date, 'all'))"
                        :style="getTotalViolationsStyle(getBezopTotal(selectedVehicle, date, 'all'), getBezopPer100km(selectedVehicle, date, 'all'))"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getBezopTotal(selectedVehicle, date, 'all')) }}
                      </td>
                    </tr>
                    <!-- Пробег, км -->
                    <tr>
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Пробег, км
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        data-font-size="14"
                        data-formatnum="12"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ formatNumberWithSpaces(getMileageValue(selectedVehicle, date)) }}
                      </td>
                    </tr>
                    <!-- Нарушений на 100 км. пробега, общее -->
                    <tr style="font-weight: bold;">
                      <td
                        colspan="2"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                        data-font-size="14"
                      >
                        Нарушений на 100 км. пробега, общее
                      </td>
                      <td
                        v-for="date in violationDates"
                        :key="date"
                        :class="getViolationsPer100kmClass(getBezopPer100km(selectedVehicle, date, 'all'))"
                        :style="getViolationsPer100kmStyle(getBezopPer100km(selectedVehicle, date, 'all'))"
                        data-font-size="14"
                        data-formatnum="5"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        {{ getBezopPer100km(selectedVehicle, date, 'all') }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Детальная таблица для остальных типов (кроме bezop_cnt, таблица 2 уровня) -->
          <div id="detailed-table-panel" v-if="showDetailedTable && !isDistanceMode && !isFuelOutMode && !isOnLineMode && currentViolationType !== 'bezop_cnt'" class="detailed-table-overlay" :class="currentViolationType === 'transmission_cnt' ? 'detailed-table-overlay-transmission' : ''">
            <div class="detailed-table-panel" :class="isMalfunctionMode ? 'detailed-table-panel-malfunction' : (currentViolationType === 'transmission_cnt' ? 'detailed-table-panel-transmission' : '')">
              <div class="detailed-table-content" style="position: relative;">
                <div id="my-info" style="left: 0; top: 0; position: sticky; z-index: 2;">
                  <button
                    class="not-print float-left"
                    style="z-index: 1; position: absolute;"
                    @click="
                        (e) =>
                          html_to_excel_helper.export(
                          e.target,
                          'detailed-table-panel',
                          'Дашборд по эксплуатации тс (детальная таблица)',
                          'landscape',
                        )
                    "
                  >
                    Экспорт&nbsp;в&nbsp;EXCEL
                  </button>
                </div>

                <h6 class="footer-desc text-center font-weight-bold hidden">
                  Дашборд по эксплуатации тс (детальная таблица)
                </h6>

                <h6 class="footer-desc text-center font-weight-bold hidden">
                  За период с {{ formatTimeHelper2(dateRange[0], false) }} по {{ formatTimeHelper2(dateRange[1], true) }}
                </h6>

                <p class="text-center excel-bottom-indent hidden">
                  Отчет сформирован {{ formatTimeHelper2(new Date()) }}
                </p>

                <!-- <h6 class="footer-desc text-center font-weight-bold hidden">
                  {{ getDetailedTableTitle2() }}
                </h6> -->

                <table class="violation-table detailed-table-inner">
                  <thead style="position: sticky; top: 0;">
                    <!-- Первый уровень заголовка -->
                    <tr>
                      <th
                        :colspan="isMalfunctionMode ? 3 : 2"
                        style="text-align: left; padding-left: 10px;border: none; padding-top: 0; padding-bottom: 0;"
                        data-font-size="18"
                        :data-minwidth="isMalfunctionMode ? 15 : 24"
                        :data-minheight="isMalfunctionMode ? 41 : 24"
                      >
                        <div style="">
                          <span style="font-weight: 700;font-size: 9px;margin-left: 135px;">VIN </span>
                          <span style="font-weight: 700;font-size: 9px;">
                            {{ (selectedVehicle?.data.objConf?.vin || 'Н/Д') }}
                          </span>
                          <span v-if="isMalfunctionMode" style="font-size: 12px;">
                            Гос. номер
                            {{ selectedVehicle?.data.objConf?.state_number || 'Н/Д'}}
                            {{ selectedVehicle?.data.objConf?.gearbox_name?.includes('АКПП') ? 'АКПП' : 'МКПП' }}
                          </span>
                        </div>
                      </th>
                      <th
                        :colspan="violationDates.length"
                        style="text-align: left; padding-left: 10px; border: none; padding-top: 0; padding-bottom: 0; padding-right: 0;"
                        data-font-size="18"
                      >
                        <div style="display: inline; flex-direction: column; gap: 4px;">
                          <span style="font-weight: 700;font-size: 13px;">
                            {{ getDetailedTableTitle2() }}
                          </span>
                        </div>

                        <button
                          @click="hideDetailedTable"
                          class="detailed-table-close 2"
                          style="padding: 0;margin-right: 1px;"
                        >
                          <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
                        </button>
                      </th>
                    </tr>
                    <!-- Второй уровень заголовка -->
                    <tr>
                      <th
                        v-if="!isMalfunctionMode"
                        colspan="2"
                        data-minwidth="40"
                        data-font-size="14"
                        style="text-align: left; border: none; font-weight: 700; font-size: 12px;"
                      > Гос. номер
                        {{ selectedVehicle?.data.objConf?.state_number || 'Н/Д'}}
                        {{ selectedVehicle?.data.objConf?.gearbox_name?.includes('АКПП') ? 'АКПП' : 'МКПП' }}
                      </th>
                      <th
                        v-if="isMalfunctionMode"
                        data-minwidth="20"
                        data-font-size="14"
                        style="text-align: left; border: none; font-weight: 700; font-size: 12px;"
                      >
                        Адрес в сети CAN
                      </th>
                      <th
                        v-if="isMalfunctionMode"
                        data-minwidth="12"
                        data-font-size="14"
                        style="text-align: center; border: none; font-weight: 700; font-size: 12px;"
                      >
                        SPN
                      </th>
                      <th
                        v-if="isMalfunctionMode"
                        data-minwidth="20"
                        data-font-size="14"
                        style="text-align: left; border: none; font-weight: 700; font-size: 12px;"
                      >
                        Описание SPN
                      </th>
                      <th
                        v-for="date in violationDates"
                        :key="date"
                        data-minwidth="15"
                        data-font-size="14"
                        style="text-align: center;border: none; font-weight: 700; font-size: 12px; padding: 0;"
                      >
                        {{ formatDateByGroupingType(date) }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Строки с нарушениями (для обычного режима) -->
                    <template v-if="!isFuelMode && !isFuel100Mode && !isEngineTimeMode && !isMalfunctionMode">
                      <tr
                        v-for="(violation, violationIndex) in violationTypes[currentViolationType]?.columns?.filter(col => col.field !== currentViolationType) || []"
                        :key="`violation-${violationIndex}`"
                      >
                        <td
                          colspan="2"
                          style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                          :style="violationIndex == 0 ? { borderTop: 'none'} : {}"
                          data-font-size="14"
                        >
                          {{ violation.label }}
                        </td>
                        <td
                          v-for="date in violationDates"
                          :key="date"
                          data-font-size="14"
                          data-formatnum="12"
                          style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                          :style="violationIndex == 0 ? { borderTop: 'none'} : {}"
                        >
                          {{ formatNumberWithSpaces(getDetailedFieldValue(selectedVehicle, date, violation.field)) }}
                        </td>
                      </tr>

                      <!-- Итого, количество нарушений -->
                      <tr style="font-weight: bold;">
                        <td
                          colspan="2"
                          style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 700; font-size: 12px; height: 30px; padding-top: 5px; padding-bottom: 5px;"
                          data-font-size="14"
                        >
                          Итого, количество нарушений
                        </td>
                        <td
                          v-for="date in violationDates"
                          :key="date"
                          :class="getTotalViolationsClass(getTotalViolations(selectedVehicle, date), getViolationsPer100km(selectedVehicle, date))"
                          :style="getTotalViolationsStyle(getTotalViolations(selectedVehicle, date), getViolationsPer100km(selectedVehicle, date))"
                          style="text-align: center; font-weight: 700; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                          data-font-size="14"
                          data-formatnum="5"
                        >
                          {{ formatNumberWithSpaces(getTotalViolations(selectedVehicle, date)) }}
                        </td>
                      </tr>

                      <!-- Пробег, км. -->
                      <tr>
                        <td
                          colspan="2"
                          style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; height: 25px; padding-top: 5px; padding-bottom: 5px;"
                          data-font-size="14"
                        >
                          Пробег, км.
                        </td>
                        <td
                          v-for="date in violationDates"
                          :key="date"
                          style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                          data-font-size="14"
                          data-formatnum="12"
                        >
                          {{ formatNumberWithSpaces(getMileageValue(selectedVehicle, date)) }}
                        </td>
                      </tr>

                      <!-- Нарушения на 100 км. пробега -->
                      <tr style="font-weight: bold;">
                        <td
                          colspan="2"
                          style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; height: 25px; padding-top: 5px; padding-bottom: 5px;"
                          data-font-size="14"
                        >
                          Нарушений на 100 км. пробега
                        </td>
                        <td
                          v-for="date in violationDates"
                          :key="date"
                          :class="getViolationsPer100kmClass(getViolationsPer100km(selectedVehicle, date))"
                          :style="getViolationsPer100kmStyle(getViolationsPer100km(selectedVehicle, date))"
                          style="text-align: center; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                          data-font-size="14"
                          data-formatnum="7"
                        >
                          {{ getViolationsPer100km(selectedVehicle, date) }}
                        </td>
                      </tr>
                    </template>

                    <!-- Строки для режима расхода топлива (isFuelMode и isFuel100Mode) -->
                    <template v-else-if="isFuelMode || isFuel100Mode">
                      <tr
                        v-for="(column, columnIndex) in fuelDetailedColumns"
                        :key="`fuel-${columnIndex}`"
                      >
                        <td
                          colspan="2"
                          style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                          :style="columnIndex == 0 ? { borderTop: 'none'} : {}"
                          data-font-size="14"
                        >
                          {{ column.label }}
                        </td>
                        <td
                          v-for="date in violationDates"
                          :key="date"
                          data-font-size="14"
                          :data-formatnum="column.dataFormatNum"
                          style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                          :style="columnIndex == 0 ? { borderTop: 'none'} : {}"
                        >
                          {{ column.field === 'sum_distance' ? formatNumberWithSpaces(getFuelDetailedFieldValue(selectedVehicle, date, column.field, column.isCalculated, column.toFixed)) : getFuelDetailedFieldValue(selectedVehicle, date, column.field, column.isCalculated, column.toFixed) }}
                        </td>
                      </tr>
                    </template>

                    <!-- Строки для режима времени работы ДВС (isEngineTimeMode) -->
                    <template v-else-if="isEngineTimeMode">
                      <tr
                        v-for="(column, columnIndex) in engineTimeDetailedColumns"
                        :key="`engine-${columnIndex}`"
                      >
                        <td
                          colspan="2"
                          style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                          :style="columnIndex == 0 ? { borderTop: 'none'} : {}"
                          data-font-size="14"
                        >
                          {{ column.label }}
                        </td>
                        <td
                          v-for="date in violationDates"
                          :key="date"
                          data-font-size="14"
                          :data-formatnum="column.dataFormatNum"
                          data-excelalignh="right"
                          style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                          :style="columnIndex == 0 ? { borderTop: 'none'} : {}"
                        >
                          {{ column.field === 'sum_distance' ? formatNumberWithSpaces(getEngineTimeDetailedFieldValue(selectedVehicle, date, column.field, column.isCalculated, column.toFixed)) : getEngineTimeDetailedFieldValue(selectedVehicle, date, column.field, column.isCalculated, column.toFixed) }}
                        </td>
                      </tr>
                    </template>

                    <!-- Строки для режима неисправностей ТС (isMalfunctionMode) -->
                    <template v-else-if="isMalfunctionMode">
                      <!-- Строки с уникальными метками неисправностей -->
                      <tr
                        v-for="(label, labelIndex) in malfunctionLabels"
                        :key="`label-${labelIndex}`"
                      >
                        <td
                          style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                          :style="labelIndex == 0 ? { borderTop: 'none'} : {}"
                          data-font-size="14"
                        >
                          {{ label.addr }};{{ label.addr_description }}
                        </td>
                        <td
                          style="text-align: center; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                          :style="labelIndex == 0 ? { borderTop: 'none'} : {}"
                          data-font-size="14"
                        >
                          {{ label.spn }}
                        </td>
                        <td
                          style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                          :style="labelIndex == 0 ? { borderTop: 'none'} : {}"
                          data-font-size="14"
                        >
                          {{ label.spn_description }}
                        </td>
                        <td
                          v-for="date in violationDates"
                          :key="date"
                          data-font-size="14"
                          data-formatnum="0"
                          data-excelalignh="right"
                          style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                          :style="labelIndex == 0 ? { borderTop: 'none'} : {}"
                        >
                          {{ getMalfunctionLabelValue(selectedVehicle, date, label) }}
                        </td>
                      </tr>
                      <!-- Итоговые строки с агрегированными данными -->
                      <tr
                        v-for="(column, columnIndex) in malfunctionDetailedColumns"
                        :key="`malfunction-${columnIndex}`"
                        style="font-weight: bold;"
                      >
                        <td
                          colspan="3"
                          style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 700; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                          :style="columnIndex == 0 ? { borderTop: 'none'} : {}"
                          data-font-size="14"
                        >
                          {{ column.label }}
                        </td>
                        <td
                          v-for="date in violationDates"
                          :key="date"
                          data-font-size="14"
                          data-formatnum="0"
                          data-excelalignh="right"
                          style="text-align: center; font-weight: 700; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                          :style="columnIndex == 0 ? { borderTop: 'none'} : {}"
                        >
                          {{ column.field === 'sum_distance' ? formatNumberWithSpaces(getMalfunctionDetailedFieldValue(selectedVehicle, date, column.field, column.isCalculated, column.toFixed)) : getMalfunctionDetailedFieldValue(selectedVehicle, date, column.field, column.isCalculated, column.toFixed) }}
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Таблица 2 уровня для "Объем сливов, литров" (отдельная панель) -->
          <div id="fuel-out-detailed-panel" v-if="isFuelOutMode && showDetailedTable" class="detailed-table-overlay fuel-out-detailed-overlay">
            <div class="detailed-table-panel fuel-out-detailed-panel" :class="{ 'map-blur': loading }">
              <div id="my-info" style="position: absolute;z-index: 2;left: 0; top: 0;">
                <button
                  class="not-print float-left"
                  @click="
                      (e) =>
                        html_to_excel_helper.export(
                        e.target,
                        'fuel-out-detailed-panel',
                        'Дашборд по эксплуатации тс (детальная таблица)',
                        'landscape',
                      )
                  "
                >
                  Экспорт&nbsp;в&nbsp;EXCEL
                </button>
              </div>

              <h6 class="footer-desc text-center font-weight-bold hidden">
                Дашборд по эксплуатации тс (детальная таблица)
              </h6>

              <h6 class="footer-desc text-center font-weight-bold hidden">
                За период с {{ formatTimeHelper2(dateRange[0], false) }} по {{ formatTimeHelper2(dateRange[1], true) }}
              </h6>

              <p class="text-center excel-bottom-indent hidden">
                Отчет сформирован {{ formatTimeHelper2(new Date()) }}
              </p>


              <div class="not-print" style="padding-left: 160px; border: none; padding-top: 0px; padding-bottom: 0px; display: inline-block; position: absolute;">
                <span style="font-weight: 700;font-size: 9px;margin-left: 135px;">VIN </span>
                <span style="font-weight: 700;font-size: 9px;">
                  {{ (selectedVehicle?.data.objConf?.vin || 'Н/Д') }}
                </span>
              </div>

              <div class="not-print" style="text-align: center;">
                <span style="font-weight: 700;font-size: 13px;">
                  Сливы топлива зафиксированные по датчику уровня топлива
                </span>
              </div>

              <button
                @click="hideDetailedTable"
                class="detailed-table-close 3"
                style="position: absolute; right: 0;"
              >
                <img src="../../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
              </button>

              <div class="detailed-table-content">
                <table class="violation-table detailed-table-inner">
                  <thead style="position: sticky; top: 0;">
                    <!-- Верхний уровень заголовка -->
                    <tr class="hidden">
                      <th
                        colspan="1"
                        data-font-size="14"
                        style="text-align: left; border: none; font-weight: 700; font-size: 12px; width: 279px; padding-left: 10px;"
                      >
                        VIN {{ selectedVehicle?.data.objConf?.vin || 'Н/Д' }}
                      </th>
                      <th
                        :colspan="groupingType2 !== 'day' ? violationDates.length * 4 : violationDates.length * 3"
                        data-font-size="14"
                        style="text-align: center; border: none; font-weight: 700; font-size: 12px; padding: 0;"
                      >
                        Сливы топлива зафиксированные по датчику уровня топлива
                      </th>
                    </tr>
                    <!-- Второй уровень заголовка с датами -->
                    <tr>
                      <th
                        colspan="1"
                        data-minwidth="46"
                        data-minheight="23"
                        data-font-size="14"
                        style="text-align: left; border: none; font-weight: 700; font-size: 12px; width: 279px; padding-left: 10px;"
                      >
                        Гос. номер
                        {{ selectedVehicle?.data.objConf?.state_number || 'Н/Д'}}
                        {{ selectedVehicle?.data.objConf?.gearbox_name?.includes('АКПП') ? 'АКПП' : 'МКПП' }}
                      </th>
                        <th
                        v-for="date in violationDates"
                        :key="date"
                          :colspan="groupingType2 !== 'day' ? 4 : 3"
                          data-font-size="18"
                          style="text-align: center; border: none; font-weight: 700; font-size: 12px; padding: 0;"
                        >
                          {{ formatDateByGroupingType(date) }}
                        </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Строки с данными: количество строк = максимальному количеству сливов за период -->
                    <template v-if="!loading">
                    <tr v-for="rowIndex in maxFuelOutRows" :key="rowIndex">
                      <td
                        colspan="1"
                        style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px; vertical-align: top;"
                        data-font-size="14"
                        data-minheight="23"
                      >
                        Время/Объем слива,л./Исправность ДУТ
                      </td>
                      <template
                        v-for="date in violationDates"
                        :key="date"
                        style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                      >
                        <template v-if="getFuelOutData(selectedVehicle, date)?.[rowIndex - 1]">
                          <td
                            v-if="groupingType2 !== 'day'"
                            style="text-align: center;"
                            data-formatnum="0"
                            data-excelalignh="right"
                            data-minwidth="12"
                            data-minheight="23"
                            data-font-size="14"
                          >
                            <!-- Дата слива -->
                            <span style="font-size: 12px;">
                              {{ formatFuelOutDate(getFuelOutData(selectedVehicle, date)[rowIndex - 1].begin) }}
                            </span>
                          </td>
                          <td
                            style="text-align: center;"
                            data-formatnum="0"
                            data-excelalignh="right"
                            data-minwidth="12"
                            data-minheight="23"
                            data-font-size="14"
                          >
                            <!-- Данные для конкретного индекса слива -->
                            <!-- Время слива -->
                            <span style="font-size: 12px;">
                              {{ formatHoursToHHMM((Number(getFuelOutData(selectedVehicle, date)[rowIndex - 1].end) - Number(getFuelOutData(selectedVehicle, date)[rowIndex - 1].begin))/3600)}}
                            </span>
                          </td>
                          <td
                            style="text-align: center;"
                            data-formatnum="5"
                            data-minwidth="12"
                            data-minheight="23"
                            data-font-size="14"
                          >
                            <!-- Объем слива -->
                            <span
                              style="font-size: 12px;"
                              :style="{ fontWeight: parseFloat(getFuelOutData(selectedVehicle, date)[rowIndex - 1].vol) > 0 ? 700 : 'normal' }"
                            >
                              {{ formatNumberWithSpaces(groupingType === 'day' ? parseFloat(getFuelOutData(selectedVehicle, date)[rowIndex - 1].vol || 0).toFixed(1) : parseFloat(getFuelOutData(selectedVehicle, date)[rowIndex - 1].vol || 0).toFixed(1)) }}
                            </span>
                          </td>
                          <td
                            style="text-align: center;"
                            data-formatnum="11"
                            data-minwidth="12"
                            data-minheight="23"
                            data-font-size="14"
                          >
                            <!-- Исправность ДУТ % getFuelOutData(selectedVehicle, date)[rowIndex - 1].vol / 1000 -->
                            <span
                              style="font-size: 12px;"
                              :style="{ color: getDutHealthValue(selectedVehicle, date) === 100 ? '#1E9764' : getDutHealthValue(selectedVehicle, date) >= 90 ? '#000000' : '#FF0909' }"
                            >
                              {{ getDutHealthValue(selectedVehicle, date) }}%
                            </span>
                          </td>
                        </template>
                        <template v-else>
                          <td
                            style="text-align: center;"
                            data-formatnum="11"
                            data-font-size="14"
                            :colspan="groupingType2 !== 'day' ? 4 : 3"
                          >
                            <span style="font-size: 12px;">
                              {{ 0 }}
                            </span>
                          </td>
                        </template>
                      </template>
                    </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td
                          colspan="1"
                          style="text-align: left; padding-left: 10px; border-right: 2px solid #000; font-weight: 400; font-size: 12px; padding-top: 5px; padding-bottom: 5px;"
                          data-font-size="14"
                        >
                          Время/Объем слива,л./Исправность ДУТ
                        </td>
                        <td
                          v-for="date in violationDates"
                          :key="date"
                            data-font-size="14"
                            data-formatnum="12"
                          :colspan="groupingType2 !== 'day' ? 4 : 3"
                            style="text-align: center; font-weight: 400; font-size: 12px; padding-left: 0px; padding-right: 0px; padding-top: 5px; padding-bottom: 5px;"
                          >
                            <span style="font-size: 12px;">Загрузка...</span>
                          </td>
                      </tr>
                    </template>
                  </tbody>
                  <tbody class="hidden">
                    <tr>
                      <td
                        :colspan="totalFuelOutColumns"
                        data-excelcolspan="full"
                        style="text-align: left; padding: 10px 15px; font-size: 12px; line-height: 1.4; font-weight: 400;"
                        data-font-size="12"
                        data-minheight="24"
                      >
                        ДУТ дополнительно устанавливаемый в топливный бак производит самодиагностику неисправностей, при коэффициенте исправности ДУТ менее 99% данные о зафиксированном в ПО сливе требуют дополнительного подтверждения обслуживающей компании.
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!-- Текст-примечание под таблицей -->
                <p class="fuel-out-detailed-note not-print">
                  ДУТ дополнительно устанавливаемый в топливный бак производит самодиагностику неисправностей, при коэффициенте исправности ДУТ менее 99% данные о зафиксированном в ПО сливе требуют дополнительного подтверждения обслуживающей компании.
                </p>
              </div>
              
              <!-- Прелоадер при загрузке -->
              <div v-if="loading" class="preloader" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 10;">
                <Preloader />
                <div v-if="progressTotal > 0" class="progress-text">
                  {{ progressLoaded >= progressTotal - 1 ? 'Загрузка данных...' : `Получено ${progressLoaded} из ${progressTotal}` }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Попап тепловой карты -->
    <MapModal
      v-if="showHeatmapPopup"
      :show="!!showHeatmapPopup"
      :is-roughly="true"
      :id="String(popupObjectId)"
      :obj-name="popupVehicleName"
      :violations="popupViolations"
      :interval="[popupTimeBegin, popupTimeEnd]"
      :heatmap-positions="popupHeatmapPositions"
      :heatmap-type="showHeatmapPopup"
      @not-show="closeHeatmapPopup"
      @close="closeHeatmapPopup"
      @reinit="closeHeatmapPopup"
    />

    <!-- Модальное окно выбора ТС -->
    <VehicleDashboardSelectModal
      v-model="showSelectModal"
      :selected-ts-list="selectedTsListSync"
      v-model:filterSelected="filterSelectedSync"
      v-model:searchStr="searchStrSync"
      v-model:clientSearchStr="clientSearchStrSync"
      @apply="applyTsSelection"
    />
  </teleport>
</template>

<script setup>
import { ref, nextTick, watch, onMounted, onBeforeMount, onBeforeUnmount, computed, inject } from 'vue';
import { formatTimeHelper2, getTzh, formatTimeHelper3, myRoundNumber_helper, formatSecondsToHHMM, formatHoursToHHMM, formatHoursToHHMMSS, formatNumberWithSpaces } from '@/helpers/main_helper';
import { html_to_excel_helper } from '@/helpers/html_to_excel_helper';
import UiDoubleDatepicker from '@/App/Components/UiDoubleDatepicker.vue';
import UIReportButton from '@/App/Monitoring/Sidebar/components/UIReportButton.vue';
import UiSelect from '@/App/Monitoring/Sidebar/components/UiSelect.vue';
import {
  objectsListFormSubmit,
  globalObjects,
  violationsDescriptions,
} from '../../../src/dataRequest/mainScript';
import VehicleDashboardSelectModal from './VehicleDashboardSelectModal.vue';
import { vehicleDashboard_template } from '../../../Template/vehicleDashboard/vehicleDashboard_template';
import Preloader from '@/App/Components/Preloader.vue';
import MapModal from '@/App/Components/MapModal.vue';
import fetchJson from '../../../src/dataRequest/fetch-json';

const printElement = () => {
  window.print();
};

const minDistance = 10; // минимальный пробег ТС для добавления в расчеты

// Проверяем доступность Highcharts
const Highcharts = window.Highcharts;

const props = defineProps({
  trigger: { type: Boolean, required: true },
  form_desc: { type: Object },
  data: { type: Object, default: () => ({}) },
  areaId: { type: String },
});

let chartInstances = [null, null, null, null, null, null, null, null, null, null, null, null, null, null];

const testData = ref(null);
const errorText = ref("");
const showViolationPanel = ref(false);
const violationCount = ref(0);
const showMileageRow = ref(false);
const isMileageBtnActive = ref(false);
const isViolationTypeBtnActive = ref(false);
const isMileageOnlyView = ref(false);
const isHeatmapExpanded = ref(false);

// Новые состояния для таблицы
const showDetailedTable = ref(false); // Показывать ли детальную таблицу поверх основной
const showVinColumn = ref(false); // Показывать VIN вместо гос номера
const sortColumn = ref(null); // Колонка, по которой сортируем (date или 'state_number' или 'vin')
const sortDirection = ref('asc'); // Направление сортировки 'asc' или 'desc'
const selectedVehicle = ref(null); // Выбранное ТС для детальной таблицы
const isMalfunctionMode = ref(false); // Режим неисправностей ТС
const isDistanceMode = ref(false); // Режим среднесуточного пробега
const isFuelMode = ref(false); // Режим расхода топлива
const isFuel100Mode = ref(false); // Режим расхода топлива на 100 км
const isEngineTimeMode = ref(false); // Режим времени работы ДВС
const isFuelOutMode = ref(false); // Режим объема сливов
const isOnLineMode = ref(false); // Режим выхода ТС на линию (лампы)

// Состояние для модального окна с информацией о нарушениях
const showDvsInfoModal = ref(false);
// Состояние для модального окна с информацией о нарушениях Трансмиссии
const showTransmissionInfoModal = ref(false);
// Состояние для модального окна с информацией о нарушениях КОМ
const showKomInfoModal = ref(false);
// Состояние для модального окна с информацией о неисправностях Красная лампа
const showRedLampInfoModal = ref(false);
// Состояние для модального окна с информацией о неисправностях Жёлтая лампа
const showYellowLampInfoModal = ref(false);
// Состояние для модального окна с информацией о неисправностях Не связана с электрикой
const showCo2InfoModal = ref(false);
// Состояние для модального окна с информацией о неисправностях Выбросы СО2
const showNonElectronicInfoModal = ref(false);
// Состояние для модального окна с информацией о выходе ТС на линию
const showOnLineInfoModal = ref(false);
// Состояние для модального окна с информацией о среднесуточном пробеге
const showDistanceInfoModal = ref(false);
// Состояние для модального окна с информацией о расходе топлива по парку
const showFuelVolumeInfoModal = ref(false);
// Состояние для модального окна с информацией о среднем расходе топлива
const showFuelConsumptionInfoModal = ref(false);
// Состояние для модального окна с информацией о времени работы ДВС
const showEngineTimeInfoModal = ref(false);
// Состояние для модального окна с информацией об объеме сливов
const showFuelOutInfoModal = ref(false);

// Конфигурация для модальных окон
const infoModalConfig = {
  dvs: {
    overlay: {
      top: '-127px',
      left: '321px',
      right: 'auto',
      bottom: 'auto'
    },
    modal: {
      maxHeight: '700px'
    }
  },
  transmission: {
    overlay: {
      top: '-127px',
      left: '1295px',
      right: 'auto',
      bottom: 'auto'
    },
    modal: {
      maxHeight: '700px'
    }
  },
  kom: {
    overlay: {
      top: '-127px',
      left: '9px',
      right: 'auto',
      bottom: 'auto'
    },
    modal: {
      maxHeight: '700px'
    }
  },
  redLamp: {
    overlay: {
      top: '125px',
      left: '1262px',
      right: 'auto',
      bottom: 'auto'
    },
    modal: {
      maxHeight: '68vh'
    }
  },
  yellowLamp: {
    overlay: {
      top: '125px',
      left: '1262px',
      right: 'auto',
      bottom: 'auto'
    },
    modal: {
      maxHeight: '68vh'
    }
  },
  co2: {
    overlay: {
      top: '241px',
      left: '1262px',
      right: 'auto',
      bottom: 'auto'
    },
    modal: {
      maxHeight: '68vh'
    }
  },
  nonElectronic: {
    overlay: {
      top: '241px',
      left: '1262px',
      right: 'auto',
      bottom: 'auto'
    },
    modal: {
      maxHeight: '68vh'
    }
  },
  onLine: {
    overlay: {
      top: 'auto',
      left: '10px',
      right: 'auto',
      bottom: '10px'
    },
    modal: {
      maxHeight: '68vh'
    }
  },
  distance: {
    overlay: {
      top: 'auto',
      left: '324px',
      right: 'auto',
      bottom: '10px'
    },
    modal: {
      maxHeight: '68vh'
    }
  },
  fuelVolume: {
    overlay: {
      top: 'auto',
      left: '632px',
      right: 'auto',
      bottom: '10px'
    },
    modal: {
      maxHeight: '68vh'
    }
  },
  fuelConsumption: {
    overlay: {
      top: 'auto',
      left: 'auto',
      right: '362px',
      bottom: '10px'
    },
    modal: {
      maxHeight: '68vh'
    }
  },
  engineTime: {
    overlay: {
      top: 'auto',
      left: 'auto',
      right: '43px',
      bottom: '10px'
    },
    modal: {
      maxHeight: '68vh'
    }
  },
  fuelOut: {
    overlay: {
      top: 'auto',
      left: 'auto',
      right: '43px',
      bottom: '10px'
    },
    modal: {
      maxHeight: '68vh'
    }
  }
};

const loading = ref(false);
const heatLayer = ref(null);
const markerLayer = ref(null);

// Состояния для отслеживания поворота стрелок
const rotatedArrows = ref({
  violationType: false,
  mileage: false
});

// Переменные для модального окна выбора ТС
const showSelectModal = ref(false);

const globalObjectsList = inject('globalObjectsList');
const objectsListUpdateTrigger = inject('objectsListUpdateTrigger');
const userData = inject('userData');
const isViolationsActive = inject('isViolationsActive');
const vehicleDashboardState = inject('vehicleDashboardState');
const isRequestingReport = inject('isRequestingReport');
const heatmapInitialized = ref(false);

// Синхронизируем локальные состояния с глобальными
const selectedTsListSync = computed({
  get: () => vehicleDashboardState.selectedTsList,
  set: (val) => { vehicleDashboardState.selectedTsList = val; }
});
const filterSelectedSync = computed({
  get: () => vehicleDashboardState.filterSelected,
  set: (val) => { vehicleDashboardState.filterSelected = val; }
});
const searchStrSync = computed({
  get: () => vehicleDashboardState.searchStr,
  set: (val) => { vehicleDashboardState.searchStr = val; }
});
const clientSearchStrSync = computed({
  get: () => vehicleDashboardState.clientSearchStr,
  set: (val) => { vehicleDashboardState.clientSearchStr = val; }
});

watch(isViolationsActive, (newValue) => {
  if (newValue && !heatmapInitialized.value) {
    nextTick(() => {
      initHeatmap();
      heatmapInitialized.value = true;
    });
  }
});

// Инициализируем selectedTsList из form_desc.objects при обновлении списка объектов
watch(objectsListUpdateTrigger, () => { 
  if (props.form_desc?.objects && props.form_desc.objects.length > 0 && 
      selectedTsListSync.value.length === 0) {
    selectedTsListSync.value = [...props.form_desc.objects];
  }
}, { immediate: true });

// const testData = ref([
//     {
//         "id": "52959",
//         "data": {
//             "posArray": [
//                 {
//                     "interval_begin": 1764180000,
//                     "interval_end": 1764266400,
//                     "sumPositions": {
//                         "last_time": 1764266400,
//                         "sum_distance": 1230,
//                         "sum_canexpence": 1230,
                          // "t1_excessrpm": 1,
                          // "t1_gearshiftrpm": 2,
                          // "t1_rpmspdless440cntg": 3,
                          // "t1_enginestalledspdcntg": 4,
                          // "t1_ineffectiverpmwithnomotobrake": 5,
                          // "t1_rpmstartspdmore1200cnt": 6,
//                         "sum_motoenginespd": 1230,
//                         "sum_motoengine": 1230,
//                         "sum_specificidling": 1230,
//                         "sum_canexpencenospd": 50,
//                         "sum_canexpencespd": 100,
//                         "critical_violations_cnt": 1230,
//                         "dvs_cnt": 14,
//                         "transmission_cnt": 124,
//                         "kom_cnt": 1240,
//                         "bezop_cnt": 1240,
//                         "sumFuelsOut": 0,
//                         "sumRedLamp": 1,
//                         "sumYellowLamp": 2,
//                         "sumCo2Impact": 3,
//                         "sumNonElectronic": 4,
//                         "weekly": 48
//                     },
//                     "aggrPositions": [
//                         {
//                             "id": "52959",
//                             "time": "1764180000",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764179400",
//                             "last_real_buttery": "7400",
//                             "last_real_power": "7400",
//                             "last_real_time": "1764179966",
//                             "cnt_real_pos": "1292",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "7214",
//                             "dist": "28030",
//                             "dist_not_engine": "580",
//                             "max_speed": "39-1152;47-1387;61-7448",
//                             "can_dist": "0",
//                             "can_expence": "0",
//                             "can_odometer": "0",
//                             "can_moto": "0",
//                             "engine_time": "20100",
//                             "engine_move": "4939",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "14500",
//                             "kren": "-4",
//                             "tang": "-1",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "20100",
//                             "moto_2": "0",
//                             "moto_3": "4300",
//                             "moto_4": "2610",
//                             "moto_5": "1",
//                             "moto_6": "1",
//                             "moto_7": "20100",
//                             "moto_8": "3865",
//                             "moto_9": "3865",
//                             "moto_10": "0",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "32234",
//                             "level_1_expence_moto_1": "0",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "0",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "0",
//                             "level_move_expence_1": "0",
//                             "level_active_expence_1": "0",
//                             "level_1": "0",
//                             "level_expence_1": "0",
//                             "level_out_1": "0",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "0",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "13323",
//                             "level_2": null,
//                             "level_expence_2": null,
//                             "level_out_2": null,
//                             "level_out_move_2": null,
//                             "level_out_cnt_2": null,
//                             "level_out_move_cnt_2": null,
//                             "level_in_2": null,
//                             "level_in_cnt_2": null,
//                             "level_lags_2": null,
//                             "level_3": null,
//                             "level_expence_3": null,
//                             "level_out_3": null,
//                             "level_out_move_3": null,
//                             "level_out_cnt_3": null,
//                             "level_out_move_cnt_3": null,
//                             "level_in_3": null,
//                             "level_in_cnt_3": null,
//                             "level_lags_3": null
//                         },
//                         {
//                             "id": "52959",
//                             "time": "1764183600",
//                             "seconds_of_the_day": "86400",
//                             "last_offset_real_time": "1764181500",
//                             "last_real_buttery": "100",
//                             "last_real_power": "100",
//                             "last_real_time": "1764183506",
//                             "cnt_real_pos": "1304",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "7220",
//                             "dist": "28030",
//                             "dist_not_engine": "580",
//                             "max_speed": "39-4752;47-4987;61-11048",
//                             "can_dist": "0",
//                             "can_expence": "0",
//                             "can_odometer": "0",
//                             "can_moto": "0",
//                             "engine_time": "20100",
//                             "engine_move": "4939",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "14500",
//                             "kren": "-4",
//                             "tang": "-1",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "20100",
//                             "moto_2": "0",
//                             "moto_3": "4300",
//                             "moto_4": "2610",
//                             "moto_5": "1",
//                             "moto_6": "1",
//                             "moto_7": "20100",
//                             "moto_8": "3865",
//                             "moto_9": "3865",
//                             "moto_10": "0",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "35834",
//                             "level_1_expence_moto_1": "0",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "0",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "0",
//                             "level_move_expence_1": "0",
//                             "level_active_expence_1": "0",
//                             "level_1": "0",
//                             "level_expence_1": "0",
//                             "level_out_1": "0",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "0",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "16863",
//                             "level_2": null,
//                             "level_expence_2": null,
//                             "level_out_2": null,
//                             "level_out_move_2": null,
//                             "level_out_cnt_2": null,
//                             "level_out_move_cnt_2": null,
//                             "level_in_2": null,
//                             "level_in_cnt_2": null,
//                             "level_lags_2": null,
//                             "level_3": null,
//                             "level_expence_3": null,
//                             "level_out_3": null,
//                             "level_out_move_3": null,
//                             "level_out_cnt_3": null,
//                             "level_out_move_cnt_3": null,
//                             "level_in_3": null,
//                             "level_in_cnt_3": null,
//                             "level_lags_3": null
//                         },
//                         {
//                             "id": "52959",
//                             "time": "1764266400",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764265800",
//                             "last_real_buttery": "14500",
//                             "last_real_power": "14500",
//                             "last_real_time": "1764266391",
//                             "cnt_real_pos": "1276",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "7758",
//                             "dist": "30650",
//                             "dist_not_engine": "0",
//                             "max_speed": "27-6133;51-7173",
//                             "can_dist": "0",
//                             "can_expence": "0",
//                             "can_odometer": "0",
//                             "can_moto": "0",
//                             "engine_time": "25189",
//                             "engine_move": "4243",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764266391",
//                             "last_speed": "0",
//                             "last_power_value": "14500",
//                             "kren": "-2",
//                             "tang": "-1",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "25189",
//                             "moto_2": "0",
//                             "moto_3": "3692",
//                             "moto_4": "2565",
//                             "moto_5": "2",
//                             "moto_6": "1",
//                             "moto_7": "25189",
//                             "moto_8": "8176",
//                             "moto_9": "8176",
//                             "moto_10": "0",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "36395",
//                             "level_1_expence_moto_1": "0",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "0",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "0",
//                             "level_move_expence_1": "0",
//                             "level_active_expence_1": "0",
//                             "level_1": "0",
//                             "level_expence_1": "0",
//                             "level_out_1": "0",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "0",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "14278",
//                             "level_2": null,
//                             "level_expence_2": null,
//                             "level_out_2": null,
//                             "level_out_move_2": null,
//                             "level_out_cnt_2": null,
//                             "level_out_move_cnt_2": null,
//                             "level_in_2": null,
//                             "level_in_cnt_2": null,
//                             "level_lags_2": null,
//                             "level_3": null,
//                             "level_expence_3": null,
//                             "level_out_3": null,
//                             "level_out_move_3": null,
//                             "level_out_cnt_3": null,
//                             "level_out_move_cnt_3": null,
//                             "level_in_3": null,
//                             "level_in_cnt_3": null,
//                             "level_lags_3": null
//                         }
//                     ],
//                     "on_line": true,
//                     "fuelPositions": [],
//                     "lampsPositions": []
//                 },
//                 {
//                     "interval_begin": 1764276400,
//                     "interval_end": 1764296400,
//                     "sumPositions": {
//                         "last_time": 1764266400,
//                         "sum_distance": 84.62,
//                         "sum_canexpence": 23,
                          // "t1_excessrpm": 1,
                          // "t1_gearshiftrpm": 2,
                          // "t1_rpmspdless440cntg": 3,
                          // "t1_enginestalledspdcntg": 4,
                          // "t1_ineffectiverpmwithnomotobrake": 5,
                          // "t1_rpmstartspdmore1200cnt": 6,
//                         "sum_motoenginespd": 3.368333333333333,
//                         "sum_motoengine": 6.834722222222222,
//                         "sum_specificidling": 3.466388888888889,
//                         "sum_canexpencenospd": 10,
//                         "sum_canexpencespd": 7,
//                         "sumFuelsOut": 0,
//                         "sumRedLamp": 1,
//                         "sumYellowLamp": 2,
//                         "sumCo2Impact": 3,
//                         "sumNonElectronic": 4,
//                         "critical_violations_cnt": 0,
//                         "dvs_cnt": 1,
//                         "transmission_cnt": 124,
//                         "kom_cnt": 1240,
//                         "bezop_cnt": 1240,
//                         "weekly": 48
//                     },
//                     "aggrPositions": [
//                         {
//                             "id": "54818",
//                             "time": "1764180000",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764179100",
//                             "last_real_buttery": "8400",
//                             "last_real_power": "8400",
//                             "last_real_time": "1764179967",
//                             "cnt_real_pos": "1056",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41300",
//                             "dist": "81800",
//                             "dist_not_engine": "0",
//                             "max_speed": "5-599;39-900",
//                             "can_dist": "84320",
//                             "can_expence": "31500",
//                             "can_odometer": "1001441630",
//                             "can_moto": "129660661",
//                             "engine_time": "19024",
//                             "engine_move": "13465",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "25100",
//                             "kren": "0",
//                             "tang": "-2",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "19024",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "20121",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "21606",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "39940",
//                             "level_1_expence_moto_1": "20010",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "19917",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "18349",
//                             "level_move_expence_1": "17093",
//                             "level_active_expence_1": "0",
//                             "level_1": "273235",
//                             "level_expence_1": "18349",
//                             "level_out_1": "18319",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "2",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "146",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "67317",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         },
//                         {
//                             "id": "54818",
//                             "time": "1764183600",
//                             "seconds_of_the_day": "86400",
//                             "last_offset_real_time": "1764181500",
//                             "last_real_buttery": "0",
//                             "last_real_power": "0",
//                             "last_real_time": "1764183507",
//                             "cnt_real_pos": "1068",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41306",
//                             "dist": "81800",
//                             "dist_not_engine": "0",
//                             "max_speed": "5-4199;39-4500",
//                             "can_dist": "84320",
//                             "can_expence": "31500",
//                             "can_odometer": "1001441630",
//                             "can_moto": "129660661",
//                             "engine_time": "19024",
//                             "engine_move": "13465",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "25100",
//                             "kren": "0",
//                             "tang": "-2",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "19024",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "20121",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "21606",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "43447",
//                             "level_1_expence_moto_1": "20010",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "19917",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "18349",
//                             "level_move_expence_1": "17093",
//                             "level_active_expence_1": "0",
//                             "level_1": "273235",
//                             "level_expence_1": "18349",
//                             "level_out_1": "18319",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "2",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "146",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "70857",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         },
//                         {
//                             "id": "54818",
//                             "time": "1764266400",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764265800",
//                             "last_real_buttery": "27500",
//                             "last_real_power": "27500",
//                             "last_real_time": "1764266399",
//                             "cnt_real_pos": "1106",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41859",
//                             "dist": "82190",
//                             "dist_not_engine": "0",
//                             "max_speed": "9-61;40-1480",
//                             "can_dist": "84620",
//                             "can_expence": "37500",
//                             "can_odometer": "1001526250",
//                             "can_moto": "129685682",
//                             "engine_time": "24387",
//                             "engine_move": "12147",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764266399",
//                             "last_speed": "4",
//                             "last_power_value": "27500",
//                             "kren": "1",
//                             "tang": "-3",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "24387",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "25221",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "25937",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "44724",
//                             "level_1_expence_moto_1": "26913",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "25758",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "25662",
//                             "level_move_expence_1": "18194",
//                             "level_active_expence_1": "0",
//                             "level_1": "232524",
//                             "level_expence_1": "25662",
//                             "level_out_1": "15049",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "1",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "184",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "68264",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         }
//                     ],
//                     "on_line": true,
//                     "fuelPositions": [],
//                     "lampsPositions": []
//                 },
//                 {
//                     "interval_begin": 1764352800,
//                     "interval_end": 1764439200,
//                     "sumPositions": {
//                         "last_time": 1764266400,
//                         "sum_distance": 84.62,
//                         "sum_canexpence": 23,
                          // "t1_excessrpm": 1,
                          // "t1_gearshiftrpm": 2,
                          // "t1_rpmspdless440cntg": 3,
                          // "t1_enginestalledspdcntg": 4,
                          // "t1_ineffectiverpmwithnomotobrake": 5,
                          // "t1_rpmstartspdmore1200cnt": 6,
//                         "sum_motoenginespd": 3.368333333333333,
//                         "sum_motoengine": 6.834722222222222,
//                         "sum_specificidling": 3.466388888888889,
//                         "sum_canexpencenospd": 10,
//                         "sum_canexpencespd": 7,
//                         "sumFuelsOut": 0,
//                         "sumRedLamp": 1,
//                         "sumYellowLamp": 2,
//                         "sumCo2Impact": 3,
//                         "sumNonElectronic": 4,
//                         "critical_violations_cnt": 0,
//                         "dvs_cnt": 5,
//                         "transmission_cnt": 124,
//                         "kom_cnt": 1240,
//                         "bezop_cnt": 1240,
//                         "weekly": 48
//                     },
//                     "aggrPositions": [
//                         {
//                             "id": "54818",
//                             "time": "1764180000",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764179100",
//                             "last_real_buttery": "8400",
//                             "last_real_power": "8400",
//                             "last_real_time": "1764179967",
//                             "cnt_real_pos": "1056",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41300",
//                             "dist": "81800",
//                             "dist_not_engine": "0",
//                             "max_speed": "5-599;39-900",
//                             "can_dist": "84320",
//                             "can_expence": "31500",
//                             "can_odometer": "1001441630",
//                             "can_moto": "129660661",
//                             "engine_time": "19024",
//                             "engine_move": "13465",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "25100",
//                             "kren": "0",
//                             "tang": "-2",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "19024",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "20121",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "21606",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "39940",
//                             "level_1_expence_moto_1": "20010",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "19917",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "18349",
//                             "level_move_expence_1": "17093",
//                             "level_active_expence_1": "0",
//                             "level_1": "273235",
//                             "level_expence_1": "18349",
//                             "level_out_1": "18319",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "2",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "146",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "67317",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         },
//                         {
//                             "id": "54818",
//                             "time": "1764183600",
//                             "seconds_of_the_day": "86400",
//                             "last_offset_real_time": "1764181500",
//                             "last_real_buttery": "0",
//                             "last_real_power": "0",
//                             "last_real_time": "1764183507",
//                             "cnt_real_pos": "1068",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41306",
//                             "dist": "81800",
//                             "dist_not_engine": "0",
//                             "max_speed": "5-4199;39-4500",
//                             "can_dist": "84320",
//                             "can_expence": "31500",
//                             "can_odometer": "1001441630",
//                             "can_moto": "129660661",
//                             "engine_time": "19024",
//                             "engine_move": "13465",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "25100",
//                             "kren": "0",
//                             "tang": "-2",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "19024",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "20121",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "21606",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "43447",
//                             "level_1_expence_moto_1": "20010",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "19917",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "18349",
//                             "level_move_expence_1": "17093",
//                             "level_active_expence_1": "0",
//                             "level_1": "273235",
//                             "level_expence_1": "18349",
//                             "level_out_1": "18319",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "2",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "146",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "70857",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         },
//                         {
//                             "id": "54818",
//                             "time": "1764266400",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764265800",
//                             "last_real_buttery": "27500",
//                             "last_real_power": "27500",
//                             "last_real_time": "1764266399",
//                             "cnt_real_pos": "1106",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41859",
//                             "dist": "82190",
//                             "dist_not_engine": "0",
//                             "max_speed": "9-61;40-1480",
//                             "can_dist": "84620",
//                             "can_expence": "37500",
//                             "can_odometer": "1001526250",
//                             "can_moto": "129685682",
//                             "engine_time": "24387",
//                             "engine_move": "12147",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764266399",
//                             "last_speed": "4",
//                             "last_power_value": "27500",
//                             "kren": "1",
//                             "tang": "-3",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "24387",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "25221",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "25937",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "44724",
//                             "level_1_expence_moto_1": "26913",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "25758",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "25662",
//                             "level_move_expence_1": "18194",
//                             "level_active_expence_1": "0",
//                             "level_1": "232524",
//                             "level_expence_1": "25662",
//                             "level_out_1": "15049",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "1",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "184",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "68264",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         }
//                     ],
//                     "on_line": true,
//                     "fuelPositions": [],
//                     "lampsPositions": []
//                 },
//                 {
//                     "interval_begin": 1764439200,
//                     "interval_end": 1764525600,
//                     "sumPositions": {
//                         "last_time": 1764266400,
//                         "sum_distance": 84.62,
//                         "sum_canexpence": 23,
                          // "t1_excessrpm": 1,
                          // "t1_gearshiftrpm": 2,
                          // "t1_rpmspdless440cntg": 3,
                          // "t1_enginestalledspdcntg": 4,
                          // "t1_ineffectiverpmwithnomotobrake": 5,
                          // "t1_rpmstartspdmore1200cnt": 6,
//                         "sum_motoenginespd": 3.368333333333333,
//                         "sum_motoengine": 6.834722222222222,
//                         "sum_specificidling": 3.466388888888889,
//                         "sum_canexpencenospd": 10,
//                         "sum_canexpencespd": 7,
//                         "sumFuelsOut": 0,
//                         "sumRedLamp": 1,
//                         "sumYellowLamp": 2,
//                         "sumCo2Impact": 3,
//                         "sumNonElectronic": 4,
//                         "critical_violations_cnt": 0,
//                         "dvs_cnt": 10,
//                         "transmission_cnt": 124,
//                         "kom_cnt": 1240,
//                         "bezop_cnt": 1240,
//                         "weekly": 48
//                     },
//                     "aggrPositions": [
//                         {
//                             "id": "54818",
//                             "time": "1764180000",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764179100",
//                             "last_real_buttery": "8400",
//                             "last_real_power": "8400",
//                             "last_real_time": "1764179967",
//                             "cnt_real_pos": "1056",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41300",
//                             "dist": "81800",
//                             "dist_not_engine": "0",
//                             "max_speed": "5-599;39-900",
//                             "can_dist": "84320",
//                             "can_expence": "31500",
//                             "can_odometer": "1001441630",
//                             "can_moto": "129660661",
//                             "engine_time": "19024",
//                             "engine_move": "13465",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "25100",
//                             "kren": "0",
//                             "tang": "-2",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "19024",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "20121",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "21606",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "39940",
//                             "level_1_expence_moto_1": "20010",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "19917",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "18349",
//                             "level_move_expence_1": "17093",
//                             "level_active_expence_1": "0",
//                             "level_1": "273235",
//                             "level_expence_1": "18349",
//                             "level_out_1": "18319",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "2",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "146",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "67317",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         },
//                         {
//                             "id": "54818",
//                             "time": "1764183600",
//                             "seconds_of_the_day": "86400",
//                             "last_offset_real_time": "1764181500",
//                             "last_real_buttery": "0",
//                             "last_real_power": "0",
//                             "last_real_time": "1764183507",
//                             "cnt_real_pos": "1068",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41306",
//                             "dist": "81800",
//                             "dist_not_engine": "0",
//                             "max_speed": "5-4199;39-4500",
//                             "can_dist": "84320",
//                             "can_expence": "31500",
//                             "can_odometer": "1001441630",
//                             "can_moto": "129660661",
//                             "engine_time": "19024",
//                             "engine_move": "13465",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "25100",
//                             "kren": "0",
//                             "tang": "-2",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "19024",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "20121",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "21606",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "43447",
//                             "level_1_expence_moto_1": "20010",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "19917",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "18349",
//                             "level_move_expence_1": "17093",
//                             "level_active_expence_1": "0",
//                             "level_1": "273235",
//                             "level_expence_1": "18349",
//                             "level_out_1": "18319",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "2",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "146",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "70857",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         },
//                         {
//                             "id": "54818",
//                             "time": "1764266400",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764265800",
//                             "last_real_buttery": "27500",
//                             "last_real_power": "27500",
//                             "last_real_time": "1764266399",
//                             "cnt_real_pos": "1106",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41859",
//                             "dist": "82190",
//                             "dist_not_engine": "0",
//                             "max_speed": "9-61;40-1480",
//                             "can_dist": "84620",
//                             "can_expence": "37500",
//                             "can_odometer": "1001526250",
//                             "can_moto": "129685682",
//                             "engine_time": "24387",
//                             "engine_move": "12147",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764266399",
//                             "last_speed": "4",
//                             "last_power_value": "27500",
//                             "kren": "1",
//                             "tang": "-3",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "24387",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "25221",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "25937",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "44724",
//                             "level_1_expence_moto_1": "26913",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "25758",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "25662",
//                             "level_move_expence_1": "18194",
//                             "level_active_expence_1": "0",
//                             "level_1": "232524",
//                             "level_expence_1": "25662",
//                             "level_out_1": "15049",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "1",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "184",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "68264",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         }
//                     ],
//                     "on_line": true,
//                     "fuelPositions": [],
//                     "lampsPositions": []
//                 },
//                 {
//                     "interval_begin": 1764525600,
//                     "interval_end": 1764612000,
//                     "sumPositions": {
//                         "last_time": 1764266400,
//                         "sum_distance": 84.62,
//                         "sum_canexpence": 23,
                          // "t1_excessrpm": 1,
                          // "t1_gearshiftrpm": 2,
                          // "t1_rpmspdless440cntg": 3,
                          // "t1_enginestalledspdcntg": 4,
                          // "t1_ineffectiverpmwithnomotobrake": 5,
                          // "t1_rpmstartspdmore1200cnt": 6,
//                         "sum_motoenginespd": 3.368333333333333,
//                         "sum_motoengine": 6.834722222222222,
//                         "sum_specificidling": 3.466388888888889,
//                         "sum_canexpencenospd": 10,
//                         "sum_canexpencespd": 7,
//                         "sumFuelsOut": 0,
//                         "sumRedLamp": 1,
//                         "sumYellowLamp": 2,
//                         "sumCo2Impact": 3,
//                         "sumNonElectronic": 4,
//                         "critical_violations_cnt": 0,
//                         "dvs_cnt": 5,
//                         "transmission_cnt": 124,
//                         "kom_cnt": 1240,
//                         "bezop_cnt": 1240,
//                         "weekly": 48
//                     },
//                     "aggrPositions": [
//                         {
//                             "id": "54818",
//                             "time": "1764180000",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764179100",
//                             "last_real_buttery": "8400",
//                             "last_real_power": "8400",
//                             "last_real_time": "1764179967",
//                             "cnt_real_pos": "1056",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41300",
//                             "dist": "81800",
//                             "dist_not_engine": "0",
//                             "max_speed": "5-599;39-900",
//                             "can_dist": "84320",
//                             "can_expence": "31500",
//                             "can_odometer": "1001441630",
//                             "can_moto": "129660661",
//                             "engine_time": "19024",
//                             "engine_move": "13465",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "25100",
//                             "kren": "0",
//                             "tang": "-2",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "19024",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "20121",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "21606",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "39940",
//                             "level_1_expence_moto_1": "20010",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "19917",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "18349",
//                             "level_move_expence_1": "17093",
//                             "level_active_expence_1": "0",
//                             "level_1": "273235",
//                             "level_expence_1": "18349",
//                             "level_out_1": "18319",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "2",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "146",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "67317",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         },
//                         {
//                             "id": "54818",
//                             "time": "1764183600",
//                             "seconds_of_the_day": "86400",
//                             "last_offset_real_time": "1764181500",
//                             "last_real_buttery": "0",
//                             "last_real_power": "0",
//                             "last_real_time": "1764183507",
//                             "cnt_real_pos": "1068",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41306",
//                             "dist": "81800",
//                             "dist_not_engine": "0",
//                             "max_speed": "5-4199;39-4500",
//                             "can_dist": "84320",
//                             "can_expence": "31500",
//                             "can_odometer": "1001441630",
//                             "can_moto": "129660661",
//                             "engine_time": "19024",
//                             "engine_move": "13465",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "25100",
//                             "kren": "0",
//                             "tang": "-2",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "19024",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "20121",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "21606",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "43447",
//                             "level_1_expence_moto_1": "20010",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "19917",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "18349",
//                             "level_move_expence_1": "17093",
//                             "level_active_expence_1": "0",
//                             "level_1": "273235",
//                             "level_expence_1": "18349",
//                             "level_out_1": "18319",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "2",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "146",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "70857",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         },
//                         {
//                             "id": "54818",
//                             "time": "1764266400",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764265800",
//                             "last_real_buttery": "27500",
//                             "last_real_power": "27500",
//                             "last_real_time": "1764266399",
//                             "cnt_real_pos": "1106",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41859",
//                             "dist": "82190",
//                             "dist_not_engine": "0",
//                             "max_speed": "9-61;40-1480",
//                             "can_dist": "84620",
//                             "can_expence": "37500",
//                             "can_odometer": "1001526250",
//                             "can_moto": "129685682",
//                             "engine_time": "24387",
//                             "engine_move": "12147",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764266399",
//                             "last_speed": "4",
//                             "last_power_value": "27500",
//                             "kren": "1",
//                             "tang": "-3",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "24387",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "25221",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "25937",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "44724",
//                             "level_1_expence_moto_1": "26913",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "25758",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "25662",
//                             "level_move_expence_1": "18194",
//                             "level_active_expence_1": "0",
//                             "level_1": "232524",
//                             "level_expence_1": "25662",
//                             "level_out_1": "15049",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "1",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "184",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "68264",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         }
//                     ],
//                     "on_line": true,
//                     "fuelPositions": [],
//                     "lampsPositions": []
//                 },
//                 {
//                     "interval_begin": 1764612000,
//                     "interval_end": 1764698400,
//                     "sumPositions": {
//                         "last_time": 1764266400,
//                         "sum_distance": 84.62,
//                         "sum_canexpence": 23,
                          // "t1_excessrpm": 5,
                          // "t1_gearshiftrpm": 4,
                          // "t1_rpmspdless440cntg": 3,
                          // "t1_enginestalledspdcntg": 2,
                          // "t1_ineffectiverpmwithnomotobrake": 1,
                          // "t1_rpmstartspdmore1200cnt": 0,
//                         "sum_motoenginespd": 3.368333333333333,
//                         "sum_motoengine": 6.834722222222222,
//                         "sum_specificidling": 3.466388888888889,
//                         "sum_canexpencenospd": 10,
//                         "sum_canexpencespd": 7,
//                         "sumFuelsOut": 0,
//                         "sumRedLamp": 1,
//                         "sumYellowLamp": 2,
//                         "sumCo2Impact": 3,
//                         "sumNonElectronic": 4,
//                         "critical_violations_cnt": 0,
//                         "dvs_cnt": 30,
//                         "transmission_cnt": 124,
//                         "kom_cnt": 1240,
//                         "bezop_cnt": 1240,
//                         "weekly": 48
//                     },
//                     "aggrPositions": [
//                         {
//                             "id": "54818",
//                             "time": "1764180000",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764179100",
//                             "last_real_buttery": "8400",
//                             "last_real_power": "8400",
//                             "last_real_time": "1764179967",
//                             "cnt_real_pos": "1056",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41300",
//                             "dist": "81800",
//                             "dist_not_engine": "0",
//                             "max_speed": "5-599;39-900",
//                             "can_dist": "84320",
//                             "can_expence": "31500",
//                             "can_odometer": "1001441630",
//                             "can_moto": "129660661",
//                             "engine_time": "19024",
//                             "engine_move": "13465",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "25100",
//                             "kren": "0",
//                             "tang": "-2",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "19024",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "20121",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "21606",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "39940",
//                             "level_1_expence_moto_1": "20010",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "19917",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "18349",
//                             "level_move_expence_1": "17093",
//                             "level_active_expence_1": "0",
//                             "level_1": "273235",
//                             "level_expence_1": "18349",
//                             "level_out_1": "18319",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "2",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "146",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "67317",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         },
//                         {
//                             "id": "54818",
//                             "time": "1764183600",
//                             "seconds_of_the_day": "86400",
//                             "last_offset_real_time": "1764181500",
//                             "last_real_buttery": "0",
//                             "last_real_power": "0",
//                             "last_real_time": "1764183507",
//                             "cnt_real_pos": "1068",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41306",
//                             "dist": "81800",
//                             "dist_not_engine": "0",
//                             "max_speed": "5-4199;39-4500",
//                             "can_dist": "84320",
//                             "can_expence": "31500",
//                             "can_odometer": "1001441630",
//                             "can_moto": "129660661",
//                             "engine_time": "19024",
//                             "engine_move": "13465",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "25100",
//                             "kren": "0",
//                             "tang": "-2",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "19024",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "20121",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "21606",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "43447",
//                             "level_1_expence_moto_1": "20010",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "19917",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "18349",
//                             "level_move_expence_1": "17093",
//                             "level_active_expence_1": "0",
//                             "level_1": "273235",
//                             "level_expence_1": "18349",
//                             "level_out_1": "18319",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "2",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "146",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "70857",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         },
//                         {
//                             "id": "54818",
//                             "time": "1764266400",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764265800",
//                             "last_real_buttery": "27500",
//                             "last_real_power": "27500",
//                             "last_real_time": "1764266399",
//                             "cnt_real_pos": "1106",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41859",
//                             "dist": "82190",
//                             "dist_not_engine": "0",
//                             "max_speed": "9-61;40-1480",
//                             "can_dist": "84620",
//                             "can_expence": "37500",
//                             "can_odometer": "1001526250",
//                             "can_moto": "129685682",
//                             "engine_time": "24387",
//                             "engine_move": "12147",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764266399",
//                             "last_speed": "4",
//                             "last_power_value": "27500",
//                             "kren": "1",
//                             "tang": "-3",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "24387",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "25221",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "25937",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "44724",
//                             "level_1_expence_moto_1": "26913",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "25758",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "25662",
//                             "level_move_expence_1": "18194",
//                             "level_active_expence_1": "0",
//                             "level_1": "232524",
//                             "level_expence_1": "25662",
//                             "level_out_1": "15049",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "1",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "184",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "68264",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         }
//                     ],
//                     "on_line": true,
//                     "fuelPositions": [],
//                     "lampsPositions": []
//                 },
//                 {
//                     "interval_begin": 1764698400,
//                     "interval_end": 1764784800,
//                     "sumPositions": {
//                         "last_time": 1764266400,
//                         "sum_distance": 84.62,
//                         "sum_canexpence": 23,
                          // "t1_excessrpm": 1,
                          // "t1_gearshiftrpm": 2,
                          // "t1_rpmspdless440cntg": 3,
                          // "t1_enginestalledspdcntg": 4,
                          // "t1_ineffectiverpmwithnomotobrake": 5,
                          // "t1_rpmstartspdmore1200cnt": 4,
//                         "sum_motoenginespd": 3.368333333333333,
//                         "sum_motoengine": 6.834722222222222,
//                         "sum_specificidling": 3.466388888888889,
//                         "sum_canexpencenospd": 10,
//                         "sum_canexpencespd": 7,
//                         "sumFuelsOut": 0,
//                         "sumRedLamp": 1,
//                         "sumYellowLamp": 2,
//                         "sumCo2Impact": 3,
//                         "sumNonElectronic": 4,
//                         "critical_violations_cnt": 0,
//                         "dvs_cnt": 15,
//                         "transmission_cnt": 124,
//                         "kom_cnt": 1240,
//                         "bezop_cnt": 1240,
//                         "weekly": 48
//                     },
//                     "aggrPositions": [
//                         {
//                             "id": "54818",
//                             "time": "1764180000",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764179100",
//                             "last_real_buttery": "8400",
//                             "last_real_power": "8400",
//                             "last_real_time": "1764179967",
//                             "cnt_real_pos": "1056",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41300",
//                             "dist": "81800",
//                             "dist_not_engine": "0",
//                             "max_speed": "5-599;39-900",
//                             "can_dist": "84320",
//                             "can_expence": "31500",
//                             "can_odometer": "1001441630",
//                             "can_moto": "129660661",
//                             "engine_time": "19024",
//                             "engine_move": "13465",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "25100",
//                             "kren": "0",
//                             "tang": "-2",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "19024",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "20121",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "21606",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "39940",
//                             "level_1_expence_moto_1": "20010",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "19917",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "18349",
//                             "level_move_expence_1": "17093",
//                             "level_active_expence_1": "0",
//                             "level_1": "273235",
//                             "level_expence_1": "18349",
//                             "level_out_1": "18319",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "2",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "146",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "67317",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         },
//                         {
//                             "id": "54818",
//                             "time": "1764183600",
//                             "seconds_of_the_day": "86400",
//                             "last_offset_real_time": "1764181500",
//                             "last_real_buttery": "0",
//                             "last_real_power": "0",
//                             "last_real_time": "1764183507",
//                             "cnt_real_pos": "1068",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41306",
//                             "dist": "81800",
//                             "dist_not_engine": "0",
//                             "max_speed": "5-4199;39-4500",
//                             "can_dist": "84320",
//                             "can_expence": "31500",
//                             "can_odometer": "1001441630",
//                             "can_moto": "129660661",
//                             "engine_time": "19024",
//                             "engine_move": "13465",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "25100",
//                             "kren": "0",
//                             "tang": "-2",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "19024",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "20121",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "21606",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "43447",
//                             "level_1_expence_moto_1": "20010",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "19917",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "18349",
//                             "level_move_expence_1": "17093",
//                             "level_active_expence_1": "0",
//                             "level_1": "273235",
//                             "level_expence_1": "18349",
//                             "level_out_1": "18319",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "2",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "146",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "70857",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         },
//                         {
//                             "id": "54818",
//                             "time": "1764266400",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764265800",
//                             "last_real_buttery": "27500",
//                             "last_real_power": "27500",
//                             "last_real_time": "1764266399",
//                             "cnt_real_pos": "1106",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41859",
//                             "dist": "82190",
//                             "dist_not_engine": "0",
//                             "max_speed": "9-61;40-1480",
//                             "can_dist": "84620",
//                             "can_expence": "37500",
//                             "can_odometer": "1001526250",
//                             "can_moto": "129685682",
//                             "engine_time": "24387",
//                             "engine_move": "12147",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764266399",
//                             "last_speed": "4",
//                             "last_power_value": "27500",
//                             "kren": "1",
//                             "tang": "-3",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "24387",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "25221",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "25937",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "44724",
//                             "level_1_expence_moto_1": "26913",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "25758",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "25662",
//                             "level_move_expence_1": "18194",
//                             "level_active_expence_1": "0",
//                             "level_1": "232524",
//                             "level_expence_1": "25662",
//                             "level_out_1": "15049",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "1",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "184",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "68264",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         }
//                     ],
//                     "on_line": true,
//                     "fuelPositions": [],
//                     "lampsPositions": []
//                 }
//             ],
//             "error": 0,
//             "objConf": {
//                 "line_id": "1510",
//                 "id": "52959",
//                 "name": "XM_SBT Бенза847",
//                 "vendor_server": "navigator",
//                 "state_number": "В 847 СС 186 (АТЗ)",
//                 "model": "MAN Бензовоз",
//                 "client": "СИБИТЕК АО",
//                 "vin": "",
//                 "uid": "860922042956262",
//                 "phone": "+79822202852",
//                 "category": "34",
//                 "parent_code": "51723",
//                 "install_time": "0",
//                 "lat": "60083694460000000",
//                 "lon": "70768798829999992",
//                 "alt": "0",
//                 "head": "0",
//                 "speed": "0",
//                 "pwr": "0",
//                 "bat": "0",
//                 "gearbox_name": "нет значения",
//                 "gearbox_cnt": "17",
//                 "gearbox_is_clutch": "0",
//                 "change_config_time": "1763171211",
//                 "last_time_vendor": "1764271201",
//                 "last_time_revision_begin": "1764262022",
//                 "last_time_revision_end": "1764262240",
//                 "last_time_aggregation": "1764269400",
//                 "task_get_positions_status": "success",
//                 "task_get_positions_task_add_time": "1764270563",
//                 "task_get_positions_task_start_time": "1764270665",
//                 "task_get_positions_query_begin": "1764177396",
//                 "task_get_positions_query_end": "1764273600",
//                 "task_get_positions_aggregate_begin": "1764183600",
//                 "task_get_positions_aggregate_end": "1764270000",
//                 "task_get_positions_file_name": "/var/www/html/server_part1_v2/src/cron/files/answers/id52959_1764270690_6299.txt",
//                 "task_calculate_status": "wait",
//                 "task_calculate_task_add_time": "1764270690",
//                 "task_calculate_task_start_time": "1764270543",
//                 "task_calculate_heartbeat": "0",
//                 "task_error_cnt": "288",
//                 "transmission_lock_0_name": "",
//                 "transmission_lock_1_name": "",
//                 "transmission_lock_2_name": "",
//                 "transmission_lock_3_name": "",
//                 "transmission_lock_4_name": "",
//                 "transmission_lock_5_name": "",
//                 "transmission_lock_6_name": "",
//                 "transmission_lock_7_name": "",
//                 "transmission_lock_8_name": "",
//                 "transmission_lock_9_name": "",
//                 "transmission_lock_10_name": "",
//                 "config": "{\"ign\":{\"p\":\"3\",\"max\":\"1\"},\"dist\":{\"p\":\"2\"},\"park\":{\"p\":\"1\"},\"eval\":[{\"p\":\"17039363\",\"rule\":\"iif(pwr>10&&p102<2000&&p102>1,(p102\\/10)-90,err)\",\"nm\":\"Угол крена\",\"dim\":\"град.\"},{\"p\":\"17039363\",\"id\":\"1\",\"rule\":\"iif(pwr>10&&p103<2000&&p103>1,(p103\\/10)-90,err)\",\"nm\":\"Угол тангажа\",\"dim\":\"град.\"},{\"p\":\"17039363\",\"id\":\"2\",\"rule\":\"p131&8\",\"nm\":\"Бенза connect (связь ГЛОНАСС с BENZA)\",\"dim\":\"0 - нет связи\"},{\"p\":\"17039363\",\"id\":\"3\",\"rule\":\"p131&4\",\"nm\":\"Бенза идентификация (RFID)\",\"dim\":\"0 - нет\"},{\"p\":\"17039363\",\"id\":\"4\",\"rule\":\"p132\\/1000\",\"nm\":\"Бенза объем посл. выдачи\",\"dim\":\"литры\"},{\"p\":\"17039363\",\"id\":\"5\",\"rule\":\"iif( (prev.cpe4) && (!cpe4), 3000,0)\",\"nm\":\"prev.cpe4&&!cpe4\"},{\"p\":\"17039363\",\"id\":\"6\",\"rule\":\"iif(p101>0&&p101<250,p101-127,err)\",\"nm\":\"Температура ДУТ в цистерне\",\"dim\":\"градусы\"},{\"p\":\"17039363\",\"id\":\"7\",\"rule\":\"iif(p131&16,3200,0)\",\"nm\":\"Начало выдачи топлива\"},{\"p\":\"17039363\",\"id\":\"8\",\"rule\":\"iif(p131&32,4000,0)\",\"nm\":\"Окончание выдачи топлива\"},{\"p\":\"17039363\",\"id\":\"9\",\"rule\":\"iif(p131 & 64,4500,0)\",\"nm\":\"Смена кода карты\"}],\"csmp\":[{\"p\":\"1572870\",\"spd\":\"1\",\"spt\":\"1\",\"coef\":\"0.000001\",\"rule\":\"p132\\/1000\"},{\"p\":\"6\",\"id\":\"4\",\"spd\":\"10\",\"spt\":\"10\",\"rule\":\"refueller_cistern ?1,????7\"}],\"moto\":[{\"p\":\"5\",\"rule\":\"s1&&adc1>26\"},{\"p\":\"5\",\"id\":\"1\",\"rule\":\"p131&4&&spd>2\"},{\"p\":\"5\",\"id\":\"2\",\"rule\":\"spd>0\"},{\"p\":\"5\",\"id\":\"3\",\"rule\":\"cpe4&&prev.cpe4\"},{\"p\":\"5\",\"id\":\"4\",\"rule\":\"((abs(cpe1-prev.cpe1)>2)||(abs(cpe2-prev.cpe2)>2))&&spd=0\"},{\"p\":\"5\",\"id\":\"5\",\"rule\":\"(cpe4&&!prev.cpe4)||(!cpe4&&prev.cpe4)\"},{\"p\":\"2\",\"id\":\"6\"},{\"p\":\"5\",\"id\":\"7\",\"tmin\":\"300\",\"rule\":\"pwr>12&&!(p104>3&&p104<4096)\"},{\"p\":\"5\",\"id\":\"8\",\"tmin\":\"300\",\"rule\":\"pwr>12&&!(p104>3&&p104<4096)\"}],\"levl\":[{\"p\":\"719323139\",\"vol\":\"10950\",\"avg\":\"3\",\"inp\":\"2\",\"outp\":\"2\",\"spt\":\"8\",\"spd\":\"8\",\"rule\":\"iif(pwr>14, p104,err)\",\"fx\":\"iif(x<4096,iif(x>0,tab(x,0,0,27,50,78,100,116,150,147,200,174,250,198,300,222,350,244,400,267,450,287,500,364,700,436,900,507,1100,573,1300,637,1500,699,1700,760,1900,824,2100,883,2300,943,2500,1007,2700,1064,2900,1126,3100,1183,3300,1244,3500,1303,3700,1364,3900,1420,4100,1482,4300,1537,4500,1594,4700,1654,4900,1715,5100,1774,5300,1832,5500,1893,5700,1950,5900,2010,6100,2071,6300,2126,6500,2186,6700,2245,6900,2310,7100,2365,7300,2425,7500,2485,7700,2547,7900,2609,8100,2674,8300,2737,8500,2798,8700,2867,8900,2929,9100,2997,9300,3064,9500,3127,9700,3199,9900,3272,10100,3354,11050,4095,11051),err),err)\",\"mod\":\"MonAlgFuel080719? l=484 &w=250 & h=123 &left= 120 &back= 235 & lhinmax=60000 & lhoutmax=20000&jerksumm=150&jerknorm=20 & bigpercent=8&bigpercenttime=1 & diffToRecord = 100 & anglestab=20 & cpek=1 & cpet=2\",\"nm\":\"Цистерна (тарировка 05.08.2020г)\",\"gp\":\"1. Цистерна\\/BENZA\",\"st\":[{\"m\":\"8\",\"inp\":\"4\",\"outp\":\"6\",\"spt\":\"11\",\"spd\":\"11\"},{\"m\":\"32\",\"inp\":\"1\",\"outp\":\"0.04\",\"spt\":\"1\",\"spd\":\"1\"},{\"m\":\"16\",\"inp\":\"7\",\"outp\":\"7\",\"spt\":\"1000\",\"spd\":\"1000\",\"stb\":\"60\"},{\"m\":\"64\",\"inp\":\"7\",\"outp\":\"7\",\"spt\":\"900\",\"spd\":\"900\"},{\"m\":\"128\",\"inp\":\"9\",\"outp\":\"9\"}]},{\"p\":\"803471363\",\"id\":\"1\",\"vol\":\"1000\",\"avg\":\"3\",\"inp\":\"2\",\"outp\":\"2\",\"spt\":\"1\",\"spd\":\"1\",\"rule\":\"cpf1\",\"mod\":\"MonAlgFuel080719?lhinmax=30000 & lhoutmax=800&jerksumm=100&jerknorm=50 & bigpercent=9 & bigpercenttime=1 & diffToRecord = 100\",\"nm\":\"Ввыдачи Benza (от нач. п., но по сост. на 07.07.19 смотреть в отчете)\",\"gp\":\"1. Цистерна\\/BENZA\",\"st\":[{\"m\":\"32\",\"inp\":\"0.30000001\",\"outp\":\"0.30000001\"},{\"m\":\"128\",\"inp\":\"11\",\"outp\":\"11\",\"spt\":\"8\",\"spd\":\"8\"}]},{\"p\":\"717225987\",\"id\":\"2\",\"vol\":\"310\",\"avg\":\"3\",\"inp\":\"5\",\"outp\":\"5\",\"spt\":\"10\",\"spd\":\"50\",\"rule\":\"iif(pwr>14, p105 ,err)\",\"fx\":\"iif(x<4096,iif(x>3,tab(x,4,0,4095,310),err),err)\",\"nm\":\"Топливный бак (не окончательная настройка)\",\"gp\":\"2. Шасси\",\"st\":[{\"m\":\"16\",\"inp\":\"60\",\"outp\":\"60\",\"spt\":\"40\",\"spd\":\"300\"}]},{\"p\":\"736362499\",\"id\":\"4\",\"avg\":\"1\",\"inp\":\"5\",\"outp\":\"5\",\"spt\":\"10\",\"spd\":\"50\",\"rule\":\"p191\",\"nm\":\"Педаль газа\"},{\"p\":\"736362499\",\"id\":\"5\",\"avg\":\"1\",\"inp\":\"5\",\"outp\":\"5\",\"spt\":\"10\",\"spd\":\"50\",\"rule\":\"p192\",\"nm\":\"Нагрузка ДВС\"},{\"p\":\"736362499\",\"id\":\"6\",\"vol\":\"11185\",\"avg\":\"3\",\"inp\":\"100\",\"outp\":\"100\",\"spt\":\"10\",\"spd\":\"50\",\"rule\":\"lv1\",\"nm\":\"Цистерна 99% (не окончательная настройка)\"}],\"vars\":{\"tm\":\"1763141265\"}}\n"
//             },
//             "ts_in_park": 1,
//             "ts_with_dut": true,
//             "ts_in_work": true,
//             "ts_with_correct_dut": true
//         }
//     },
//     {
//         "id": "54818",
//         "data": {
//             "posArray": [
//                 {
//                     "interval_begin": 1764180000,
//                     "interval_end": 1764266400,
//                     "sumPositions": {
//                         "last_time": 1764266400,
//                         "sum_distance": 84.62,
//                         "sum_canexpence": 23,
                          // "t1_excessrpm": 6,
                          // "t1_gearshiftrpm": 7,
                          // "t1_rpmspdless440cntg":8,
                          // "t1_enginestalledspdcntg": 9,
                          // "t1_ineffectiverpmwithnomotobrake": 8,
                          // "t1_rpmstartspdmore1200cnt": 7,
//                         "sum_motoenginespd": 3.368333333333333,
//                         "sum_motoengine": 6.834722222222222,
//                         "sum_specificidling": 3.466388888888889,
//                         "sum_canexpencenospd": 15,
//                         "sum_canexpencespd": 12,
//                         "critical_violations_cnt": 0,
//                         "dvs_cnt": 20,
//                         "transmission_cnt": 124,
//                         "kom_cnt": 1240,
//                         "bezop_cnt": 1240,
//                         "sumFuelsOut": 10,
//                         "sumRedLamp": 1,
//                         "sumYellowLamp": 2,
//                         "sumCo2Impact": 3,
//                         "sumNonElectronic": 4,
//                         "weekly": 48
//                     },
//                     "aggrPositions": [
//                         {
//                             "id": "54818",
//                             "time": "1764180000",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764179100",
//                             "last_real_buttery": "8400",
//                             "last_real_power": "8400",
//                             "last_real_time": "1764179967",
//                             "cnt_real_pos": "1056",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41300",
//                             "dist": "81800",
//                             "dist_not_engine": "0",
//                             "max_speed": "5-599;39-900",
//                             "can_dist": "84320",
//                             "can_expence": "31500",
//                             "can_odometer": "1001441630",
//                             "can_moto": "129660661",
//                             "engine_time": "19024",
//                             "engine_move": "13465",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "25100",
//                             "kren": "0",
//                             "tang": "-2",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "19024",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "20121",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "21606",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "39940",
//                             "level_1_expence_moto_1": "20010",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "19917",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "18349",
//                             "level_move_expence_1": "17093",
//                             "level_active_expence_1": "0",
//                             "level_1": "273235",
//                             "level_expence_1": "18349",
//                             "level_out_1": "18319",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "2",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "146",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "67317",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         },
//                         {
//                             "id": "54818",
//                             "time": "1764183600",
//                             "seconds_of_the_day": "86400",
//                             "last_offset_real_time": "1764181500",
//                             "last_real_buttery": "0",
//                             "last_real_power": "0",
//                             "last_real_time": "1764183507",
//                             "cnt_real_pos": "1068",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41306",
//                             "dist": "81800",
//                             "dist_not_engine": "0",
//                             "max_speed": "5-4199;39-4500",
//                             "can_dist": "84320",
//                             "can_expence": "31500",
//                             "can_odometer": "1001441630",
//                             "can_moto": "129660661",
//                             "engine_time": "19024",
//                             "engine_move": "13465",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "25100",
//                             "kren": "0",
//                             "tang": "-2",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "19024",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "20121",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "21606",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "43447",
//                             "level_1_expence_moto_1": "20010",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "19917",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "18349",
//                             "level_move_expence_1": "17093",
//                             "level_active_expence_1": "0",
//                             "level_1": "273235",
//                             "level_expence_1": "18349",
//                             "level_out_1": "18319",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "2",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "146",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "70857",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         },
//                         {
//                             "id": "54818",
//                             "time": "1764266400",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764265800",
//                             "last_real_buttery": "27500",
//                             "last_real_power": "27500",
//                             "last_real_time": "1764266399",
//                             "cnt_real_pos": "1106",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41859",
//                             "dist": "82190",
//                             "dist_not_engine": "0",
//                             "max_speed": "9-61;40-1480",
//                             "can_dist": "84620",
//                             "can_expence": "37500",
//                             "can_odometer": "1001526250",
//                             "can_moto": "129685682",
//                             "engine_time": "24387",
//                             "engine_move": "12147",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764266399",
//                             "last_speed": "4",
//                             "last_power_value": "27500",
//                             "kren": "1",
//                             "tang": "-3",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "24387",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "25221",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "25937",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "44724",
//                             "level_1_expence_moto_1": "26913",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "25758",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "25662",
//                             "level_move_expence_1": "18194",
//                             "level_active_expence_1": "0",
//                             "level_1": "232524",
//                             "level_expence_1": "25662",
//                             "level_out_1": "15049",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "1",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "184",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "68264",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         }
//                     ],
//                     "on_line": true,
//                     "fuelPositions": [],
//                     "lampsPositions": [] 
//                 },
//                 {
//                     "interval_begin": 1764276400,
//                     "interval_end": 1764296400,
//                     "sumPositions": {
//                         "last_time": 1764266400,
//                         "sum_distance": 84.62,
//                         "sum_canexpence": 23,
                          // "t1_excessrpm": 1,
                          // "t1_gearshiftrpm": 2,
                          // "t1_rpmspdless440cntg": 4,
                          // "t1_enginestalledspdcntg": 2,
                          // "t1_ineffectiverpmwithnomotobrake": 5,
                          // "t1_rpmstartspdmore1200cnt": 1,
//                         "sum_motoenginespd": 3.368333333333333,
//                         "sum_motoengine": 6.834722222222222,
//                         "sum_specificidling": 3.466388888888889,
//                         "sum_canexpencenospd": 20,
//                         "sum_canexpencespd": 5,
//                         "critical_violations_cnt": 0,
//                         "dvs_cnt": 25,
//                         "transmission_cnt": 124,
//                         "kom_cnt": 1240,
//                         "bezop_cnt": 1240,
//                         "sumRedLamp": 1,
//                         "sumYellowLamp": 2,
//                         "sumCo2Impact": 3,
//                         "sumNonElectronic": 4,
//                         "sumFuelsOut": 0,
//                         "weekly": 48
//                     },
//                     "aggrPositions": [
//                         {
//                             "id": "54818",
//                             "time": "1764180000",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764179100",
//                             "last_real_buttery": "8400",
//                             "last_real_power": "8400",
//                             "last_real_time": "1764179967",
//                             "cnt_real_pos": "1056",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41300",
//                             "dist": "81800",
//                             "dist_not_engine": "0",
//                             "max_speed": "5-599;39-900",
//                             "can_dist": "84320",
//                             "can_expence": "31500",
//                             "can_odometer": "1001441630",
//                             "can_moto": "129660661",
//                             "engine_time": "19024",
//                             "engine_move": "13465",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "25100",
//                             "kren": "0",
//                             "tang": "-2",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "19024",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "20121",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "21606",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "39940",
//                             "level_1_expence_moto_1": "20010",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "19917",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "18349",
//                             "level_move_expence_1": "17093",
//                             "level_active_expence_1": "0",
//                             "level_1": "273235",
//                             "level_expence_1": "18349",
//                             "level_out_1": "18319",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "2",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "146",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "67317",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         },
//                         {
//                             "id": "54818",
//                             "time": "1764183600",
//                             "seconds_of_the_day": "86400",
//                             "last_offset_real_time": "1764181500",
//                             "last_real_buttery": "0",
//                             "last_real_power": "0",
//                             "last_real_time": "1764183507",
//                             "cnt_real_pos": "1068",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41306",
//                             "dist": "81800",
//                             "dist_not_engine": "0",
//                             "max_speed": "5-4199;39-4500",
//                             "can_dist": "84320",
//                             "can_expence": "31500",
//                             "can_odometer": "1001441630",
//                             "can_moto": "129660661",
//                             "engine_time": "19024",
//                             "engine_move": "13465",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764179535",
//                             "last_speed": "0",
//                             "last_power_value": "25100",
//                             "kren": "0",
//                             "tang": "-2",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "19024",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "20121",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "21606",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "43447",
//                             "level_1_expence_moto_1": "20010",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "19917",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "18349",
//                             "level_move_expence_1": "17093",
//                             "level_active_expence_1": "0",
//                             "level_1": "273235",
//                             "level_expence_1": "18349",
//                             "level_out_1": "18319",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "2",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "146",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "70857",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         },
//                         {
//                             "id": "54818",
//                             "time": "1764266400",
//                             "seconds_of_the_day": "82800",
//                             "last_offset_real_time": "1764265800",
//                             "last_real_buttery": "27500",
//                             "last_real_power": "27500",
//                             "last_real_time": "1764266399",
//                             "cnt_real_pos": "1106",
//                             "cnt_pos_missed": "0",
//                             "last_pos_num": "41859",
//                             "dist": "82190",
//                             "dist_not_engine": "0",
//                             "max_speed": "9-61;40-1480",
//                             "can_dist": "84620",
//                             "can_expence": "37500",
//                             "can_odometer": "1001526250",
//                             "can_moto": "129685682",
//                             "engine_time": "24387",
//                             "engine_move": "12147",
//                             "active_time": "0",
//                             "percent_data": "10000",
//                             "last_power_time": "1764266399",
//                             "last_speed": "4",
//                             "last_power_value": "27500",
//                             "kren": "1",
//                             "tang": "-3",
//                             "counter_1": "0",
//                             "counter_2": "0",
//                             "counter_3": "0",
//                             "counter_4": "0",
//                             "counter_5": "0",
//                             "counter_6": "0",
//                             "counter_7": "0",
//                             "counter_8": "0",
//                             "counter_9": "0",
//                             "counter_10": "0",
//                             "moto_1": "24387",
//                             "moto_2": "0",
//                             "moto_3": "0",
//                             "moto_4": "0",
//                             "moto_5": "0",
//                             "moto_6": "0",
//                             "moto_7": "25221",
//                             "moto_8": "0",
//                             "moto_9": "0",
//                             "moto_10": "25937",
//                             "retarderoiltmprs": "[]",
//                             "continuous_data_time": "44724",
//                             "level_1_expence_moto_1": "26913",
//                             "level_1_expence_moto_2": "0",
//                             "level_1_expence_moto_3": "0",
//                             "level_1_expence_moto_4": "0",
//                             "level_1_expence_moto_5": "0",
//                             "level_1_expence_moto_6": "0",
//                             "level_1_expence_moto_7": "25758",
//                             "level_1_expence_moto_8": "0",
//                             "level_1_expence_moto_9": "0",
//                             "level_1_expence_moto_10": "25662",
//                             "level_move_expence_1": "18194",
//                             "level_active_expence_1": "0",
//                             "level_1": "232524",
//                             "level_expence_1": "25662",
//                             "level_out_1": "15049",
//                             "level_out_move_1": "0",
//                             "level_out_cnt_1": "1",
//                             "level_out_move_cnt_1": "0",
//                             "level_in_1": "0",
//                             "level_in_cnt_1": "0",
//                             "level_lags_1": "184",
//                             "level_2": "5261320",
//                             "level_expence_2": "0",
//                             "level_out_2": "0",
//                             "level_out_move_2": "0",
//                             "level_out_cnt_2": "0",
//                             "level_out_move_cnt_2": "0",
//                             "level_in_2": "0",
//                             "level_in_cnt_2": "0",
//                             "level_lags_2": "68264",
//                             "level_3": "0",
//                             "level_expence_3": "0",
//                             "level_out_3": "0",
//                             "level_out_move_3": "0",
//                             "level_out_cnt_3": "0",
//                             "level_out_move_cnt_3": "0",
//                             "level_in_3": "0",
//                             "level_in_cnt_3": "0",
//                             "level_lags_3": "0"
//                         }
//                     ],
//                     "on_line": true,
//                     "fuelPositions": [],
//                     "lampsPositions": []
//                 }
//             ],
//             "error": 0,
//             "objConf": {
//                 "line_id": "1748",
//                 "id": "54818",
//                 "name": "XM_SBT MAN 847н",
//                 "vendor_server": "navigator",
//                 "state_number": "В 847 СС 186",
//                 "model": "MAN",
//                 "client": "СИБИТЕК АО",
//                 "vin": "",
//                 "uid": "861230043829960",
//                 "phone": "+79822201876",
//                 "category": "34",
//                 "parent_code": "51723",
//                 "install_time": "0",
//                 "lat": "60001686100000000",
//                 "lon": "71208511349999992",
//                 "alt": "57",
//                 "head": "197",
//                 "speed": "0",
//                 "pwr": "0",
//                 "bat": "0",
//                 "gearbox_name": "нет значения",
//                 "gearbox_cnt": "17",
//                 "gearbox_is_clutch": "0",
//                 "change_config_time": "1763138572",
//                 "last_time_vendor": "1764271203",
//                 "last_time_revision_begin": "1764257524",
//                 "last_time_revision_end": "1764257597",
//                 "last_time_aggregation": "1764269400",
//                 "task_get_positions_status": "success",
//                 "task_get_positions_task_add_time": "1764270403",
//                 "task_get_positions_task_start_time": "1764270504",
//                 "task_get_positions_query_begin": "1764178255",
//                 "task_get_positions_query_end": "1764273600",
//                 "task_get_positions_aggregate_begin": "1764183600",
//                 "task_get_positions_aggregate_end": "1764270000",
//                 "task_get_positions_file_name": "/var/www/html/server_part1_v2/src/cron/files/answers/id54818_1764270519_9646.txt",
//                 "task_calculate_status": "process",
//                 "task_calculate_task_add_time": "1764270519",
//                 "task_calculate_task_start_time": "1764271387",
//                 "task_calculate_heartbeat": "1764271388",
//                 "task_error_cnt": "0",
//                 "transmission_lock_0_name": "",
//                 "transmission_lock_1_name": "",
//                 "transmission_lock_2_name": "",
//                 "transmission_lock_3_name": "",
//                 "transmission_lock_4_name": "",
//                 "transmission_lock_5_name": "",
//                 "transmission_lock_6_name": "",
//                 "transmission_lock_7_name": "",
//                 "transmission_lock_8_name": "",
//                 "transmission_lock_9_name": "",
//                 "transmission_lock_10_name": "",
//                 "config": "{\"ign\":{\"p\":\"3\",\"max\":\"26.79999924\"},\"dist\":{\"p\":\"2\"},\"park\":{\"p\":\"1\",\"spd\":\"1\"},\"evnt\":[{\"tmin\":\"720\",\"msg\":\"ДУТ оключен\\/неисправен\",\"rule\":\"(cpmt10)>7\"},{\"id\":\"1\",\"m\":\"2\",\"tmin\":\"120\",\"msg\":\"ДВС работает ГЛОНАСС нет более 20 минут\",\"rule\":\"(cpmt9)>20\"},{\"id\":\"2\",\"m\":\"2\",\"tmin\":\"120\",\"msg\":\"Движение ТС без зажигания более 2 мин., нисправность или перевозка на трале\",\"rule\":\"(cpmt8)>2\"},{\"id\":\"3\",\"m\":\"3\",\"tmin\":\"120\",\"msg\":\"Перегорел предохранитель питания\",\"rule\":\"(adc1>1000&&pwr<1)&&(prev.adc1>1000&&prev.pwr<1)\"},{\"id\":\"4\",\"tmin\":\"60\",\"msg\":\"Неимпрпаномь ГЛОНАСС более 10 км.\",\"rule\":\"((((dist*1000)\\/ ((time-prev.time)*86400))*3.6)>200)&&(dist>10)\"}],\"eval\":[{\"p\":\"17039363\",\"fx\":\"x\\/10\",\"rule\":\"(p137&4095)\",\"nm\":\"01. Дисперсия т\"},{\"p\":\"17039363\",\"id\":\"1\",\"fx\":\"x\\/10\",\"rule\":\"((p137&16773120) \\/ 4096)\",\"nm\":\"02. Дисперсия к\"},{\"p\":\"17039363\",\"id\":\"2\",\"rule\":\"p138&2\",\"nm\":\"03. Топливо стабилизировано\"},{\"p\":\"17039363\",\"id\":\"3\",\"rule\":\"iif((pwr>13&& ((p106>0)&&(p106<2000))),p106\\/10-90,err)\",\"nm\":\"Угол крена\",\"dim\":\"градусы\"},{\"p\":\"17039363\",\"id\":\"4\",\"rule\":\"iif((pwr>13&& ((p105>0)&&(p105<2000))),p105\\/10-90,err)\",\"nm\":\"Угол тангажа\",\"dim\":\"градусы\"},{\"p\":\"17039363\",\"id\":\"5\",\"rule\":\"p208\",\"nm\":\"Обороты ДВС\"}],\"moto\":[{\"p\":\"5\",\"rule\":\"ign&&adc1>26000\"},{\"p\":\"5\",\"id\":\"2\",\"rule\":\"(spd>0&&spd<7)&&(cpe1>4||cpe2>4)\"},{\"p\":\"5\",\"id\":\"3\",\"rule\":\"spd>6&&(cpe1>5||cpe2>5)\"},{\"p\":\"5\",\"id\":\"4\",\"rule\":\"(cpe1>4||cpe2>4)\"},{\"p\":\"5\",\"id\":\"5\",\"rule\":\"cpe1>8||cpe2>8\"},{\"p\":\"2\",\"id\":\"6\",\"max\":\"26\"},{\"p\":\"5\",\"id\":\"7\",\"tmin\":\"120\",\"rule\":\"!ign&&spd>0\"},{\"p\":\"5\",\"id\":\"8\",\"tmin\":\"1380\",\"rule\":\"ign&&adc1>26000&&(((time-prev.time)*24*60)<11)&&(pos==0||gps<3)\"},{\"p\":\"5\",\"id\":\"9\",\"tmin\":\"420\",\"rule\":\"(pwr>12&&!(p102>0&&p102<4096))\"}],\"levl\":[{\"p\":\"734003203\",\"vol\":\"400\",\"avg\":\"1\",\"inp\":\"1.79999995\",\"outp\":\"1.79999995\",\"spt\":\"9\",\"spd\":\"9\",\"rule\":\"iif(pwr>10,p104,err)\",\"fx\":\"iif(x<4096,iif(x>0,tab(x,0,0,7,10,133,20,250,30,363,40,474,50,583,60,690,70,796,80,902,90,1008,100,1112,110,1217,120,1321,130,1426,140,1536,150,1628,160,1724,170,1824,180,1931,190,2034,200,2140,210,2242,220,2345,230,2448,240,2553,250,2655,260,2759,270,2861,280,2967,290,3060,300,3163,310,3271,320,3374,330,3483,340,3588,350,3699,360,3810,370,3923,380,4048,390,4095,400),err),err)\",\"mod\":\"MonAlgFuel171120? cpeknum_dispersion=1 & cpetnum_dispersion = 2  & cpek=4 & cpet=5 & anglestab=10 & jerksumm=150 & jerknorm=30 & bigpercent=7 & bigpercenttime=30 & lhinmax=10000&lhoutmax=1000 &  l=119 & w=77 & h=62 & left=43 & back=63\",\"nm\":\"Бак 400л. (по аналогии)\",\"gp\":\"1.Эксплуатация:\",\"st\":[{\"m\":\"32\",\"inp\":\"20\",\"outp\":\"20\",\"spt\":\"50\",\"spd\":\"90\"},{\"m\":\"16\",\"inp\":\"9\",\"outp\":\"9\",\"spt\":\"40\",\"spd\":\"100\"},{\"m\":\"64\",\"inp\":\"4\",\"outp\":\"4\",\"spt\":\"20\",\"spd\":\"50\"}]},{\"p\":\"717225987\",\"id\":\"1\",\"vol\":\"37535\",\"avg\":\"3\",\"inp\":\"1\",\"outp\":\"1\",\"spt\":\"10\",\"spd\":\"50\",\"rule\":\"iif(pwr>10,p102,err)\",\"fx\":\"iif(x<4096,iif(x>0,tab(x,0,0,4095,37535),err),err)\",\"nm\":\"Цистерна полуприцеп БЦМ-42.3 37535 литров\",\"gp\":\"1.Эксплуатация:\"},{\"p\":\"736100355\",\"id\":\"4\",\"avg\":\"1\",\"inp\":\"1\",\"outp\":\"1\",\"spt\":\"9\",\"spd\":\"9\",\"rule\":\"p127\",\"nm\":\"Температура ДУТ\",\"gp\":\"1.Эксплуатация:\"}],\"cntr\":[{\"p\":\"5\",\"max\":\"1\",\"rule\":\"((((dist*1000)\\/ ((time-prev.time)*86400))*3.6)>200)&&(dist>10)\"},{\"p\":\"5\",\"id\":\"1\",\"max\":\"1\",\"rule\":\"(((p212>>7)&31)==5)\"}],\"vars\":{\"tm\":\"1707728862\"}}\n"
//             },
//             "ts_in_park": 1,
//             "ts_with_dut": true,
//             "ts_in_work": true,
//             "ts_with_correct_dut": false
//         }
//     }
// ]);
const emit = defineEmits(['displayReport', 'close']);

// Data for the violation charts (chartContainer1 to chartContainer4)
const violationChartsData = ref([
  {
    id: 'dvs_cnt',
    title: 'ДВС',
    tooltipText: 'Тест текста подсказки для ДВС',
    ref: 'chartContainer1',
    info: {
      items: [
        {
          title: 'Превышение допустимых оборотов ДВС, более 2400 об/мин',
          description: 'за каждую секунду превышения фиксируется нарушение;',
          consequences: [
            'крутящий момент ДВС в околонулевой зоне, резко возрастает тепловая нагрузка на ДВС, повышенная нагрузка на пары трения цилиндро - поршневой группы (ЦПГ), повышенный угар масла, при перепробеге масла возможно образование задиров пар трения ЦПГ, навесные агрегаты приводимые от ДВС работают вне диапазона номинальных нагрузок;'
          ]
        },
        {
          title: 'Неэффективные обороты более 1900 при движении без применения моторного тормоза',
          description: 'за каждый факт превышения фиксируется нарушение;',
          consequences: [
            'крутящий момент развиваемый ДВС после 1900 об/мин идет на уменьшение, увеличивается тепловая нагрузка ДВС, увеличивается угар масла, значительно увеличивается расход топлива;'
          ]
        },
        {
          title: 'МКПП: Обороты ДВС при переключении передач менее 800 об/мин',
          description: '– за каждый факт фиксируется нарушение;',
          consequences: [
            'ДВС не развивает достаточный крутящий момент для уверенного движения ТС;',
            'чем ниже обороты ДВС, тем меньшее давление развивает масляный насос;',
            'работа ДВС под нагрузкой на пониженных оборотах способствуют образованию детонации;',
            'работа ДВС под нагрузкой на пониженных оборотах при пониженном давления масла приводит к повышенному износу ЦПГ ДВС;'
          ]
        },
        {
          title: 'При движении обороты ДВС опустились ниже 550 об/мин',
          description: '– за каждый факт фиксируется нарушение;',
          consequences: [
            'ДВС работает в условиях пониженного масляного давления, при работе под нагрузкой происходит повышенный износ ЦПГ, при перепробеге масла – возможно образование задиров пар трения в ЦПГ;',
            'работа ДВС под нагрузкой на пониженных оборотах способствуют образованию детонации;'
          ]
        },
        {
          title: 'Заглох при движении',
          description: '– за каждый факт начисляется нарушение;',
          consequences: [
            'работа ДВС под нагрузкой, в условиях недостаточного давления масла приводит к повышенному износу ЦПГ, при перепробеге масла - возможно образование задиров пар трения в ЦПГ;',
            'работа ДВС под нагрузкой на пониженных оборотах способствуют образованию детонации в ДВС;'
          ]
        },
        {
          title: 'Повышенные обороты ДВС при начале движения',
          description: '– за каждый факт оборотов ДВС более 1200 для МКПП и более 1400 для АКПП начисляется нарушение;',
          consequences: [
            'излишняя нагрузка на диски сцепления КПП, возможна ударная нагрузка на узлы трансмиссии ТС, при начале движения ТС рекомендуемые обороты ДВС 900 – 1100 об/мин;'
          ]
        }
      ]
    }
  },
  {
    id: 'transmission_cnt',
    title: 'ТРАНСМИССИЯ',
    tooltipText: 'Подсказка для трансмиссии',
    ref: 'chartContainer2',
    info: {
      items: [
        {
          title: 'Начало движения, лишняя работа сцепления',
          description: '- за каждый факт фиксируется нарушение;',
          consequences: [
            'при неправильно выбранной передаче КПП, например выборе 6 передачи вместо 3, происходит затяжная работа сцепления с повышенной нагрузкой, это приводит к повышенному износу дисков сцепления;'
          ]
        },
        {
          title: 'Начало движения, пережег сцепления, температура дисков сцепления 100 градусов и более',
          description: '- за каждые 5 секунд фиксируется нарушение;',
          consequences: [
            'при длительной пробуксовке под нагрузкой диски сцепления значительно нагреваются, при температуре дисков сцепления 100 градусов происходит повышенный износ фрикционного состава дисков сцепления, как правило, в салоне ТС при этом присутствует запах гари, при пережеге сцепления значительно снижается ресурс сцепления, возможно будет требоваться замена дисков сцепления;'
          ]
        },
        {
          title: 'Начало движения, правильный выбор передачи в КПП',
          description: '- за каждый факт не правильного выбора КПП при начале движения фиксируется нарушение;',
          consequences: [
            'Правильный выбор КПП для начала движения:',
            '- для МКПП: 1 или 3 передача;',
            '- для АКПП: передача не выше 4;',
            'Не правильный выбор КПП при начале движения увеличивает нагрузку на сцепление и коробку передач, сокращает безремонтный ресурс этих агрегатов;'
          ]
        },
        {
          title: 'Начало движения, переключение КПП с переднего на задний ход на скорости более 0 км/час',
          description: '- за каждый факт фиксируется нарушение;',
          consequences: [
            'перед переключением КПП с передней на заднюю передачу требуется полностью остановить ТС, переключение КПП с передней на заднюю передачу на скорости приводит к повышенной нагрузке на КПП;'
          ]
        },
        {
          title: 'Включение/выключение блокировок мостов/колес при скорости более 7 км/час или при нажатой педали газа',
          description: '– за каждый факт включения фиксируется нарушение;',
          consequences: [
            'включение/выключение внедорожных режимов трансмиссии на скорости более 7 км/час или при нажатой педали газа приводит к повышенному износу механизмов блокировок, сокращает безремонтный ресурс этих узлов;'
          ]
        },
        {
          title: 'Включение/выключение пониженной РКП при скорости более 0 км/час или при нажатой педали газа',
          description: '– за каждый факт фиксируется нарушение;',
          consequences: [
            'включение/выключение пониженной передачи в РКП на скорости или при нажатой педали газа приводит к повышенному износу механизмов РКП, сокращает безремонтный ресурс этого узла;'
          ]
        },
        {
          title: 'Движение с включенной межколесной блокировкой при скорости более 10 км/час',
          description: '– за каждый факт начисляется нарушение;',
          consequences: [
            'движение с включенной межколесной блокировкой на скорости более 10 км/час приводит к повышенным нагрузкам на межосевой дифференциал, возможен перегрев узла, при этом сокращается ресурс;'
          ]
        },
        {
          title: 'Работа дифференциалов мостов/колес при скорости 0 км/час',
          description: '– за каждые 5 секунд фиксируется нарушение;',
          consequences: [
            'возникает при вывешенном колесе и не включенных блокировках внедорожных режимов трансмиссии, ТС стоит на месте буксуя одним из колес на какой-либо оси;',
            'при длительном буксовании происходит перегрев дифференциалов, как следствие - потеря свойств масла трансмиссии, далее при эксплуатации ТС происходит повышенный износ дифференциалов;',
            'своевременное включение блокировок трансмиссии исключает работу дифференциалов при 0 км/час;'
          ]
        },
        {
          title: 'МКПП: движение с нажатой педалью сцепления',
          description: '– за каждые 10 секунд фиксируется нарушение;',
          consequences: [
            'приводит к повышенному износу привода сцепления, дисков сцепления, нарушение фиксирует вредный навык оставлять стопу на педали сцепления при движении ТС;'
          ]
        },
        {
          title: 'МКПП: движение с накатом на нейтральной передаче',
          description: '– за каждые 10 секунд фиксируется нарушение;',
          consequences: [
            'при движении накатом на нейтральной передаче нарушаются условия смазки валов МКПП;'
          ]
        },
        {
          title: 'Температура масла ретардера 130 и более градусов',
          description: '– за каждые 10 секунд фиксируется нарушение;',
          consequences: [
            'при температуре масла более 130 градусов происходит выгорание присадок масла, уменьшение антифрикционных свойств, это приводит к повышенному износу ретардера ТС;'
          ]
        }
      ]
    }
  },
  {
    id: 'kom_cnt',
    title: 'РАБОТА КОМ',
    tooltipText: 'Подсказка для КОМ',
    ref: 'chartContainer3',
    info: {
      items: [
        {
          title: 'Крен при работе КОМ >5 градусов',
          description: '- за каждый факт фиксируется нарушение;',
          consequences: [
            'опасность заваливания (опрокидывание) самосвала;'
          ]
        },
        {
          title: 'Движение с включенной КОМ самосвала',
          description: '- за каждый факт движения фиксируется нарушение, при длительном движении - за каждые 20 метров пробега фиксируется нарушение;',
          consequences: [
            'приводит к повышенному износу элементов привода КОМ;'
          ]
        },
        {
          title: 'Движение с поднятым кузовом',
          description: '– за каждые 10 метров фиксируется нарушение;',
          consequences: [
            'приводит к повышенной ударной и боковой нагрузке вызванной движением ТС на гидроцилиндры поднятия кузова;',
            'опасность ДТП, опрокидывания ТС или повреждения линий ЛЭП, дорожных конструкций поднятым кузовом;'
          ]
        },
        {
          title: 'Обороты ДВС более 1000 или менее 800 при работе КОМ самосвала',
          description: '– за каждые 10 секунд фиксируется нарушение;',
          consequences: [
            'при работе коробки отбора мощности вне диапазона ДВС 800 - 1000 об/мин нарушается смазка элементов привода КОМ;',
            'работа КОМ самосвала на оборотах ДВС более 1000 об/мин может привести к масляному голоданию и заклиниванию насоса КОМ;'
          ]
        }
      ]
    }
  },
  {
    id: 'bezop_cnt',
    title: 'СУММА НАРУШЕНИЙ',
    tooltipText: 'Сумма по ДВС, трансмиссии и работе КОМ',
    ref: 'chartContainer4'
  }
]);

// Dynamic refs for violation charts
const violationChartRefs = ref([]);

// Function to set chart refs dynamically
const setChartRef = (el, index) => {
  if (el) {
    violationChartRefs.value[index] = el;
  }
};

// Data for the malfunction charts (chartContainer5 to chartContainer8)
const malfunctionChartsData1 = ref([
  {
    id: 'sumRedLamp',
    title: 'КРАСНАЯ ЛАМПА',
    tooltipText: 'Количество срабатываний красной лампы',
    info: {
      items: [
        {
          title: 'Красная лампа',
          description: '– критическая неисправность, требуется остановка ТС для устранения неисправности;',
          consequences: []
        },
        {
          title: 'SPN',
          description: '- код неисправности в соответствии с CAN протоколом J1939;',
          consequences: []
        },
        {
          title: 'Адрес в сети CAN',
          description: '- типовые узлы и агрегаты ТС имеют заранее утвержденный адрес в сети CAN, по адресу определяется узел/агрегат ТС отправивший сообщение о неисправности;',
          consequences: []
        },
        {
          title: 'Время неисправности',
          description: '- общее время в течении которого фиксировалась неисправность узла/агрегата ТС;',
          consequences: []
        },
        {
          title: 'Доля неисправности, от времени работы ДВС',
          description: '- указывает стабильность неисправности, увеличение указывает на прогрессирующую поломку ТС;',
          consequences: []
        }
      ]
    }
  },
  {
    id: 'sumYellowLamp',
    title: 'ЖЁЛТАЯ ЛАМПА',
    tooltipText: 'Количество срабатываний жёлтой лампы',
    info: {
      items: [
        {
          title: 'Желтая лампа',
          description: '- незначительная неисправность, не требует немедленной остановки ТС, требуется плановая проверка/ремонт ТС;',
          consequences: []
        },
        {
          title: 'SPN',
          description: '- код неисправности в соответствии с CAN протоколом J1939;',
          consequences: []
        },
        {
          title: 'Адрес в сети CAN',
          description: '- типовые узлы и агрегаты ТС имеют заранее утвержденный адрес в сети CAN, по адресу определяется узел/агрегат ТС отправивший сообщение о неисправности;',
          consequences: []
        },
        {
          title: 'Время неисправности',
          description: '- общее время в течении которого фиксировалась неисправность узла/агрегата ТС;',
          consequences: []
        },
        {
          title: 'Доля неисправности, от времени работы ДВС',
          description: '- указывает стабильность неисправности, увеличение указывает на прогрессирующую поломку ТС;',
          consequences: []
        }
      ]
    }
  },
]);
const malfunctionChartsData2 = ref([
  {
    id: 'sumNonElectronic',
    title: 'Не связана с электрикой',
    tooltipText: 'Количество событий, не связанных с электроникой',
    info: {
      items: [
        {
          title: 'Не связана с электрикой',
          description: '- тип неисправности не связанный с электронной подсистемой, например температура охлаждающей жидкости двигателя превышает предписанный температурный диапазон;',
          consequences: []
        },
        {
          title: 'SPN',
          description: '- код неисправности в соответствии с CAN протоколом J1939;',
          consequences: []
        },
        {
          title: 'Адрес в сети CAN',
          description: '- типовые узлы и агрегаты ТС имеют заранее утвержденный адрес в сети CAN, по адресу определяется узел/агрегат ТС отправивший сообщение о неисправности;',
          consequences: []
        },
        {
          title: 'Время неисправности',
          description: '- общее время в течении которого фиксировалась неисправность узла/агрегата ТС;',
          consequences: []
        },
        {
          title: 'Доля неисправности, от времени работы ДВС',
          description: '- указывает стабильность неисправности, увеличение указывает на прогрессирующую поломку ТС;',
          consequences: []
        }
      ]
    }
  },
  {
    id: 'sumCo2Impact',
    title: 'Выбросы СО2',
    tooltipText: 'Количество событий выбросов СО2',
    info: {
      items: [
        {
          title: 'Выбросы СО2',
          description: '- тип неисправности, при котором увеличены выбросы СО2, как правило, при этом увеличивается расход топлива ТС;',
          consequences: []
        },
        {
          title: 'SPN',
          description: '- код неисправности в соответствии с CAN протоколом J1939;',
          consequences: []
        },
        {
          title: 'Адрес в сети CAN',
          description: '- типовые узлы и агрегаты ТС имеют заранее утвержденный адрес в сети CAN, по адресу определяется узел/агрегат ТС отправивший сообщение о неисправности;',
          consequences: []
        },
        {
          title: 'Время неисправности',
          description: '- общее время в течении которого фиксировалась неисправность узла/агрегата ТС;',
          consequences: []
        },
        {
          title: 'Доля неисправности, от времени работы ДВС',
          description: '- указывает стабильность неисправности, увеличение указывает на прогрессирующую поломку ТС;',
          consequences: []
        }
      ]
    }
  }
]);

// Dynamic refs for malfunction charts
const malfunctionChartRefs = ref([]);

// Function to set malfunction chart refs dynamically
const setMalfunctionChartRef = (el, index) => {
  if (el) {
    malfunctionChartRefs.value[index] = el;
  }
};

// Data for the work charts (chartContainer9 to chartContainer14)
const workChartsData = computed(() => {
  return [
  {
    id: 'on_line',
    title: 'Выход ТС на линию',
    tooltipText: 'Количество ТС на линии и процент выхода на линию',
    info: {
      items: [
        {
          title: 'Выход ТС на линию',
          description: '- ТС с пробегом более 10 км.;',
          consequences: [
            'определяется по формуле: число ТС вышедших на линию/число ТС в парке *100% ;'
          ]
        }
      ]
    }
  },
  {
    id: 'distance',
    title: 'Среднесуточный пробег ТС, км.',
    tooltipText: 'Среднесуточный пробег и средняя скорость ТС',
    info: {
      items: [
        {
          title: 'В расчет среднесуточного пробега берутся ТС с пробегом более 10 км.',
          description: '',
          consequences: [
            'определяется по формуле: суммарный пробег по CAN данным всех ТС вышедших на линию/общее число ТС вышедших на линию;'
          ]
        },
        {
          title: 'Средняя скорость определяется по тем ТС, у которых пробег более 10 км.',
          description: '',
          consequences: [
            'определяется по формуле: суммарный пробег по CAN данным всех ТС/общее время движения всех ТС;'
          ]
        }
      ]
    }
  },
  {
    id: 'fuel_volume',
    title: groupingType.value === 'day' ? 'Расход топлива по парку, литров' : 'Расход топлива по парку, тысяч литров',
    tooltipText: 'Суммарный расход топлива и суммарный расход в движении',
    info: {
      items: [
        {
          title: 'Суммарный расход по CAN данным всех ТС с пробегом более 10 ти км.',
          description: '',
          consequences: []
        }
      ]
    }
  },
  {
    id: 'fuel_consumption',
    title: 'Средний расход топлива л/100 км.',
    tooltipText: 'Средний расход топлива на 100 км и средний расход топлива на 100 км в движении',
    info: {
      items: [
        {
          title: 'В расчет среднего расхода л/100 км. берутся ТС с пробегом более 10 ти. км',
          description: '',
          consequences: [
            'определяется по формуле: суммарный расход топлива по CAN данным всех ТС/общий пробег по CAN данным всех ТС * 100;'
          ]
        }
      ]
    }
  },
  {
    id: 'engine_time',
    title: 'Время работы ДВС',
    tooltipText: 'Время работы двигателя в общем и в движении',
    info: {
      items: [
        {
          title: 'В расчет времени работы ДВС берутся все ТС не зависимо от пробега',
          description: '',
          consequences: [
            'определяется по формуле: суммарное время работы ДВС всех ТС/общее число ТС с работающим ДВС;'
          ]
        }
      ]
    }
  },
  {
    id: 'fuel_out',
    title: groupingType.value === 'day' ? 'Объем сливов, литров' : 'Объем сливов, тысяч литров',
    tooltipText: 'Общий объем сливов топлива',
    info: {
      items: [
        {
          title: 'Слив топлива из бака ТС',
          description: '- уменьшение уровня топлива со скоростью превышающей расход топлива двигателя ТС;',
          consequences: [
            'Датчик уровня топлива (ДУТ) дополнительно устанавливаемый в бак ТС производит самодиагностику неисправностей: целостность кабеля, наличие посторонних примесей в баке ТС (грязь, вода), исправность измерительной части ДУТ, при исправности менее 99 % требуется дополнительная проверка на факт наличия слива обслуживающей компанией;'
          ]
        }
      ]
    }
  }
  ];
});

// Dynamic refs for work charts
const workChartRefs = ref([]);

// Function to set work chart refs dynamically
const setWorkChartRef = (el, index) => {
  if (el) {
    workChartRefs.value[index] = el;
  }
};
const now2 = new Date();
const dateRange = ref([new Date(now2.getFullYear(), now2.getMonth(), now2.getDate() - 7), new Date(now2.getFullYear(), now2.getMonth(), now2.getDate())]);
const showRefreshButton = ref(false);

const groupingType2 = ref('day');

const groupingTypeOptions = [
  { value: 'day', text: 'дни' },
  { value: 'week', text: 'недели' },
  { value: 'month', text: 'месяц' },
  { value: 'quarter', text: 'квартал' },
  { value: 'season', text: 'сезон года' },
];

const groupingType = computed({
  get: () => {
    // return 'month';
    if (testData.value && testData.value.length > 0 && testData.value[0].data.type) {
      groupingType2.value = testData.value[0].data.type;
      return testData.value[0].data.type;
    }
    return 'month'; // default fallback
  },
  set: (value) => {
    // If you need to update the type in the first testData object, do it here
    groupingType2.value = value;
  }
});

const selectedTableType = ref('none');

const selectedTableTypeOptions = [
  { value: 'none', text: 'не указано' },
  { value: 'dvs_cnt', text: 'грубые нарушения ДВС' },
  { value: 'transmission_cnt', text: 'грубые нарушения трансмиссии' },
  { value: 'kom_cnt', text: 'грубые нарушения КОМ' },
  { value: 'bezop_cnt', text: 'сумма нарушений' },
  { value: 'fuel_out', text: 'сливы' },
];

// Function to handle date changes
const onDateChange = () => {
  showRefreshButton.value = true;
};

// Function to handle grouping changes
const onGroupingChange = () => {
  showRefreshButton.value = true;

  setDateRangeByGroupingType();

  const fakeEvent = { ctrlKey: false, metaKey: false };
  executeVehicleReport(fakeEvent);
};

// Вспомогательная функция для установки dateRange в зависимости от типа группировки
const setDateRangeByGroupingType = () => {
  const now = new Date();
  
  if (groupingType2.value === 'day') {
    // [за 7 дней до 00:00 этой ночи, 00:00 этой ночи]
    const tonightMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
    const sevenDaysBefore = new Date(tonightMidnight.getTime() - 7 * 24 * 60 * 60 * 1000);
    dateRange.value = [sevenDaysBefore, tonightMidnight];
  } else if (groupingType2.value === 'week') {
    // [за 4 недели до 00:00 понедельника этой недели, 00:00 понедельника этой недели]
    const dayOfWeek = now.getDay(); // 0 - воскресенье, 1 - понедельник, ...
    const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Смещение до понедельника
    const thisMondayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + mondayOffset, 0, 0, 0);
    const fourWeeksBefore = new Date(thisMondayMidnight.getTime() - 4 * 7 * 24 * 60 * 60 * 1000);
    dateRange.value = [fourWeeksBefore, thisMondayMidnight];
  } else if (groupingType2.value === 'month') {
    // [за 4 месяца до 00:00 1 числа этого месяца, 00:00 1 числа этого месяца]
    const firstDayThisMonth = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
    const firstDayFourMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 4, 1, 0, 0, 0);
    dateRange.value = [firstDayFourMonthsAgo, firstDayThisMonth];
  } else if (groupingType2.value === 'quarter') {
    // [за 4 квартала до 00:00 начала текущего квартала, 00:00 начала текущего квартала]
    const currentMonth = now.getMonth(); // 0-11
    const currentQuarter = Math.floor(currentMonth / 3); // 0, 1, 2, 3
    const firstMonthOfQuarter = currentQuarter * 3; // 0, 3, 6, 9
    const firstDayThisQuarter = new Date(now.getFullYear(), firstMonthOfQuarter, 1, 0, 0, 0);
    
    // 4 квартала назад = 12 месяцев назад
    const firstDayFourQuartersAgo = new Date(now.getFullYear(), firstMonthOfQuarter - 12, 1, 0, 0, 0);
    dateRange.value = [firstDayFourQuartersAgo, firstDayThisQuarter];
  } else if (groupingType2.value === 'season') {
    // [за 4 сезона до 1 числа текущего сезона, 1 число текущего сезона]
    // Зима: декабрь (11), январь (0), февраль (1) - с 1 декабря по конец февраля
    // Весна: март (2), апрель (3), май (4) - с 1 марта по конец мая
    // Лето: июнь (5), июль (6), август (7) - с 1 июня по конец августа
    // Осень: сентябрь (8), октябрь (9), ноябрь (10) - с 1 сентября по конец ноября
    const currentMonth = now.getMonth(); // 0-11
    
    let currentSeasonStartMonth;
    if (currentMonth === 11 || currentMonth === 0 || currentMonth === 1) {
      // Зима - начинается в декабре предыдущего года
      currentSeasonStartMonth = 11; // Декабрь
    } else if (currentMonth >= 2 && currentMonth <= 4) {
      // Весна - начинается в марте
      currentSeasonStartMonth = 2; // Март
    } else if (currentMonth >= 5 && currentMonth <= 7) {
      // Лето - начинается в июне
      currentSeasonStartMonth = 5; // Июнь
    } else {
      // Осень - начинается в сентябре
      currentSeasonStartMonth = 8; // Сентябрь
    }
    
    // 1 число текущего сезона
    const firstDayThisSeason = new Date(now.getFullYear(), currentSeasonStartMonth, 1, 0, 0, 0);
    
    // 4 сезона назад = 12 месяцев назад
    const firstDayFourSeasonsAgo = new Date(now.getFullYear(), currentSeasonStartMonth - 12, 1, 0, 0, 0);
    dateRange.value = [firstDayFourSeasonsAgo, firstDayThisSeason];
  }
};

const onGrouping3Change = () => {
  // Сбрасываем сортировку и подробную таблицу при переключении между графиками
  sortColumn.value = null;
  sortDirection.value = 'asc';
  showDetailedTable.value = false;
  selectedVehicle.value = null;
  
  showViolationPanel.value = false;
  if (selectedTableType.value === 'none') {
    // Удаляем все слои с карты
  if (heatLayer.value) {
    heatmap.value.removeLayer(heatLayer.value);
  }
  if (markerLayer.value) {
    heatmap.value.removeLayer(markerLayer.value);
  }
    return;
  }
    // Загружаем данные для отображения на карте
  loadMapData(selectedTableType.value);

  selectedTableType.value = selectedTableType.value;
};

const heatmap = ref(null);

// Кэш для хранения данных о точках на карте
const mapDataCache = ref({});

// Отдельный кэш для детальных данных по сливам (по одному объекту)
const fuelOutDetailsCache = ref({});

// Типы нарушений, соответствующие типам в API
const violationTypeMapping = {
  'dvs_cnt': 'dvs',
  'transmission_cnt': 'transmission',
  'kom_cnt': 'kom',
  'bezop_cnt': 'bezop',
  'fuel_out': 'fuel_out'
};

// Состояния для отслеживания прогресса загрузки
const progressLoaded = ref(0);
const progressTotal = ref(0);

const loadMapData = async (type, skipMapUpdate = false) => {
  // Преобразуем тип нарушения к формату, используемому в API
  const apiType = violationTypeMapping[type];

  if (!apiType) {
    console.error('Неизвестный тип нарушения:', type);
    return;
  }

  // Проверяем, есть ли данные в кэше
  if (mapDataCache.value[apiType]) {
    // Используем закэшированные данные
    updateMapWithPositions(mapDataCache.value[apiType], apiType);
    return;
  }

  // Если данных нет в кэше, делаем запрос к серверу
  try {
    loading.value = true;

    // Собираем ID всех объектов из testData
    const objectIds = [];
    if (testData.value && testData.value.length > 0) {
      objectIds.push(...testData.value.map(item => item.data?.objConf?.id).filter(id => id));
    }

    if (objectIds.length === 0) {
      console.warn('Нет доступных ID объектов для запроса');
      return;
    }

    // Создадим общий объект для хранения всех позиций
    const allPositions = [];
    let combinedObjConf = {};
    let combinedIntervalBegin = null;
    let combinedIntervalEnd = null;
    let combinedType = apiType;

    // Для fuel_out (индекс 4) используем особую логику запроса
    const isFuelOut = type === 'fuel_out';

    if (isFuelOut) {
      // Для fuel_out отправляем запросы синхронно, по одному, с ids до 50 объектов
      const BATCH_SIZE = 50;
      progressTotal.value = Math.ceil(objectIds.length / BATCH_SIZE);
      progressLoaded.value = 0;

      for (let i = 0; i < objectIds.length; i += BATCH_SIZE) {
        const batch = objectIds.slice(i, i + BATCH_SIZE);
        const idsParam = batch.join(',');

        const params = new URLSearchParams({
          ids: idsParam, // массив ID объектов через запятую
          time_begin: Math.floor(dateRange.value[0] / 1000), // Начальное время в секундах
          time_end: Math.floor(dateRange.value[1] / 1000), // Конечное время в секундах
          tzh: getTzh(), // Часовой пояс
          type: apiType // Тип нарушений
        });

        try {
          const data = await fetchJson((process.env.VUE_APP_BACKEND_URL || window.location.origin) + `/Api/getDashboardMapPositions?${params}`);
          console.log('Ответ для fuel_out (batch', i, '-', i + batch.length, '):', data);

          progressLoaded.value++;

          // Обрабатываем данные
          if (data && data.posArray && Array.isArray(data.posArray)) {
            allPositions.push(...data.posArray);
          }
          if (data && data.objConf) {
            combinedObjConf = { ...data.objConf };
          }
          if (data && data.interval_begin !== undefined) {
            if (combinedIntervalBegin === null || data.interval_begin < combinedIntervalBegin) {
              combinedIntervalBegin = data.interval_begin;
            }
          }
          if (data && data.interval_end !== undefined) {
            if (combinedIntervalEnd === null || data.interval_end > combinedIntervalEnd) {
              combinedIntervalEnd = data.interval_end;
            }
          }
        } catch (e) {
          console.error(`Ошибка при запросе данных для fuel_out (batch ${i}):`, e);
        }
      }
    } else {
      // Для остальных типов - скользящее окно по 3 запроса параллельно
      progressTotal.value = objectIds.length;
      progressLoaded.value = 0;

      // Функция для выполнения одного запроса
      const fetchForObject = async (objectId) => {
        const params = new URLSearchParams({
          id: objectId, // id текущего объекта из testData
          time_begin: Math.floor(dateRange.value[0] / 1000), // Начальное время в секундах
          time_end: Math.floor(dateRange.value[1] / 1000), // Конечное время в секундах
          tzh: getTzh(), // Часовой пояс
          type: apiType // Тип нарушений
        });

        // Выполняем запрос к API
        let data = false;
        try {
          data = await fetchJson((process.env.VUE_APP_BACKEND_URL || window.location.origin) + `/Api/getDashboardMapPositions?${params}`);
        } catch (e) {
          console.error(`Ошибка при запросе данных для объекта ${objectId}:`, e);
          return null; // Возвращаем null в случае ошибки
        }

        progressLoaded.value++;

        return data;
      };

      // Ограничиваем количество одновременных запросов до 3
      // Используем "скользящее окно": как только один запрос завершается, сразу запускается следующий
      const MAX_CONCURRENT_REQUESTS = 3;
      const results = [];
      let currentIndex = 0;

      const runNextRequest = async () => {
        while (currentIndex < objectIds.length) {
          const currentIndexToFetch = currentIndex++;
          const objectId = objectIds[currentIndexToFetch];
          const result = await fetchForObject(objectId).catch(err => {
            console.error('Ошибка при выполнении запроса:', err);
            return null;
          });
          results.push({ status: result !== null ? 'fulfilled' : 'rejected', value: result });
        }
      };

      // Запускаем MAX_CONCURRENT_REQUESTS параллельных "потоков"
      const concurrentPromises = Array.from({ length: Math.min(MAX_CONCURRENT_REQUESTS, objectIds.length) }, () => runNextRequest());
      await Promise.all(concurrentPromises);

      // Обрабатываем результаты
      for (const result of results) {
        if (result.status === 'fulfilled' && result.value) {
          const data = result.value;

          // Добавляем позиции из ответа к общему списку
          if (data.posArray && Array.isArray(data.posArray)) {
            allPositions.push(...data.posArray);
          }

          if (data.objConf) {
            combinedObjConf = { ...data.objConf };
          }

          if (data.interval_begin !== undefined) {
            if (combinedIntervalBegin === null || data.interval_begin < combinedIntervalBegin) {
              combinedIntervalBegin = data.interval_begin;
            }
          }

          if (data.interval_end !== undefined) {
            if (combinedIntervalEnd === null || data.interval_end > combinedIntervalEnd) {
              combinedIntervalEnd = data.interval_end;
            }
          }
        } else if (result.status === 'rejected') {
          console.error('Ошибка при выполнении запроса:', result.reason);
        }
      }
    }

    // Создаем результирующий объект с объединенными данными
    const combinedData = {
      posArray: allPositions,
      error: 0, // Предполагаем, что ошибок нет, если хотя бы один запрос успешен
      objConf: combinedObjConf,
      interval_begin: combinedIntervalBegin,
      interval_end: combinedIntervalEnd,
      type: combinedType
    };

    // Сохраняем объединенные данные в кэш
    mapDataCache.value[apiType] = combinedData;

    console.log('loadMapData: данные сохранены в кэш для', apiType, {
      posArrayLength: combinedData.posArray?.length || 0,
      firstItem: combinedData.posArray?.[0]
    });

    if (!skipMapUpdate) {
      // Обновляем карту с объединенными данными
      updateMapWithPositions(combinedData, apiType);
    }
    
  } catch (error) {
    console.error('Ошибка при загрузке данных для карты:', error);
  } finally {
    loading.value = false;
    // Сбрасываем значения прогресса
    progressTotal.value = 0;
    progressLoaded.value = 0;
  }
};

// Функция для обновления карты с полученными позициями
const updateMapWithPositions = (data, apiType = '') => {
  
  // Убедимся, что карта инициализирована
  if (!heatmap.value) {
    console.error('Карта не инициализирована');
    return;
  }

  // Удалим предыдущие слои
  if (heatLayer.value) {
    heatmap.value.removeLayer(heatLayer.value);
  }
  if (markerLayer.value) {
    heatmap.value.removeLayer(markerLayer.value);
  }

  const positions = data.posArray || [];

  const latLonDelimeter = 1000000000000000;

  let dataPoints
  // Подготовим данные для тепловой карты в формате [lat, lng, intensity]
  if (apiType == 'fuel_out') {
    dataPoints = positions.map(pos => {
      let lat = parseFloat(pos.lat) / latLonDelimeter;
      let lon = parseFloat(pos.lon) / latLonDelimeter;
      // Интенсивность = 1 для каждой точки
      return [lat, lon, 1];
    });
  } else {
    dataPoints = positions.map(pos => {
      let lat = parseFloat(pos.lt);
      let lon = parseFloat(pos.ln);
      let intencity = Number(pos?.i || 0.1);
      return [lat, lon, intencity];
    });
  }
  
  const dataPoints2 = dataPoints;

  console.log('dataPoints count:', dataPoints2.length, 'dataPoints:', dataPoints2);

  // Создаем и добавляем новый heatLayer
  heatLayer.value = L.heatLayer(dataPoints2, {
    radius: 20,
    blur: 15,
    maxZoom: 17,
    minOpacity: 0.4,
    gradient: {
      0.1: 'blue',
      0.2: 'lime',
      0.3: 'red',
    }
  }).addTo(heatmap.value);

  // Центрируем карту по середине всех точек heatmap
  if (dataPoints2.length > 0) {
    const bounds = L.latLngBounds(dataPoints2.map(p => [p[0], p[1]]));
    heatmap.value.fitBounds(bounds.pad(0.1));
  }
};

// const getHeatmapData = () => {
//   const heatmapPoints = [
//   // [50.5, 30.5, 1],
// 	// [50.6, 30.5, 1],
//   // [50.6, 30.4, 1],
// ];

//   const dataPoints = [
//       [50.880509986, -114.081560859],
//       [50.880509986, -114.081560859],
//       [50.880509986, -114.081560859],
//       [44.53666687, -64.243164062],
//       [44.639999389, -63.613998413],
//       [44.676998138, -63.612499237],
//       [44.679332733, -63.610500335],
//       [50.970165252, -114.06916809],
//       [34.104833333, -118.323],
//       [50.579812463, -113.872800754],
//       [51.055080414, -114.056716919],
//       [44.648111204, -63.577139396],
//       [44.642322778, -63.579243422],
//       [44.643284609, -63.568868637],
//       [44.64246, -63.578947],
//       [44.718542104, -63.683588477],
//       [44.718418471, -63.683593422],
//       [44.718461344, -63.683637427],
//       [44.718412771, -63.683782686],
//       [44.718390978, -63.683674224],
//       [44.718426894, -63.683400638],
//       [44.718389102, -63.683563615],
//       [44.643199507, -63.568366686],
//       [44.718326605, -63.683847729],
//       [44.7157814, -63.686402518],
//       [44.718411484, -63.683636892],
//       [44.718421013, -63.683612197],
//       [44.718408703, -63.683583046],
//       [44.718479198, -63.683512285],
//       [44.718442462, -63.683621787],
//       [44.70944854, -63.693567955],
//       [44.718409395, -63.683602933],
//       [44.718338801, -63.684254335],
//       [44.718401488, -63.683540924],
//       [44.718386997, -63.683626363],
//       [44.718386997, -63.683626363],
//       [44.718386997, -63.683626363],
//       [44.717759553, -63.677263503],
//       [44.642686, -63.578319],
//       [44.718392151, -63.683523433],
//       [44.718386997, -63.683626363],
//       [44.718355229, -63.683762904],
//       [44.718500027, -63.683851836],
//       [44.718399905, -63.683797438],
//       [44.718426224, -63.683320424],
//       [44.647744146, -63.575160526],
//       [44.642261709, -63.579683304],
//       [44.649856, -63.586578],
//       [44.647437, -63.580284],
//       [44.718402168, -63.683638014],
//       [44.718503631, -63.68352226],
//       [44.718453507, -63.683740692],
//       [44.718406694, -63.683453947],
//       [44.718592538, -63.683768395],
//       [44.718500529, -63.68364891],
//       [44.718374717, -63.683847142],
//       [44.718296221, -63.683787212],
//       [44.718322533, -63.683521553],
//       [44.718461344, -63.683620161],
//       [44.718429676, -63.683640406],
//       [44.71843339, -63.683663914],
//       [44.718477647, -63.683813028],
//       [44.718398396, -63.683542209],
//       [44.718504084, -63.683465428],
//       [44.718575212, -63.683621166],
//       [44.718387784, -63.683589918],
//       [44.718244917, -63.683892581],
//       [44.718385838, -63.683624545],
//       [44.718397606, -63.683539988],
//       [44.718408668, -63.683616944],
//       [44.718401751, -63.683572637],
//       [44.718407164, -63.683572267],
//       [44.718424391, -63.683666915],
//       [44.718339513, -63.683889806],
//       [44.718404213, -63.683593903],
//       [44.718376712, -63.683603459],
//       [44.718365334, -63.683625158],
//       [44.718406172, -63.683623469],
//       [44.718357136, -63.683653095],
//       [44.71841303, -63.683625434],
//       [44.718367131, -63.683636757],
//       [44.718337501, -63.683804059],
//       [44.718377546, -63.683478126],
//       [44.718491649, -63.68370368],
//       [44.718393032, -63.683595266],
//       [44.718385449, -63.683592853]
//   ];

//   const count = 30000;

//   // Генерируем 30000 дополнительных точек
//   const additionalPoints = Array.from({ length: count }, () => {
//       const p = dataPoints[Math.floor(Math.random() * dataPoints.length)];
//       const noise = 0.0001; // степень разброса
//       return [
//           p[0] + (Math.random() - 0.5) * noise,
//           p[1] + (Math.random() - 0.5) * noise
//       ];
//   });

//   // return [...dataPoints, ...additionalPoints];
//   return heatmapPoints;
// };

const callback = (data) => {
    data = data.map((obj) => ({ ...obj, data: JSON.parse(obj.data) }));
    emit('displayReport', { data, areaId: props.areaId });
};

// Методы для модального окна выбора ТС
const openSelectModal = () => {
  showSelectModal.value = true;
};

const applyTsSelection = (selectedIds) => {
  selectedTsListSync.value = selectedIds;
};

function setStatusText(text) {
  const targetElement = document.querySelector('#vehicle-dashboard-get-template-button-test .target-show-span');
  if (targetElement) {
    targetElement.textContent = text;
  }
}

function checkConditions() {
  let [start, end] = dateRange.value;

  start = Math.floor(start / 1000);
  end = Math.floor(end / 1000);
  
  // Проверяем, выбраны ли объекты
  if (selectedTsListSync.value.length === 0) {
    setStatusText('Не выбран ни один объект.');
    return false;
  }

  // Проверяем, выбраны ли объекты
  // if (!props.form_desc?.objects || props.form_desc.objects.length === 0) {
  //   setStatusText('Не выбран ни один объект.');
  //   return false;
  // }

  // Validation 1: End date must be after start date
  if (end <= start) {
    setStatusText('Конечная дата должна быть позже начальной.');
    return false;
  }

  // Validation 2-5: Grouping-specific range checks
  const timeDiff = end - start;
  const maxDayDiff = 7 * 24 * 60 * 60; // 7 days in s
  const maxWeekDiff = 7 * maxDayDiff; // 49 days in s

  switch (groupingType2.value) {
    case 'day':
      if (timeDiff > maxDayDiff) {
        setStatusText('Промежуток времени не должен превышать 7 дней.');
        // errorText.value = 'Промежуток времени не должен превышать 7 дней.';
        return false;
      }
      break;
    case 'week':
      if (timeDiff > maxWeekDiff) {
        setStatusText('Промежуток времени не должен превышать 49 дней.');
        // errorText.value = 'Промежуток времени не должен превышать 49 дней.';
        return false;
      }
      break;
    case 'month':
    case 'season':
    case 'quarter':
      const maxDate = new Date(start * 1000);
      const minDate = new Date(end * 1000);
      maxDate.setFullYear(maxDate.getFullYear() + 1); // Exactly 12 months later
      if (minDate > maxDate) {
        let unit;
        if (groupingType2.value === 'month') {
          unit = '12 месяцев';
        } else if (groupingType2.value === 'season') {
          unit = '4 сезона (12 месяцев)';
        } else {
          unit = '4 квартала (12 месяцев)';
        }
        setStatusText(`Промежуток времени не должен превышать ${unit} для текущей группировки.`);
        errorText.value = `Промежуток времени не должен превышать ${unit} для текущей группировки.`;
        return false;
      }
      break;
  }

  return true
}

// Функция выполнения отчета (аналогично DiagnosticsSidebar)
const hasError = ref(false);
const lastErrorMessage = ref('');

const executeVehicleReport = (e) => {

  hasError.value = false;
  lastErrorMessage.value = '';
  setStatusText('');

  const isCtrlPressed = e.ctrlKey; // true, если нажат Ctrl (или Cmd на Mac)
  const isMetaPressed = e.metaKey; // для Mac (Cmd)

  const offset = '5';
  const beginTime = (dateRange.value[0].getTime() / 1000).toString();
  const endTime = (dateRange.value[1].getTime() / 1000).toString();
  const areaId = '#section-violations';
  const formId = 'vehicle-dashboard-form';
  const buttonId = 'vehicle-dashboard-get-template-button-test';

  const type = groupingType2.value;

  const listLastTimeAggregation = {};

  for (const id of selectedTsListSync.value) {
    if (globalObjectsList[id]) {
      listLastTimeAggregation[id] = globalObjectsList[id].last_time_aggregation;
    }
  }

  globalObjects.nodeSettings = {
    isCtrlPressed: isCtrlPressed || isMetaPressed,
    listLastTimeAggregation,
    login: userData?.user?.login,
    VueLoadingProcess: (message) => {
      if (hasError.value) {
        setStatusText(lastErrorMessage.value);
        return;
      }
      console.log('Loading process:', message);
      setStatusText(message);
    },
    VueErrorHandler: (errorMessage) => {
      console.error('Error handler:', errorMessage);
      hasError.value = true;
      lastErrorMessage.value = errorMessage;
      isRequestingReport.value = false;
      setStatusText(errorMessage);
    }
  };

  const data = {
    objects: [...selectedTsListSync.value],
    beginTime: beginTime,
    endTime: endTime,
    timeOffset: offset,
    buttonId,
    areaId,
    formId,
    type,
  };

  if (!checkConditions()) {
    isRequestingReport.value = false;
    return
  }
  isRequestingReport.value = true;

  objectsListFormSubmit('vehicle_dashboard', data);
};

// Function to refresh the data - calls the template submit function
const refreshData = () => {
  errorText.value = ''; // Clear previous errors
  setStatusText('');

  const [start, end] = dateRange.value;

  // Проверяем, выбраны ли объекты
  if (!props.form_desc?.objects || props.form_desc.objects.length === 0) {
    isRequestingReport.value = false;
    setStatusText('Не выбран ни один объект.');
    return;
  }

  // Validation 1: End date must be after start date
  if (end <= start) {
    isRequestingReport.value = false;
    setStatusText('Конечная дата должна быть позже начальной.');
    return;
  }

  // Validation 2-5: Grouping-specific range checks
  const timeDiff = end - start;
  const maxDayDiff = 7 * 24 * 60 * 60 * 1000; // 7 days in ms
  const maxWeekDiff = 7 * maxDayDiff; // 49 days in ms

  switch (groupingType2.value) {
    case 'day':
      if (timeDiff > maxDayDiff) {
        isRequestingReport.value = false;
        setStatusText('Промежуток времени не должен превышать 7 дней.');
        // errorText.value = 'Промежуток времени не должен превышать 7 дней.';
        return;
      }
      break;
    case 'week':
      if (timeDiff > maxWeekDiff) {
        isRequestingReport.value = false;
        setStatusText('Промежуток времени не должен превышать 49 дней.');
        // errorText.value = 'Промежуток времени не должен превышать 49 дней.';
        return;
      }
      break;
    case 'month':
    case 'season':
    case 'quarter':
      const maxDate = new Date(start);
      maxDate.setFullYear(start.getFullYear() + 1); // Exactly 12 months later
      if (end > maxDate) {
        let unit;
        if (groupingType2.value === 'month') {
          unit = '12 месяцев';
        } else if (groupingType2.value === 'season') {
          unit = '4 сезона (12 месяцев)';
        } else {
          unit = '4 квартала (12 месяцев)';
        }
        isRequestingReport.value = false;
        setStatusText(`Промежуток времени не должен превышать ${unit} для текущей группировки.`);
        errorText.value = `Промежуток времени не должен превышать ${unit} для текущей группировки.`;
        return;
      }
      break;
  }

  // Proceed with data refresh if validations pass
  showRefreshButton.value = false;
  errorText.value = '';
  setStatusText('');
  
  // Сбрасываем кэш карты и детальный кэш сливов при обновлении данных, т.к. данные устаревают
  mapDataCache.value = {};
  fuelOutDetailsCache.value = {};
  
  const updatedFormDesc = {
    ...props.form_desc,
    beginTime: start.getTime(),
    endTime: end.getTime(),
    objects: props.form_desc?.objects || [],
  };

  const groupingTypeForSubmit = groupingType2.value
  const state = vehicleDashboard_template.submit(updatedFormDesc, groupingTypeForSubmit, callback);
  if (state === 'error') {
    console.error('Error submitting vehicle dashboard report');
  }
};

watch(() => props.data, () => {
  console.log("props.data", props.data);

  // Сбрасываем isRequestingReport при получении ответа (успешного или с ошибкой)
  isRequestingReport.value = false;

  if (Highcharts) {
    nextTick(() => {
      initCharts();
    });
  }
}, { deep: true });

const getStartTime = () => {
  if (!props.data) return;
  const lastData = props.data?.data;
  if (!Array.isArray(lastData) || lastData.length < 1) return;

  // Находим элемент с максимальной длиной posArray
  const itemWithMaxPosArray = lastData.reduce((maxItem, currentItem) => {
    const currentLength = currentItem?.data?.posArray?.length || 0;
    const maxLength = maxItem?.data?.posArray?.length || 0;
    return currentLength > maxLength ? currentItem : maxItem;
  }, null);

  // Если не нашли подходящего элемента или posArray пуст
  if (!itemWithMaxPosArray?.data?.posArray?.length) return;

  const firstPos = itemWithMaxPosArray.data.posArray[0];
  const lastTime = firstPos?.interval_begin;
  if (lastTime == null) return;

  return formatTimeHelper2(new Date(lastTime * 1000), false);
};

function calculateTsHeaderData(type) {
  let res = 0
  for (const item of testData.value) {
    if (item.data[type]) {
      res++
    }
  }

  return res
}

const calculateSumData = (fieldName) => {
  if (!testData.value || testData.value.length === 0) {
    return { categories: [], data: [] };
  }

  // Find all unique intervals across all users
  const intervalsMap = new Map();

  testData.value.forEach(user => {
    if (user.data && user.data.posArray) {
      user.data.posArray.forEach(interval => {
        const beginTime = interval.interval_begin;
        const beginDate = new Date(beginTime * 1000);
        const day = String(beginDate.getDate()).padStart(2, '0');
        const month = String(beginDate.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const dateStr = `${day}.${month}`;

        if (!intervalsMap.has(beginTime)) {
          intervalsMap.set(beginTime, {
            dateStr: dateStr,
            intervalBegin: beginTime, // Store the beginning timestamp
            intervalEnd: interval.interval_end, // Store the ending timestamp
            totalValue: 0,      // sum for all fields
            columnVal: 0,       // count of non-zero values for specific fields
            userCount: 0,       // count of users with non-zero values for specific fields
            actualValue: 0,     // calculated value for specific fields that will be formatted with formatSecondsToHHMM
            sumFieldValues: 0,    // sum to store field values for qualifying intervals
            sumDistanceValues: 0  // sum to store distance values for qualifying intervals
          });
        }

        // Check if the interval qualifies based on sum_distance > minDistance
        const sumDistance = interval.sumPositions?.sum_distance || 0;

        // For specified fields (dvs_cnt, transmission_cnt, kom_cnt, bezop_cnt),
        // only process if sum_distance > minDistance
        if (['dvs_cnt', 'transmission_cnt', 'kom_cnt', 'bezop_cnt'].includes(fieldName)) {
          if (sumDistance > minDistance) {
            const currentValue = interval.sumPositions[fieldName];
            const currentInterval = intervalsMap.get(beginTime);

            // Collect the values for this qualifying user
            currentInterval.sumFieldValues += currentValue;
            currentInterval.sumDistanceValues += sumDistance;
            currentInterval.userCount += 1;
            currentInterval.columnVal += currentValue; // Store sum of violations for display under column
          }
        } else {
          // For other fields, keep the original behavior
          if (sumDistance > minDistance) {
            // Update the sum for all fields
            intervalsMap.get(beginTime).totalValue += interval.sumPositions[fieldName];
            intervalsMap.get(beginTime).userCount += 1;
            if (interval.sumPositions[fieldName] !== 0) {
              if (['sumRedLamp', 'sumYellowLamp', 'sumCo2Impact', 'sumNonElectronic'].includes(fieldName)) {
                intervalsMap.get(beginTime).columnVal += 1; // в колонке количество тс
              }
            }
          }
        }
      });
    }
  });

  // Now calculate the totalValue for each interval as (sum of field / sum of distance) * 100 for special fields
  for (let [beginTime, intervalData] of intervalsMap) {
    if (['dvs_cnt', 'transmission_cnt', 'kom_cnt', 'bezop_cnt'].includes(fieldName)) {
      // Calculate sum of field values and sum of distances for this interval
      const fieldSum = intervalData.sumFieldValues;
      const distanceSum = intervalData.sumDistanceValues;

      // Calculate the percentage: (fieldSum / distanceSum) * 100
      intervalData.totalValue = distanceSum > 0 ? (fieldSum / distanceSum) * 100 : 0;
    }
    // For lamp fields, calculate actualValue as totalValue/userCount for formatSecondsToHHMM
    else if (['sumRedLamp', 'sumYellowLamp', 'sumCo2Impact', 'sumNonElectronic'].includes(fieldName)) {
      // Calculate the ratio of totalValue/columnVal for formatSecondsToHHMM. именно columnVal тут отображает количество юзеров
      intervalData.actualValue = intervalData.columnVal > 0 ? intervalData.totalValue / intervalData.columnVal : 0;
      intervalData.actualValue = formatSecondsToHHMM(intervalData.actualValue)
    }
  }

  // Sort intervals by time
  const sortedIntervals = Array.from(intervalsMap.values())
    .sort((a, b) => a.intervalEnd - b.intervalEnd);

  // console.log("sortedIntervals", sortedIntervals);

  // Format categories based on groupingType
  const categories = sortedIntervals.map(item => {
    const intervalBegin = item.intervalBegin;
    const intervalEnd = item.intervalEnd;
    return formatCategoryByGroupingType(intervalBegin, intervalEnd, groupingType.value);
  });

  // For violation charts (fieldName dvs_cnt, transmission_cnt, kom_cnt, bezop_cnt), round to 2 decimals
  // For other charts, use Math.round
  const data = sortedIntervals.map(item => {
    if (['dvs_cnt', 'transmission_cnt', 'kom_cnt', 'bezop_cnt'].includes(fieldName)) {
      return parseFloat(item.totalValue.toFixed(2));
    }
    return Math.round(item.totalValue);
  });
  const columnVals = sortedIntervals.map(item => Math.round(item.columnVal || 0));  // column count for specific fields
  const userCounts = sortedIntervals.map(item => item.userCount || 0);  // user count with non-zero values for specific fields
  const actualValues = sortedIntervals.map(item => item.actualValue || 0); // actual calculated values for specific fields

  const begins = sortedIntervals.map(item => {
    const intervalBegin = item.intervalBegin;
    return intervalBegin
  });
  

  return { categories, data, columnVals, userCounts, actualValues, begins };
};

// Utility function to format categories based on groupingType
const formatCategoryByGroupingType = (intervalBegin, intervalEnd, groupingTypeValue) => {
  if (groupingTypeValue === 'day') {
    // For day grouping, format as "dd.mm" using the actual interval begin timestamp
    const beginDate = new Date(intervalBegin * 1000);
    const day = String(beginDate.getDate()).padStart(2, '0');
    const month = String(beginDate.getMonth() + 1).padStart(2, '0');
    return `${day}.${month}`;
  } else if (groupingTypeValue === 'week') {
    // For week grouping, format as "dd.mm - dd.mm" (start to end of week)
    const beginDate = new Date(intervalBegin * 1000);
    const endDate = new Date(intervalEnd * 1000);
    const startDay = String(beginDate.getDate()).padStart(2, '0');
    const startMonth = String(beginDate.getMonth() + 1).padStart(2, '0');
    const endDay = String(endDate.getDate() - 1).padStart(2, '0');
    const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
    return `${startDay}.${startMonth} - ${endDay}.${endMonth}`;
  } else if (groupingTypeValue === 'month') {
    // For month and season grouping, format as "mm:yy" (month:2-digit year)
    const beginDate = new Date(intervalBegin * 1000);
    const month = String(beginDate.getMonth() + 1).padStart(2, '0'); // Month (0-indexed)
    const year = String(beginDate.getFullYear() % 100).padStart(2, '0'); // Last 2 digits of year
    return `${month}.${year}`;
  } else if (groupingTypeValue === 'quarter' || groupingTypeValue === 'season') {
    // For quarter grouping, format as "mm:yy - mm:yy" (start to end of interval)
    const beginDate = new Date(intervalBegin * 1000);
    const endDate = new Date(intervalEnd * 1000);

    const startMonth = String(beginDate.getMonth() + 1).padStart(2, '0');
    const startYr = String(beginDate.getFullYear() % 100).padStart(2, '0');

    let endMonth = endDate.getMonth();
    let endYr = endDate.getFullYear() % 100;
    if (endMonth == 0) {
      endMonth = 12
      endYr -= 1
    }
    endMonth = String(endMonth).padStart(2, '0');
    endYr = String(endYr).padStart(2, '0');

    return `${startMonth}.${startYr} - ${endMonth}.${endYr}`;
  } else {
    // Default format: dd.mm
    const beginDate = new Date(intervalBegin * 1000);
    const day = String(beginDate.getDate()).padStart(2, '0');
    const month = String(beginDate.getMonth() + 1).padStart(2, '0');
    return `${day}.${month}`;
  }
};

// выход тс на линию
const calculateOnLineData = () => {
  if (!testData.value || testData.value.length === 0) {
    return { categories: [], data: [], columnVals: [] };
  }

  const totalUsers = testData.value.length;
  const intervalsMap = new Map();

  testData.value.forEach(user => {
    if (user.data && user.data.posArray) {
      user.data.posArray.forEach(interval => {
        const beginTime = interval.interval_begin;
        const beginDate = new Date(beginTime * 1000);
        const day = String(beginDate.getDate()).padStart(2, '0');
        const month = String(beginDate.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const dateStr = `${day}.${month}`;

        if (!intervalsMap.has(beginTime)) {
          intervalsMap.set(beginTime, {
            dateStr: dateStr,
            intervalBegin: beginTime, // Store the beginning timestamp
            intervalEnd: interval.interval_end, // Store the ending timestamp
            onLineCount: 0
          });
        }

        // Count how many users are on_line for this interval
        if (interval.on_line === true && interval.sumPositions.sum_distance > minDistance) {
          intervalsMap.get(beginTime).onLineCount += 1;
        }
      });
    }
  });

  // Sort intervals by time
  const sortedIntervals = Array.from(intervalsMap.values())
  .sort((a, b) => a.intervalBegin - b.intervalBegin);

  // Format categories based on groupingType
  const categories = sortedIntervals.map(item => {
    const intervalBegin = item.intervalBegin;
    const intervalEnd = item.intervalEnd;
    return formatCategoryByGroupingType(intervalBegin, intervalEnd, groupingType.value);
  });

  const data = sortedIntervals.map(item => item.onLineCount);

  // Calculate percentage for each interval with decimal precision, hiding .0
  const columnVals = sortedIntervals.map(item => {
    if (totalUsers > 0) {
      const percentage = (item.onLineCount / totalUsers) * 100;
      const formattedPercentage = percentage.toFixed(1);
      // Remove decimal part if it's ".0"
      return parseFloat(formattedPercentage) % 1 === 0
        ? Math.round(percentage)
        : parseFloat(formattedPercentage);
    }
    return 0;
  });

  return { categories, data, columnVals };
};

const calculateFuelConsumptionData = () => {
  if (!testData.value || testData.value.length === 0) {
    return { categories: [], data: [], columnVals: [] };
  }

  const intervalsMap = new Map();

  testData.value.forEach(user => {
    if (user.data && user.data.posArray) {
      user.data.posArray.forEach(interval => {
        const beginTime = interval.interval_begin;
        const beginDate = new Date(beginTime * 1000);
        const day = String(beginDate.getDate()).padStart(2, '0');
        const month = String(beginDate.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const dateStr = `${day}.${month}`;

        if (!intervalsMap.has(beginTime)) {
          intervalsMap.set(beginTime, {
            dateStr: dateStr,
            intervalBegin: beginTime, // Store the beginning timestamp
            intervalEnd: interval.interval_end, // Store the ending timestamp
            totalSumCanexpence: 0,
            totalSumCanExpenceSpd: 0,
            totalSumDistance: 0,
            userCount: 0
          });
        }

        const current = intervalsMap.get(beginTime);

        if (interval.sumPositions &&
          interval.sumPositions.sum_distance > minDistance
        ) {
          current.totalSumCanexpence += interval.sumPositions.sum_canexpence;
          current.totalSumCanExpenceSpd += interval.sumPositions.sum_canexpencespd;
          current.totalSumDistance += interval.sumPositions.sum_distance;
          current.userCount += 1;
        }
      });
    }
  });

  const sortedIntervals = Array.from(intervalsMap.values())
    .sort((a, b) => a.intervalBegin - b.intervalBegin);

  const categories = sortedIntervals.map(item => {
    const intervalBegin = item.intervalBegin;
    const intervalEnd = item.intervalEnd;
    return formatCategoryByGroupingType(intervalBegin, intervalEnd, groupingType.value);
  });

  const data = sortedIntervals.map(item => {
    const { totalSumCanexpence, totalSumDistance, userCount } = item;
    if (userCount > 0 && totalSumDistance > 0) {
      const value = (100 * totalSumCanexpence) / totalSumDistance;
      return parseFloat(value.toFixed(1));
    }
    return 0;
  });

  const columnVals = sortedIntervals.map(item => {
    const { totalSumCanExpenceSpd, totalSumDistance, userCount } = item;
    if (userCount > 0 && totalSumDistance > 0) {
      const value = (100 * totalSumCanExpenceSpd) / totalSumDistance;
      return parseFloat(value.toFixed(1));
    }
    return 0;
  });

  // const columnVals = sortedIntervals.map(item => item[1].columnVal || 0);  // column count for specific fields
  const userCounts = sortedIntervals.map(item => item.userCount || 0);  // user count with non-zero values for specific fields
  // const actualValues = sortedIntervals.map(item => item[1].actualValue || 0); // actual calculated values for specific fields

  return { categories, data, columnVals, userCounts };
};

const calculateFuelVolumeData = (groupingTypeValue) => {
  if (!testData.value || testData.value.length === 0) {
    return { categories: [], data: [], columnVals: [] };
  }

  const intervalsMap = new Map();

  testData.value.forEach(user => {
    if (user.data && user.data.posArray) {
      user.data.posArray.forEach(interval => {
        const beginTime = interval.interval_begin;
        const beginDate = new Date(beginTime * 1000);
        const day = String(beginDate.getDate()).padStart(2, '0');
        const month = String(beginDate.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const dateStr = `${day}.${month}`;

        if (!intervalsMap.has(beginTime)) {
          intervalsMap.set(beginTime, {
            dateStr: dateStr,
            intervalBegin: beginTime, // Store the beginning timestamp
            intervalEnd: interval.interval_end, // Store the ending timestamp
            totalSumCanexpence: 0,
            totalSumCanExpenceSpd: 0,
            userCount: 0
          });
        }

        const current = intervalsMap.get(beginTime);

        if (interval.sumPositions) {
          const canexpence = Number(interval.sumPositions.sum_canexpence) || 0;
          const canexpenceSpd = Number(interval.sumPositions.sum_canexpencespd) || 0;
          current.totalSumCanexpence += canexpence;
          current.totalSumCanExpenceSpd += canexpenceSpd;
          console.log("canexpence", canexpence, "canexpenceSpd", canexpenceSpd);
          current.userCount += 1;
        }
      });
    }
  });

  const sortedIntervals = Array.from(intervalsMap.values())
    .sort((a, b) => a.intervalBegin - b.intervalBegin);

  // Format categories based on groupingType
  const categories = sortedIntervals.map(item => {
    const intervalBegin = item.intervalBegin;
    const intervalEnd = item.intervalEnd;
    return formatCategoryByGroupingType(intervalBegin, intervalEnd, groupingType.value);
  });

  const data = sortedIntervals.map(item => {
    const { totalSumCanexpence, userCount } = item;
    let value = Number(totalSumCanexpence) || 0;
    // Convert to tons if groupingType is not "day"
    if (groupingTypeValue && groupingTypeValue !== 'day') {
      value = value / 1000;
    }
    return Math.round(value);
  });

  const columnVals = sortedIntervals.map(item => {
    const { totalSumCanExpenceSpd, userCount } = item;
    let value = Number(totalSumCanExpenceSpd) || 0;
    // Convert to tons if groupingType is not "day"
    if (groupingTypeValue && groupingTypeValue !== 'day') {
      value = value / 1000;
    }
    return Math.round(value);
  });

  const userCounts = sortedIntervals.map(item => item.userCount || 0);

  return { categories, data, columnVals, userCounts };
};

const calculateDistanceAndSpeedData = () => {
  if (!testData.value || testData.value.length === 0) {
    return { categories: [], data: [], columnVals: [] };
  }

  const intervalsMap = new Map();

  testData.value.forEach(user => {
    if (user.data && user.data.posArray) {
      user.data.posArray.forEach(interval => {
        const beginTime = interval.interval_begin;
        const beginDate = new Date(beginTime * 1000);
        const day = String(beginDate.getDate()).padStart(2, '0');
        const month = String(beginDate.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const dateStr = `${day}.${month}`;

        if (!intervalsMap.has(beginTime)) {
          intervalsMap.set(beginTime, {
            dateStr: dateStr,
            intervalBegin: beginTime, // Store the beginning timestamp
            intervalEnd: interval.interval_end, // Store the ending timestamp
            totalSumDistance: 0,
            totalSumMotoEngineSpd: 0,
            userCount: 0,
            numberOfDays: 0
          });
        }

        const current = intervalsMap.get(beginTime);

        const intervalDurationMs = (interval.interval_end - beginTime) * 1000;
        current.numberOfDays = Math.max(1, Math.floor(intervalDurationMs / (1000 * 60 * 60 * 24))); // Convert to days, minimum 1

        if (interval.sumPositions &&
            interval.sumPositions.sum_distance > minDistance
          ) {

          current.totalSumDistance += interval.sumPositions.sum_distance;
          current.totalSumMotoEngineSpd += interval.sumPositions.sum_motoenginespd;
          current.userCount += 1;
        }
      });
    }
  });

  const sortedIntervals = Array.from(intervalsMap.values())
    .sort((a, b) => a.intervalBegin - b.intervalBegin);

  // Format categories based on groupingType
  const categories = sortedIntervals.map(item => {
    const intervalBegin = item.intervalBegin;
    const intervalEnd = item.intervalEnd;
    return formatCategoryByGroupingType(intervalBegin, intervalEnd, groupingType.value);
  });

  const data = sortedIntervals.map(item => {
    const { totalSumDistance, userCount, numberOfDays } = item;
    if (userCount > 0) {
      const avgDailyDistance = totalSumDistance / numberOfDays;
      const value = avgDailyDistance / userCount; // среднесуточный пробег
      // Round to 1 decimal place and remove decimal if it's ".0"
      const roundedValue = Number(value.toFixed(1));
      return Number.isInteger(roundedValue) ? Math.round(value) : roundedValue;
    }
    return 0;
  });

  const columnVals = sortedIntervals.map(item => {
    const { totalSumDistance, userCount, totalSumMotoEngineSpd } = item;
    if (userCount > 0 && totalSumMotoEngineSpd > 0) {
      const value = totalSumDistance / totalSumMotoEngineSpd; // средняя скорость
      // Round to 1 decimal place and remove decimal if it's ".0"
      const roundedValue = Number(value.toFixed(1));
      return Number.isInteger(roundedValue) ? Math.round(value) : roundedValue;
    }
    return 0;
  });

  // const columnVals = sortedIntervals.map(item => item[1].columnVal || 0);  // column count for specific fields
  const userCounts = sortedIntervals.map(item => item.userCount || 0);  // user count with non-zero values for specific fields
  // const actualValues = sortedIntervals.map(item => item[1].actualValue || 0); // actual calculated values for specific fields

  return { categories, data, columnVals, userCounts };
};

const calculateEngineTimeData = () => {
  if (!testData.value || testData.value.length === 0) {
    return { categories: [], data: [], engineTimeInMotionData: [] };
  }

  const intervalsMap = new Map();

  testData.value.forEach(user => {
    if (user.data && user.data.posArray) {
      user.data.posArray.forEach(interval => {
        const beginTime = interval.interval_begin;
        const beginDate = new Date(beginTime * 1000);
        const day = String(beginDate.getDate()).padStart(2, '0');
        const month = String(beginDate.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const dateStr = `${day}.${month}`;

        if (!intervalsMap.has(beginTime)) {
          intervalsMap.set(beginTime, {
            dateStr: dateStr,
            intervalBegin: beginTime, // Store the beginning timestamp
            intervalEnd: interval.interval_end, // Store the ending timestamp
            totalSumMotoEngine: 0,
            totalSumMotoEngineSpd: 0,
            userCount: 0
          });
        }

        const current = intervalsMap.get(beginTime);

        if (interval.sumPositions) {
          const motoEngine = Number(interval.sumPositions.sum_motoengine) || 0;
          const motoEngineSpd = Number(interval.sumPositions.sum_motoenginespd) || 0;
          current.totalSumMotoEngine += motoEngine;
          current.totalSumMotoEngineSpd += motoEngineSpd;
          current.userCount += 1;
        }
      });
    }
  });

  const sortedIntervals = Array.from(intervalsMap.values())
    .sort((a, b) => a.intervalBegin - b.intervalBegin);

  const categories = sortedIntervals.map(item => {
    const intervalBegin = item.intervalBegin;
    const intervalEnd = item.intervalEnd;
    return formatCategoryByGroupingType(intervalBegin, intervalEnd, groupingType.value);
  });

  // Calculate raw numeric values
  const rawNumericData = sortedIntervals.map(item => {
    const { totalSumMotoEngine, userCount } = item;
    if (userCount > 0) {
      return Number(totalSumMotoEngine / userCount) || 0;
    }
    return 0;
  });

  const rawEngineTimeInMotionData = sortedIntervals.map(item => {
    const { totalSumMotoEngineSpd, userCount } = item;
    if (userCount > 0) {
      return Number(totalSumMotoEngineSpd / userCount) || 0;
    }
    return 0;
  });

  // Format the values using formatHoursToHHMM
  const data = rawNumericData.map(value => formatHoursToHHMM(value));
  const engineTimeInMotionData = rawEngineTimeInMotionData.map(value => formatHoursToHHMM(value));

  return { categories, data, engineTimeInMotionData, rawNumericData, rawEngineTimeInMotionData };
};

const createChartOptions = (title, categories, data, width = 301, height = 202, fontSize = '14px', labelsEnabled = true, stacking = false, seriesData = null, isViolationChart = false, fieldName = null, hideDateLabels = false, columnVals = null, userCounts = null, actualValues = null, chartIndex = null, extraData = null, groupMaxValue = null, begins = null) => {
  // Function to determine color based on value
  const getColorForValue = (value) => {
    if (value < 6) return '#1E9764';      // Green for values 0-5
    if (value < 11) return '#FFC801';      // Yellow for values 6-10
    return '#CD5247';                      // Red for values >= 11
  };

  // Function to determine border color based on value (darker version)
  const getBorderColorForValue = (value) => {
    if (value < 6) return '#156F48';      // Darker green for values 0-5
    if (value < 11) return '#CC9E00';      // Darker yellow for values 6-10
    return '#9E3E34';                      // Darker red for values >= 11
  };

  const getColorForField = (field) => {
    switch(field) {
      case 'sumRedLamp':
        return ['#CD5247', '#9E3E34'];  // Red
      case 'sumYellowLamp':
        return ['#FFC801', '#CC9E00'];  // Yellow
      case 'sumCo2Impact':
        return ['#C7C7CC', '#838387'];  // Grey
      case 'sumNonElectronic':
        return ['#928F95', '#575659'];  // Darker grey
      case 'sumFuelsOut':
        return ['#00426A', '#002b47'];  // Blue
      default:
        return ['#00426A', '#002b47'];  // Blue
    }
  };

  // Check if all values in the data are zero (for the purpose of hiding actualValue)
  const allDataZero = data && data.length > 0 && data.every(item => {
    const value = typeof item === 'object' ? item.y : item;
    return value === 0 || value === null || value === undefined || isNaN(value);
  });

  // Process data for violation charts to include colors
  let processedData = data;
  processedData = data.map((point, index) => {
    const value = typeof point === 'object' ? point.y : point;
    // Round to 1 decimal place if it's a floating point number
    let roundedValue = Number.isInteger(value) ? value : parseFloat(value.toFixed(1));
    let actualValueForDisplay = roundedValue;

    // For chartIndex 12 (engine time chart), format time values with formatHoursToHHMM
    if (chartIndex === 12) {
      actualValueForDisplay = formatHoursToHHMM(value);
    }
    // For chartIndex 11 (fuel consumption chart), use the original value without rounding
    else if (chartIndex === 11) {
      actualValueForDisplay = value;
    }
    // For chartIndex 0-3 (violation charts), use the original value with 2 decimals
    else if (chartIndex >= 0 && chartIndex <= 3) {
      actualValueForDisplay = value;
    }

    const res = {
      y: roundedValue,
      // Add the actual data value for the checkerboard pattern
      actualValue: actualValueForDisplay,
      color: getColorForValue(roundedValue), // todo убрать
      borderColor: getBorderColorForValue(roundedValue) // todo убрать
    }

    if (isViolationChart) {
      res.color = getColorForValue(roundedValue)
      res.borderColor = getBorderColorForValue(roundedValue)
      // For chartIndex 0-3 (violation charts):
      // - y = roundedValue (violations per 100km) for column height
      // - actualValue = columnVals[index] (sum of violations) for display under column
      // - columnVal = violations per 100km (sum_violations / sum_distance * 100) with 2 decimals for display inside column
      if (chartIndex >= 0 && chartIndex <= 3 && Array.isArray(columnVals) && index < columnVals.length) {
        res.actualValue = columnVals[index]; // Sum of violations for display under column
        // Use the original value with 2 decimals for display inside column
        res.columnVal = parseFloat(value.toFixed(2));
      }
    } else if (fieldName && ['sumRedLamp', 'sumYellowLamp', 'sumCo2Impact', 'sumNonElectronic', 'sumFuelsOut'].includes(fieldName)) {
      res.color = getColorForField(fieldName)[0];
      res.borderColor = getColorForField(fieldName)[1];

      // For sumRedLamp, sumYellowLamp, sumCo2Impact, sumNonElectronic, use column count for height and include sum as actualValue
      if (fieldName && ['sumRedLamp', 'sumYellowLamp', 'sumCo2Impact', 'sumNonElectronic'].includes(fieldName) && Array.isArray(columnVals) && index < columnVals.length) {
        res.y = columnVals[index]; // Use column count for chart height
        res.actualValue = actualValues[index];
        res.columnVal = columnVals[index]; // Include column count for data labels
      }
      // For sumFuelsOut, apply division by 1000 if groupingType is not "day"
      else if (fieldName && fieldName === 'sumFuelsOut') {
        const divisor = groupingType.value !== 'day' ? 1000 : 1;
        res.y = roundedValue / divisor; // Divide by 1000 if not daily grouping
        res.actualValue = res.y; // Use adjusted value for display
      }
    }

    // If ALL values in the chart are zero, don't set actualValue
    // For violation charts (chartIndex 0-3), check columnVals instead of data
    if (allDataZero) {
      if (chartIndex >= 0 && chartIndex <= 3) {
        // For violation charts, only delete actualValue if columnVals are also all zero
        const allColumnValsZero = columnVals && columnVals.length > 0 && columnVals.every(val => val === 0 || val === null || val === undefined);
        if (allColumnValsZero) {
          delete res.actualValue;
        }
      } else {
        delete res.actualValue; // Don't show actualValue if all data in the chart is zero
      }
    }

    return res;
  });

  const chartOptions = {
    chart: {
      type: 'column',
      width: width,
      height: height,
      spacingBottom: 0,
      style: { 
        fontFamily: 'inherit',
        position: 'unset',
      },
      // backgroundColor: '#f0f0f0'
    },
    title: { text: null },
    // title: {
    //   text: title,
    //   style: {
    //     color: 'black',
    //     fontSize: fontSize
    //   },
    //   align: 'left',
    //   x: 0
    // },
    credits: { enabled: false },
    legend: { enabled: false },
    exporting: { enabled: false },
    xAxis: {
      categories: categories,
      lineWidth: 0, // Убираем линию оси
      tickWidth: 0, // Убираем засечки
      crosshair: true,
      labels: {
        enabled: labelsEnabled,
        rotation: 0,
        useHTML: true,
        y: 25, // Исходное смещение вниз для всех
        step: 1, // Show all labels without hiding any for readability
        allowOverlap: true, // Allow labels to overlap when there are many values
        style: {
          fontSize: '13px',
          fontFamily: 'inherit'
        },
        formatter: function() {
          const actualValue = processedData[this.pos]?.actualValue || ' ';
          // Format the actual value for display
          let displayValue = actualValue;
          if (typeof actualValue === 'number' && !Number.isInteger(actualValue)) {
            // For chartIndex 12 (engine time), format as HH:MM instead of rounding to 1 decimal place
            if (chartIndex === 12) {
              displayValue = formatHoursToHHMM(actualValue);
            }
            // For chartIndex 11 (fuel consumption), show the full precision without rounding
            else if (chartIndex === 11) {
              displayValue = actualValue;
            }
            else {
              displayValue = parseFloat(actualValue.toFixed(1));
            }
          } else if (typeof actualValue === 'number' && chartIndex === 12) {
            // For integer values on engine time chart, still format as HH:MM
            displayValue = formatHoursToHHMM(actualValue);
          } else if (typeof actualValue === 'number' && chartIndex === 11) {
            // For integer values on fuel consumption chart, still show the full precision
            displayValue = actualValue;
          }

          // --- УСЛОВИЯ ДЛЯ ШАХМАТНОГО РАСПОЛОЖЕНИЯ ---
          // Проверяем, есть ли больше 11 колонок и хотя бы одно значение > 3 символов
          const hasMoreThan11Columns = this.axis.categories && this.axis.categories.length > 11;
          const hasValueMoreThan3Chars = processedData.some(item =>
            item && item.actualValue && item.actualValue.toString().length > 3
          );

          let staggerStyle = '';
          let stagger2Style = '';
          let xAxisTimeStyle = '';
          if (chartIndex !== null && chartIndex >= 0 && chartIndex <= 7) {
            // For chartInstances[0] - chartInstances[7], always use margin-bottom: 6px
            xAxisTimeStyle += 'margin-bottom: 6px;';
          } else if (hasMoreThan11Columns && hasValueMoreThan3Chars) {
            // Смещаем вниз нечетные индексы (1, 3, 5...) на 16px
            // staggerStyle = this.pos % 2 !== 0 ? 'margin-top: 16px;' : '';
            // stagger2Style = this.pos % 2 !== 0 ? '' : 'margin-top: 16px;';
            staggerStyle = this.pos % 2 !== 0 ? '' : 'padding-top: 17px;';
            xAxisTimeStyle = this.pos % 2 !== 0 ? 'margin-bottom: 17px;' : '';
          } else {
            xAxisTimeStyle += 'margin-bottom: 17px;'
          }

          xAxisTimeStyle += 'display: block;color: #000000;font-size: 12px;font-weight: 400;'
          staggerStyle += 'text-align: center;line-height: 1.1;min-height: 40px;display: flex;flex-direction: column;justify-content: flex-start;';
          stagger2Style += 'display: block;color: #9ca3af;font-size: 9px;'
          // ------------------------------------------

          // If hideDateLabels is true, don't show the date part, except for specific field names
          // Now the categories are already formatted based on groupingType, so just return the value
          const formattedDate = this.value;

          if (hideDateLabels && !['sumCo2Impact', 'sumNonElectronic'].includes(fieldName)) {
            return `
                <div class="chart-xaxis-label" style="${staggerStyle}">
                    <span class="chart-xaxis-time" style="${xAxisTimeStyle}">${displayValue}</span>
                </div>
            `;
          } else {
            return `
                <div class="chart-xaxis-label" style="${staggerStyle}">
                    <span class="chart-xaxis-time" style="${xAxisTimeStyle}">${displayValue}</span>
                    <span class="chart-xaxis-date" style="${stagger2Style}">${formattedDate}</span>
                </div>
            `;
          }
        }
      }
    },
    yAxis: {
      min: 0,
      visible: false,
      title: { text: null },
      endOnTick: false,
      step: 1,
      // For chartInstances[0] - chartInstances[3] (violation charts), set common max value
      ...(chartIndex >= 0 && chartIndex <= 3 ? {
        max: (() => {
          // If a groupMaxValue is provided (pre-calculated max across all violation charts), use it exactly as calculated
          if (groupMaxValue !== null && typeof groupMaxValue === 'number' && !isNaN(groupMaxValue)) {
            return groupMaxValue + 1; // Use the exact pre-calculated max value as specified
          }
        })()
      } : {}),
      // For chartInstances[4] - chartInstances[7] (lamp charts), set common max value based on columnVals (vehicle counts)
      ...(chartIndex >= 4 && chartIndex <= 7 ? {
        max: (() => {
          // If a groupMaxValue is provided (pre-calculated max across all lamp charts), use it exactly as calculated
          if (groupMaxValue !== null && typeof groupMaxValue === 'number' && !isNaN(groupMaxValue)) {
            return groupMaxValue + 1; // Use the exact pre-calculated max value as specified
          }
        })()
      } : {}),
      // For chartInstances[8] - chartInstances[13] (work charts), set individual max values based on each chart's data
      ...(chartIndex >= 8 && chartIndex <= 13 ? {
        max: (() => {
          // if (chartIndex === 8) return 100;
          // If a groupMaxValue is provided (individual max for work charts), use it exactly as calculated
          if (groupMaxValue !== null && typeof groupMaxValue === 'number' && !isNaN(groupMaxValue)) {
            return groupMaxValue + 1; // Use the exact pre-calculated max value as specified
          }
        })()
      } : {})
    },
    tooltip: {
      // enabled: true,
      // backgroundColor: 'white',
      // borderColor: 'gray',
      // borderRadius: 5,
      // shadow: true,
      // style: {
      //   color: 'black',
      //   fontSize: '12px'
      // },
      // pointFormat: '<span style="color:{point.color}">\u25CF</span> <b>{point.y}</b><br/>'
      shared: false,
      backgroundColor: '#000000',
      borderColor: '#E5E7EB',
      borderRadius: 8,
      shadow: false,
      useHTML: true,
      padding: 0,
      style: {
        zIndex: 9999
      },
      headerFormat: '',
      pointFormatter: function() {
        // Get the index of this point in the data array
        const index = this.index;
        let tooltipText = '';

        // грубые нарушения при управлении тс
        // Format tooltip based on chart index
        if (chartIndex >= 0 && chartIndex <= 3) {
          // chartInstances[0] - chartInstances[3]: violation charts (ДВС, ТРАНСМИССИЯ, РАБОТА КОМ, СУММА НАРУШЕНИЙ)
          const totalValue = this.actualValue || 0;
          const per100kmValue = (this.columnVal || 0) + '';

          // Format date with year from begins array
          let formattedDate = categories[index];
          if (begins && begins[index]) {
            const beginDate = new Date(begins[index] * 1000);
            const day = String(beginDate.getDate()).padStart(2, '0');
            const month = String(beginDate.getMonth() + 1).padStart(2, '0');
            const year = String(beginDate.getFullYear() % 100).padStart(2, '0');
            formattedDate = `${day}.${month}.${year}`;
          }
          // <div style="font-weight: 700; font-size: 13px; margin-bottom: 6px;">${formattedDate}</div>
          tooltipText = `

            <div style="margin-left: 2px; font-weight: 400; font-size: 12px;">Сумма</div>
            <div style="font-weight: 400; font-size: 12px; display: flex; justify-content: space-between; gap: 20px;">
              <span style="margin-left: 2px">по парку</span>
              <span style="font-weight: 700; margin-right: 4px">${Math.round(totalValue)}</span>
            </div>
            <div style="margin-left: 2px; font-weight: 400; font-size: 12px; margin-top: 4px">На 100 км.</div>
            <div style="font-weight: 400; font-size: 12px; display: flex; justify-content: space-between; gap: 20px; ">
              <span style="margin-left: 2px">на 1 ТС</span>
              <span style="font-weight: 700; margin-right: 4px">${per100kmValue.replace('.', ',')}</span>
            </div>
          `;
        }
        else if (chartIndex >= 4 && chartIndex <= 7) {
          // chartInstances[4] - chartInstances[7]: lamp charts
          let chartTitle = '';
          switch(chartIndex) {
            case 4: chartTitle = 'Красная лампа'; break;
            case 5: chartTitle = 'Желтая лампа'; break;
            case 6: chartTitle = 'Не связана с электроникой'; break;
            case 7: chartTitle = 'Выбросы СО2'; break;
          }
          const columnVal = columnVals && columnVals[index] ? columnVals[index] : 0;
          const actualValue = actualValues && actualValues[index] ? actualValues[index] : '0';
          tooltipText = `${categories[index]}, среднее время события по ${columnVal} ТС<br> ${actualValue}.`;
        }
        else if (chartIndex === 8) {
          // chartInstances[8]: on-line chart
          const onLineCount = extraData && extraData.data && extraData.data[index] ? extraData.data[index] : 0;
          const percentageValue = extraData && extraData.columnVals && extraData.columnVals[index] ? extraData.columnVals[index] : 0;
          tooltipText = `${categories[index]}, выход на линию ${onLineCount} ТС: ${percentageValue} %.`;
        }
        else if (chartIndex === 9) {
          // chartInstances[9]: distance and speed chart
          const userCount = userCounts && userCounts[index] ? userCounts[index] : 0;
          const distanceValue = extraData && extraData.data && extraData.data[index] ? extraData.data[index] : 0;
          const avgSpeedValue = extraData && extraData.columnVals && extraData.columnVals[index] ? extraData.columnVals[index] : 0;
          tooltipText = `${categories[index]} Среднесуточный пробег среди ${userCount} ТС ${distanceValue} км. Средняя скорость в движении ${avgSpeedValue} км/ч.`;
        }
        else if (chartIndex === 10) {
          const isThousands = groupingType.value !== 'day';
          // chartInstances[10]: fuel volume chart
          const userCount = userCounts && userCounts[index] ? userCounts[index] : 0;
          
          // extraData может содержать объекты Highcharts точек после point.update()
          const fuelIdleRaw = extraData && extraData.data && extraData.data[index] !== undefined ? extraData.data[index] : 0;
          const fuelMoveRaw = extraData && extraData.columnVals && extraData.columnVals[index] !== undefined ? extraData.columnVals[index] : 0;
          
          // Извлекаем числовое значение: если это объект Highcharts, берем .y
          const fuelIdleValue = typeof fuelIdleRaw === 'object' && fuelIdleRaw !== null ? (fuelIdleRaw.y !== undefined ? Number(fuelIdleRaw.y) : 0) : Number(fuelIdleRaw) || 0;
          const fuelMoveValue = typeof fuelMoveRaw === 'object' && fuelMoveRaw !== null ? (fuelMoveRaw.y !== undefined ? Number(fuelMoveRaw.y) : 0) : Number(fuelMoveRaw) || 0;
          
          const fuelIdleeValue = isNaN(fuelIdleValue - fuelMoveValue) ? 0 : fuelIdleValue - fuelMoveValue;
          tooltipText = `${categories[index]}, данные по ${userCount} ТС<br>Общий расход - ${isNaN(fuelIdleValue) ? 0 : fuelIdleValue} ${isThousands ? 'тыс.л.' : 'л.'}<br>Расход при движении - ${isNaN(fuelMoveValue) ? 0 : fuelMoveValue} ${isThousands ? 'тыс.л.' : 'л.'}<br>Расход при стоянке - ${fuelIdleeValue} ${isThousands ? 'тыс.л.' : 'л.'}`;
        }
        else if (chartIndex === 11) {
          // chartInstances[11]: fuel consumption chart
          const userCount = userCounts && userCounts[index] ? userCounts[index] : 0;
          
          // extraData может содержать объекты Highcharts точек после point.update()
          const fuelSumRaw = extraData && extraData.data && extraData.data[index] !== undefined ? extraData.data[index] : 0;
          const fuelMoveRaw = extraData && extraData.columnVals && extraData.columnVals[index] !== undefined ? extraData.columnVals[index] : 0;
          
          const fuelSumValue = typeof fuelSumRaw === 'object' && fuelSumRaw !== null ? (fuelSumRaw.y !== undefined ? Number(fuelSumRaw.y) : 0) : Number(fuelSumRaw) || 0;
          const fuelMoveValue = typeof fuelMoveRaw === 'object' && fuelMoveRaw !== null ? (fuelMoveRaw.y !== undefined ? Number(fuelMoveRaw.y) : 0) : Number(fuelMoveRaw) || 0;
          
          tooltipText = `${categories[index]} Средний расход топлива среди ${userCount} ТС ${fuelSumValue} литров/100 км. Средний расход топлива в движении ${fuelMoveValue} литров/100км.`;
        }
        else if (chartIndex === 12) {
          // chartInstances[12]: engine time chart
          const userCount = userCounts && userCounts[index] ? userCounts[index] : 0;
          
          // extraData может содержать объекты Highcharts точек после point.update()
          const engineTimeRaw = extraData && extraData.data && extraData.data[index] !== undefined ? extraData.data[index] : '0';
          const engineTimeInMotionRaw = extraData && extraData.engineTimeInMotionData && extraData.engineTimeInMotionData[index] !== undefined ? extraData.engineTimeInMotionData[index] : '0';
          
          // Для времени работы ДВС значения уже отформатированы как строки HH:MM
          const engineTimeValue = typeof engineTimeRaw === 'object' && engineTimeRaw !== null ? (engineTimeRaw.y !== undefined ? engineTimeRaw.y : '0') : engineTimeRaw;
          const engineTimeInMotionValue = typeof engineTimeInMotionRaw === 'object' && engineTimeInMotionRaw !== null ? (engineTimeInMotionRaw.y !== undefined ? engineTimeInMotionRaw.y : '0') : engineTimeInMotionRaw;
          
          tooltipText = `${categories[index]} Среднее время работы ДВС ${engineTimeValue}. Среднее время работы ДВС в движении ${engineTimeInMotionValue}.`;
        }
        else if (chartIndex === 13) {
          const isThousands = groupingType.value !== 'day';
          // chartInstances[13]: fuel outs chart
          const userCount = userCounts && userCounts[index] ? userCounts[index] : 0;
          const dataValue = this.y !== undefined ? this.y : 0;
          tooltipText = `${categories[index]} Общий обьем сливов ${dataValue} ${isThousands ? 'тысяч литров' : 'литров'}`;
        }
        else {
          // Default tooltip for other chart types
          tooltipText = `${categories[index]}, Значение: ${this.y}`;
        }

        // For violation charts (chartIndex 0-3), return tooltipText directly as it already has full structure
        if (chartIndex >= 0 && chartIndex <= 3) {
          return `
            <div style="padding: 1px 1px; font-size: 12px; background-color: #ffffff; border: 1px solid #00426A; border-radius: 5px; min-width: 98px;">
              ${tooltipText}
            </div>
          `;
        }

        return `
          <div style="padding: 8px; font-size: 12px; background-color: #ffffff; border: 1px solid #e5e7eb; border-radius: 6px;">
            <div style="color: #374151;">${tooltipText}</div>
          </div>
        `;
      }
    },
    plotOptions: {
      // column: {
      //   pointPadding: 0.1,
      //   groupPadding: 0.1,
      //   borderWidth: 0,
      //   dataLabels: {
      //     enabled: false
      //   }
      // }
      series: {
        borderRadius: 3,
      },
      borderRadius: 3,
      column: {
        borderWidth: 1,
        pointPadding: 0,
        groupPadding: 0,
        borderRadius: 3,
        dataLabels: {
          allowOverlap: true,
          enabled: true,
          formatter: function() {
            // For specific fields, show the columnVal (count of non-zero values) inside the column at the bottom
            if (fieldName && ['sumRedLamp', 'sumYellowLamp', 'sumCo2Impact', 'sumNonElectronic'].includes(fieldName) && this.point.columnVal !== undefined) {
              return this.point.columnVal;
            }

            // For chartInstances[0] - chartInstances[3] (violation charts), show columnVal (violations per 100km) inside the column
            if (chartIndex >= 0 && chartIndex <= 3 && this.point.columnVal !== undefined) {
              return this.point.columnVal;
            }

            // For chartInstances[8] - chartInstances[12], only show values that are below 18% of max value

            // For other fields, don't show data labels
            return null;
          },
          verticalAlign: 'bottom', // Position labels above columns for chartInstances[8] - chartInstances[12]
          inside: true, // Position labels outside columns for chartInstances[8] - chartInstances[12]
          style: {
            fontSize: (() => {
              if (fieldName && (['sumRedLamp', 'sumYellowLamp', 'sumCo2Impact', 'sumNonElectronic', 'onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName))) {
                return '12px';
              }
              if (chartIndex >= 0 && chartIndex <= 3) {
                return '12px';
              }
              return '11px';
            })(),
            color: (() => {
              if (fieldName && (['sumRedLamp', 'sumYellowLamp', 'sumCo2Impact', 'sumNonElectronic'].includes(fieldName))) {
                return '#000';
              }
              if (fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName))) {
                return '#fff';
              }
              if (chartIndex >= 0 && chartIndex <= 3) {
                return '#000';
              }
              return '#333';
            })(),
            fill: (() => {
              if (fieldName && (['sumRedLamp', 'sumYellowLamp', 'sumCo2Impact', 'sumNonElectronic'].includes(fieldName))) {
                return '#000';
              }
              if (fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName))) {
                return '#fff';
              }
              if (chartIndex >= 0 && chartIndex <= 3) {
                return '#000';
              }
              return '#333';
            })(),
            textOutline: (() => {
              if (fieldName && (['sumRedLamp', 'sumYellowLamp', 'sumCo2Impact', 'sumNonElectronic', 'onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName))) {
                return false;
              }
              if (chartIndex >= 0 && chartIndex <= 3) {
                return false;
              }
              return '1px contrast';
            })(),
            fontWeight: (() => {
              if (fieldName && (['sumRedLamp', 'sumYellowLamp', 'sumCo2Impact', 'sumNonElectronic', 'onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName))) {
                return 'normal';
              }
              if (chartIndex >= 0 && chartIndex <= 3) {
                return 'normal';
              }
              return 'bold';
            })(),
            align: 'center' // Center the text horizontally
          }
        }
      }
    },
    
    series: [{
      data: processedData
    }],
  };

  // Helper function to check if all values in the first series are zero
  const allFirstSeriesZero = (seriesData) => {
    if (!seriesData || seriesData.length === 0) return false;

    // Find the first series (usually blue #00426A or the first one)
    const firstSeries = seriesData.find(s => s.color === '#00426A') || seriesData[0];
    if (!firstSeries || !firstSeries.data) return false;

    return firstSeries.data.every(value => {
      const numericValue = typeof value === 'object' && value.y !== undefined ? value.y : value;
      return numericValue === 0 || numericValue === null || numericValue === undefined;
    });
  };

  // If stacking is enabled, modify the plotOptions and series accordingly
  if (stacking) {
    chartOptions.plotOptions.column.stacking = null//'normal';
    chartOptions.plotOptions.column.grouping = false;
    if (seriesData) {
      // For charts 9-13, add data labels to the green series (#1E9764) to show columnVal
      if (fieldName && ['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) {
        // Process each series to add columnVal to the green series (#1E9764) or blue series when green is hidden
        const modifiedSeriesData = seriesData.map((series, index) => {
          // Check if this is chartData9 or chartData10 (onLinePercentage, avgSpeed) where green series is hidden
          if (fieldName && ['onLinePercentage', 'avgSpeed'].includes(fieldName) && series.color === '#00426A') {
            // For blue series in these charts, add dataLabels that show the green series values
            // Find the green series data to use for the labels
            const greenSeries = seriesData.find(s => s.color === '#1E9764');
            if (greenSeries) {
              return {
                ...series,
                dataLabels: {
                  allowOverlap: true,
                  enabled: true,
                  formatter: function() {
                    // Use the corresponding value from the green series (columnVal)
                    const greenValue = greenSeries.data[this.point.index];
                    if (typeof greenValue === 'number') {
                      // Format based on the fieldName
                      if (fieldName === 'onLinePercentage') {
                        return Math.round(greenValue) + ' %'; // Show as percentage
                      } else if (fieldName === 'avgSpeed') {
                        // For avgSpeed, show with 1 decimal precision and remove .0 if needed
                        const roundedValue = Number(greenValue.toFixed(1));
                        const displayValue = Number.isInteger(roundedValue) ? Math.round(greenValue) : roundedValue;
                        return displayValue + '<br>км/ч'; // Show as km/h on new line
                      } else if (fieldName === 'fuelMoveVolume') {
                        // For fuel consumption, show with 1 decimal precision to match the tooltip
                        return parseFloat(greenValue.toFixed(1));
                      }
                      return Math.round(greenValue); // Show as integer for others
                    }
                    return greenValue;
                  },
                  verticalAlign: 'bottom',
                  inside: true,
                  style: {
                    fontSize: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? '12px' : '11px',
                    color: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? '#fff' : '#333',
                    fill: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? '#fff' : '#333',
                    textOutline: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? false : '1px contrast',
                    fontWeight: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? 'normal' : 'bold',
                    align: 'center' // Center the text horizontally
                  }
                }
              };
            }
          }
          // For other charts or the green series, use the original logic
          else if (series.color === '#1E9764') {
            // For the green series, we'll add dataLabels with the values
            return {
              ...series,
              dataLabels: {
                allowOverlap: true,
                enabled: true,
                formatter: function() {
                  // This will display the value for the green series inside the column
                  const value = this.y;
                  if (typeof value === 'number') {
                    // Format based on the fieldName
                    if (fieldName === 'engineTimeInMotion') {
                      return formatHoursToHHMM(value); // Format as HH:MM
                    } else if (fieldName === 'onLinePercentage') {
                      return Math.round(value) + ' %'; // Show as percentage
                    } else if (fieldName === 'avgSpeed') {
                      return Math.round(value) + '<br/>км/ч'; // Show as km/h on new line
                    } else if (fieldName === 'fuelMoveVolume') {
                      // For fuel consumption, show with 1 decimal precision to match the tooltip
                      return parseFloat(value.toFixed(1));
                    }
                    return Math.round(value); // Show as integer for others
                  }
                  return value;
                },
                verticalAlign: 'bottom',
                inside: true,
                style: {
                  fontSize: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? '12px' : '11px',
                  color: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? '#fff' : '#333',
                  fill: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? '#fff' : '#333',
                  textOutline: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? false : '1px contrast',
                  fontWeight: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? 'normal' : 'bold'
                }
              }
            };
          }
          return series;
        });

        // Check if all values in the first series are zero, adjust yAxis if needed
        if (allFirstSeriesZero(modifiedSeriesData)) {
          chartOptions.yAxis = {
            min: 0,
            max: 1, // Set a small range to keep zero bars visible at bottom
            title: { text: null },
            endOnTick: false,
            visible: false,
            step: 1,
          };
        }

        chartOptions.series = modifiedSeriesData;
      } else {
        chartOptions.series = seriesData;
      }
    } else {
      // Check if all values in the single series are zero
      const allValuesZero = processedData && processedData.length > 0 && processedData.every(point => {
        const value = typeof point === 'object' && point.y !== undefined ? point.y : point;
        return value === 0 || value === null || value === undefined;
      });

      if (allValuesZero) {
        chartOptions.yAxis = {
          min: 0,
          max: 1, // Set a small range to keep zero bars visible at bottom
          title: { text: null },
          step: 1,
          visible: false, // Hide the yAxis
          endOnTick: false,
        };
      }

      chartOptions.series = [{ data: processedData }];
    }
  } else if (seriesData) {
    // For non-stacked charts with seriesData, apply the same logic
    if (fieldName && ['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) {
      // Process each series to add columnVal to the green series (#1E9764) or blue series when green is hidden
      const modifiedSeriesData = seriesData.map((series, index) => {
        // Check if this is chartData9 or chartData10 (onLinePercentage, avgSpeed) where green series is hidden
        if (fieldName && ['onLinePercentage', 'avgSpeed'].includes(fieldName) && series.color === '#00426A') {
          // For blue series in these charts, add dataLabels that show the green series values
          // Find the green series data to use for the labels
          const greenSeries = seriesData.find(s => s.color === '#1E9764');
          if (greenSeries) {
            return {
              ...series,
              dataLabels: {
                allowOverlap: true,
                enabled: true,
                formatter: function() {
                  // Use the corresponding value from the green series (columnVal)
                  const greenValue = greenSeries.data[this.point.index];
                  if (typeof greenValue === 'number') {
                    // Format based on the fieldName
                    if (fieldName === 'onLinePercentage') {
                      return Math.round(greenValue) + ' %'; // Show as percentage
                    } else if (fieldName === 'avgSpeed') {
                      // For avgSpeed, show with 1 decimal precision and remove .0 if needed
                      const roundedValue = Number(greenValue.toFixed(1));
                      const displayValue = Number.isInteger(roundedValue) ? Math.round(greenValue) : roundedValue;
                      return displayValue + '<br/>км/ч'; // Show as km/h on new line
                    }
                    return Math.round(greenValue); // Show as integer for others
                  }
                  return greenValue;
                },
                verticalAlign: 'bottom',
                inside: true,
                style: {
                  fontSize: '11px',
                  color: '#333'
                  // fontSize: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? '12px' : '11px',
                  // color: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? '#fff' : '#333',
                }
              }
            };
          }
        }
        // For other charts or the green series, use the original logic
        else if (series.color === '#1E9764') {
          return {
            ...series,
            dataLabels: {
              allowOverlap: true,
              enabled: true,
              formatter: function() {
                const value = this.y;
                if (typeof value === 'number') {
                  // Format based on the fieldName
                  if (fieldName === 'engineTimeInMotion') {
                    return formatHoursToHHMM(value); // Format as HH:MM
                  } else if (fieldName === 'onLinePercentage') {
                    return Math.round(value) + ' %'; // Show as percentage
                  } else if (fieldName === 'avgSpeed') {
                    return Math.round(value) + '<br/>км/ч'; // Show as km/h on new line
                  }
                  return Math.round(value); // Show as integer for others
                }
                return value;
              },
              verticalAlign: 'bottom',
              inside: true,
              style: {
                fontSize: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? '12px' : '11px',
                color: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? '#fff' : '#333',
                fill: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? '#fff' : '#333',
                textOutline: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? false : '1px contrast',
                fontWeight: fieldName && (['onLinePercentage', 'avgSpeed', 'fuelMove', 'fuelMoveVolume', 'engineTimeInMotion'].includes(fieldName)) ? 'normal' : 'bold',
                align: 'center' // Center the text horizontally
              }
            }
          };
        }
        return series;
      });

      // Check if all values in the first series are zero, adjust yAxis if needed
      if (allFirstSeriesZero(modifiedSeriesData)) {
        chartOptions.yAxis = {
          min: 0,
          max: 1, // Set a small range to keep zero bars visible at bottom
          title: { text: null },
          step: 1,
          visible: false, // Hide the yAxis
          endOnTick: false,
        };
      }

      chartOptions.series = modifiedSeriesData;
    } else {
      // Check if all values in the first series are zero, adjust yAxis if needed
      if (allFirstSeriesZero(seriesData)) {
        chartOptions.yAxis = {
          min: 0,
          max: 1, // Set a small range to keep zero bars visible at bottom
          title: { text: null },
          step: 1,
          visible: false, // Hide the yAxis
          endOnTick: false,
        };
      }
      chartOptions.series = seriesData;
    }
  } else {
    // For non-stacked charts with no seriesData (single series), check if all values are zero
    const allValuesZero = processedData && processedData.length > 0 && processedData.every(point => {
      const value = typeof point === 'object' && point.y !== undefined ? point.y : point;
      return value === 0 || value === null || value === undefined;
    });

    if (allValuesZero) {
      chartOptions.yAxis = {
        min: 0,
        max: 1, // Set a small range to keep zero bars visible at bottom
        title: { text: null },
        step: 1,
        visible: false, // Hide the yAxis
        endOnTick: false,
      };
    }
  }

  return chartOptions;
};

const getTileObject = (id) => {
    return L.tileLayer(
      'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}',
      {
        attribution: '',
        // 'Map data &copy; <a href="https://www.openstreetmap.org/" target="_blank">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/" target="_blank">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/" target="_blank">Mapbox</a>',
        tileSize: 512,
        maxZoom: 17,
        zoomOffset: -1,
        id,
        accessToken:
          'pk.eyJ1IjoiaXVyaWktNTA1IiwiYSI6ImNqemlldHRqbzA4NjYzbW84bTQ0OXMzNXkifQ.tPUaHbgVZ6vCSpuxk3IUJA',
      },
    );
  }

const initHeatmap = () => {
  if (heatmap.value) {
    heatmap.value.remove();
  }

  const shema = getTileObject('mapbox/streets-v11');
  const satellite = getTileObject('mapbox/satellite-streets-v9');
  const osm = L.tileLayer(
    'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    {
      attribution: '',
      maxZoom: 17,
    },
  );

  const map = L.map('vehicle-heatmap', {
    layers: [shema],
    attributionControl: false, // Отключаем watermark Leaflet
  }).setView([50, 60], 5);

  const baseMaps = {
    'Схема Mapbox': shema,
    'Схема OpenStreet': osm,
    'Спутник Mapbox': satellite,
  };

  L.control.layers(baseMaps).addTo(map);

  // const heatmapData = getHeatmapData();

  // console.log("heatmapData", heatmapData);

  // const heatLayer = L.heatLayer(heatmapData, {
  //   radius: 20,
  //   blur: 15,
  //   maxZoom: 18,
  //   minOpacity: 0.4,
  //   gradient: {
  //     0.1: 'blue',
  //     0.2: 'lime',
  //     0.3: 'red',
  //   }
  // }).addTo(map);

  heatmap.value = map;

  // if (heatmapData.length > 0) {
  //   const bounds = L.latLngBounds(heatmapData.map(p => [p[0], p[1]]));
  //   heatmap.value.fitBounds(bounds.pad(0.1));
  // }

  L.control.scale().addTo(map);

  // setTimeout(function() {
  //   map.invalidateSize();
  // }, 400);
};

const initCharts = () => {
  if (!Highcharts) return;
  // Check if we have at least one chart container available either from dynamic refs or static refs
  const hasChartContainer = violationChartRefs.value && violationChartRefs.value.length > 0;
  if (!hasChartContainer) return;

  chartInstances.forEach((instance, index) => {
    if (instance) {
      instance.destroy();
      chartInstances[index] = null;
    }
  });

  // Нарушения
  const chartData1 = calculateSumData('dvs_cnt');              // ДВС
  const chartData2 = calculateSumData('transmission_cnt');     // Трансмиссия
  const chartData3 = calculateSumData('kom_cnt');              // Ком
  const chartData4 = calculateSumData('bezop_cnt');            // Сумма нарушений

  // Лампы
  const {categories: categories5, data: data5, columnVals: columnVals5, userCounts: userCounts5, actualValues: actualValues5, begins: begins5} = calculateSumData('sumRedLamp');           // Красная лампа
  const {categories: categories6, data: data6, columnVals: columnVals6, userCounts: userCounts6, actualValues: actualValues6, begins: begins6} = calculateSumData('sumYellowLamp');        // Жёлтая лампа
  const {categories: categories7, data: data7, columnVals: columnVals7, userCounts: userCounts7, actualValues: actualValues7, begins: begins7} = calculateSumData('sumNonElectronic');     // Не связана с электроникой
  const {categories: categories8, data: data8, columnVals: columnVals8, userCounts: userCounts8, actualValues: actualValues8, begins: begins8} = calculateSumData('sumCo2Impact');         // Выбросы СО2

  const chartData5 = {categories: categories5, data: data5, actualValues: actualValues5, columnVals: columnVals5, userCounts: userCounts5, begins: begins5};
  const chartData6 = {categories: categories6, data: data6, actualValues: actualValues6, columnVals: columnVals6, userCounts: userCounts6, begins: begins6};
  const chartData7 = {categories: categories7, data: data7, actualValues: actualValues7, columnVals: columnVals7, userCounts: userCounts7, begins: begins7};
  const chartData8 = {categories: categories8, data: data8, actualValues: actualValues8, columnVals: columnVals8, userCounts: userCounts8, begins: begins8};

  // Выход тс на линию
  const chartData9 = calculateOnLineData();                    // На линии (синий) и процент юзеров (зеленый)

  // Среднесуточный пробег и средняя скорость
  const chartData10 = calculateDistanceAndSpeedData();         // Среднесуточный пробег (синий) и средняя скорость (зеленый)

  // Объемы топлива
  const chartData11 = calculateFuelVolumeData(groupingType.value); // Расход топлива по парку (синий) и суммарный расход топлива в движении (зеленый)

  // Расход топлива
  const chartData12 = calculateFuelConsumptionData();          // Средний расход топлива 100 км (синий) и средний расход топлива 100 км в движении (зеленый)

  // Время работы двигателя
  const chartData13 = calculateEngineTimeData();               // Время работы двигателя (синий) и время работы двигателя в движении (зеленый)

  // Объем сливов
  const {categories: categories14, data: data14, columnVals: columnVals14, userCounts: userCounts14, begins: begins14} = calculateSumData('sumFuelsOut');         // Объем сливов
  const chartData14 = {categories: categories14, data: data14, begins: begins14};

  // Create violation charts with dynamic refs
  // Calculate the maximum across violation charts (0-3)
  const violationChartsData1 = chartData1?.data || []
  const violationChartsData2 = chartData2?.data || []
  const violationChartsData3 = chartData3?.data || []
  const violationChartsData4 = chartData4?.data || []

  const violationChartsMaxValue1 = violationChartsData1.length > 0
    ? Math.max(...violationChartsData1.filter(val => typeof val === 'number' && !isNaN(val)))
    : 100;
  const violationChartsMaxValue2 = violationChartsData2.length > 0
    ? Math.max(...violationChartsData2.filter(val => typeof val === 'number' && !isNaN(val)))
    : 100;
  const violationChartsMaxValue3 = violationChartsData3.length > 0
    ? Math.max(...violationChartsData3.filter(val => typeof val === 'number' && !isNaN(val)))
    : 100;
  const violationChartsMaxValue4 = violationChartsData4.length > 0
    ? Math.max(...violationChartsData4.filter(val => typeof val === 'number' && !isNaN(val)))
    : 100;
  

  if (violationChartRefs.value && violationChartRefs.value.length >= 4) {
    chartInstances[0] = Highcharts.chart(violationChartRefs.value[0], createChartOptions(
      'ДВС',
      chartData1.categories,
      chartData1.data,
      321,
      172,
      '14px',
      true,
      false,
      null,
      true,  // isViolationChart
      null,
      false,
      chartData1.columnVals,
      chartData1.userCounts,
      chartData1.actualValues,
      0,  // chartIndex
      null, // extraData
      violationChartsMaxValue1, // groupMaxValue for violation charts
      chartData1.begins
    ));

    chartInstances[1] = Highcharts.chart(violationChartRefs.value[1], createChartOptions(
      'ТРАНСМИССИЯ',
      chartData2.categories,
      chartData2.data,
      321,
      172,
      '14px',
      true,
      false,
      null,
      true,  // isViolationChart
      null,
      false,
      chartData2.columnVals,
      chartData2.userCounts,
      chartData2.actualValues,
      1,  // chartIndex
      null, // extraData
      violationChartsMaxValue2, // groupMaxValue for violation charts
      chartData2.begins
    ));

    chartInstances[2] = Highcharts.chart(violationChartRefs.value[2], createChartOptions(
      'РАБОТА КОМ',
      chartData3.categories,
      chartData3.data,
      321,
      172,
      '14px',
      true,
      false,
      null,
      true,  // isViolationChart
      null,
      false,
      chartData3.columnVals,
      chartData3.userCounts,
      chartData3.actualValues,
      2,  // chartIndex
      null, // extraData
      violationChartsMaxValue3, // groupMaxValue for violation charts
      chartData3.begins
    ));

    chartInstances[3] = Highcharts.chart(violationChartRefs.value[3], createChartOptions(
      'СУММА НАРУШЕНИЙ',
      chartData4.categories,
      chartData4.data,
      321,
      172,
      '14px',
      true,
      false,
      null,
      true,  // isViolationChart
      null,
      false,
      chartData4.columnVals,
      chartData4.userCounts,
      chartData4.actualValues,
      3,  // chartIndex
      null, // extraData
      violationChartsMaxValue4, // groupMaxValue for violation charts
      chartData4.begins
    ));

    // Add data label positioning logic for chartInstances[0] - chartInstances[3] (violation charts)
    // Similar to chartInstances[9] - chartInstances[12], show columnVal inside columns for values below threshold
    [0, 1, 2, 3].forEach((chartIdx) => {
      const chart = chartInstances[chartIdx];
      const chartData = [chartData1, chartData2, chartData3, chartData4][chartIdx];
      const maxValue = [violationChartsMaxValue1, violationChartsMaxValue2, violationChartsMaxValue3, violationChartsMaxValue4][chartIdx];

      if (chart && chartData && chartData.columnVals) {
        const maxThreshold = maxValue * 0.18;
        let maxBelowThresholdY = -Infinity;

        // First pass: find the maximum height among columns below threshold
        chart.series[0].points.forEach((point) => {
          if (point && point.y < maxThreshold && point.shapeArgs.height > maxBelowThresholdY) {
            maxBelowThresholdY = point.shapeArgs.height;
          }
        });

        // Second pass: update data labels for columns below threshold
        if (maxBelowThresholdY !== -Infinity) {
          chart.series[0].points.forEach((point) => {
            if (point && point.y < maxThreshold) {
              point.update({
                dataLabels: {
                  verticalAlign: 'top',
                  inside: false,
                  y: point.shapeArgs.height - maxBelowThresholdY,
                  style: {
                    color: '#000',
                    fontSize: '12px',
                    fontWeight: 'normal',
                    textOutline: false
                  }
                }
              }, false);
            }
          });
        }
        chart.redraw();
      }
    });
  }

  // для chartInstances[4] - chartInstances[7] обязательно actualValues
  // Calculate the maximum columnVal across ALL lamp charts (4-7) for consistent Y-axis scaling
  const lampChartsColumnVals = [
    ...(chartData5?.columnVals || []),
    ...(chartData6?.columnVals || []),
    ...(chartData7?.columnVals || []),
    ...(chartData8?.columnVals || [])
  ];

  const lampChartsMaxColumnVal = lampChartsColumnVals.length > 0
    ? Math.max(...lampChartsColumnVals.filter(val => typeof val === 'number' && !isNaN(val)))
    : 10; // default value

  // Create malfunction charts with dynamic refs
  if (malfunctionChartRefs.value && malfunctionChartRefs.value.length >= 4) {
    chartInstances[4] = Highcharts.chart(malfunctionChartRefs.value[0], createChartOptions(
      'КРАСНАЯ ЛАМПА',
      chartData5.categories,
      chartData5.data,
      321, 94, '11px', true, null, false, false, 'sumRedLamp', true, chartData5.columnVals, chartData5.userCounts, chartData5.actualValues, 4, null, lampChartsMaxColumnVal, chartData5.begins
    ));

    chartInstances[5] = Highcharts.chart(malfunctionChartRefs.value[1], createChartOptions(
      'ЖЁЛТАЯ ЛАМПА',
      chartData6.categories,
      chartData6.data,
      321, 94, '11px', true, null, false, false, 'sumYellowLamp', true, chartData6.columnVals, chartData6.userCounts, chartData6.actualValues, 5, null, lampChartsMaxColumnVal, chartData6.begins
    ));

    chartInstances[6] = Highcharts.chart(malfunctionChartRefs.value[2], createChartOptions(
      'Не связана с электроникой',
      chartData7.categories,
      chartData7.data,
      321, 94, '11px', true, null, false, false, 'sumNonElectronic', true, chartData7.columnVals, chartData7.userCounts, chartData7.actualValues, 6, null, lampChartsMaxColumnVal, chartData7.begins
    ));

    chartInstances[7] = Highcharts.chart(malfunctionChartRefs.value[3], createChartOptions(
      'Выбросы СО2',
      chartData8.categories,
      chartData8.data,
      321, 94, '11px', true, null, false, false, 'sumCo2Impact', true, chartData8.columnVals, chartData8.userCounts, chartData8.actualValues, 7, null, lampChartsMaxColumnVal, chartData8.begins
    ));
  } 

  // Calculate individual max values for chartInstances[8] - chartInstances[13]
  const chart8MaxValue = chartData9 && chartData9.data && chartData9.data.length > 0
    ? Math.max(...chartData9.data.filter(val => typeof val === 'number' && !isNaN(val)))
    : 10; // default value
  const chart8MaxColumnValue = chartData9 && chartData9.data && chartData9.data.length > 0
    ? Math.max(...chartData9.columnVals.filter(val => typeof val === 'number' && !isNaN(val)))
    : 10; // default value

  const chart9MaxValue = chartData10 && chartData10.data && chartData10.data.length > 0
    ? Math.max(...chartData10.data.filter(val => typeof val === 'number' && !isNaN(val)))
    : 10; // default value

  const chart10MaxValue = chartData11 && chartData11.data && chartData11.data.length > 0
    ? Math.max(...chartData11.data.filter(val => typeof val === 'number' && !isNaN(val)))
    : 10; // default value

  const chart11MaxValue = chartData12 && chartData12.data && chartData12.data.length > 0
    ? Math.max(...chartData12.data.filter(val => typeof val === 'number' && !isNaN(val)))
    : 10; // default value

  const chart12MaxValue = chartData13 && chartData13.rawNumericData && chartData13.rawNumericData.length > 0
    ? Math.max(...chartData13.rawNumericData.filter(val => typeof val === 'number' && !isNaN(val)))
    : 10; // default value

  const chart13MaxValue = chartData14 && chartData14.data && chartData14.data.length > 0
    ? Math.max(...chartData14.data.filter(val => typeof val === 'number' && !isNaN(val)))
    : 10; // default value

  // Create work charts with dynamic refs
  if (workChartRefs.value && workChartRefs.value.length >= 6) {
chartInstances[8] = Highcharts.chart(workChartRefs.value[0], createChartOptions(
      'Выход ТС на линию',
      chartData9.categories,
      chartData9.data,
      321, 172, '14px', true, true, [
        { data: chartData9.data, color: '#00426A', borderColor: '#002b47' },
        { data: chartData9.columnVals, color: '#1E9764', borderColor: '#166d47', visible: false }
      ], false, 'onLinePercentage', false, null, null, null, 8, { data: chartData9.data, columnVals: chartData9.columnVals }, chart8MaxValue
    ));
    
    const maxThreshold8 = 15;
    if (chartInstances[8] && chartData9.data && chartData9.columnVals) {
      let maxBelowThresholdY = -Infinity;
      console.log("points", chartInstances[8].series[0].points)
      chartInstances[8].series[0].points.forEach((point, i) => {
        if (point && point.shapeArgs.height < maxThreshold8) {
          maxBelowThresholdY = point.shapeArgs.height;
        }
      });

      if (maxBelowThresholdY !== -Infinity) {
        chartInstances[8].series[0].points.forEach((point, i) => {
          if (point && point.shapeArgs.height < maxThreshold8) {
            point.update({
              dataLabels: {
                verticalAlign: 'bottom',
                inside: false,
                y: 0, //point.shapeArgs.height - maxBelowThresholdY,
                style: {
                  color: '#000'
                }
              }
            }, false); // false to prevent redrawing immediately
          }
        });
      }
      chartInstances[8].redraw(); // Redraw after all updates
    }

    chartInstances[9] = Highcharts.chart(workChartRefs.value[1], createChartOptions(
      'Среднесуточный пробег ТС, км.',
      chartData10.categories,
      chartData10.data,
      321, 172, '14px', true, true, [
        { data: chartData10.data, color: '#00426A', borderColor: '#002b47' },
        { data: chartData10.columnVals, color: '#1E9764', borderColor: '#166d47', visible: false }
      ], false, 'avgSpeed', false, null, chartData10.userCounts, null, 9, { data: chartData10.data, columnVals: chartData10.columnVals }, chart9MaxValue
    ));

    const maxThreshold9 = chart9MaxValue * 0.24;
    if (chartInstances[9] && chartData10.data && chartData10.columnVals) {
      let maxBelowThresholdY = -Infinity;
      chartInstances[9].series[0].points.forEach((point, i) => {
        if (point && point.y < maxThreshold9 && point.shapeArgs.height > maxBelowThresholdY) {
          maxBelowThresholdY = point.shapeArgs.height;
        }
      });

      if (maxBelowThresholdY !== -Infinity) {
        chartInstances[9].series[0].points.forEach((point, i) => {
          if (point && point.y < maxThreshold9) {
            point.update({
              dataLabels: {
                verticalAlign: 'top',
                inside: false,
                y: point.shapeArgs.height - maxBelowThresholdY,
                style: {
                  color: '#000'
                }
              }
            }, false);
          }
        });
      }
      chartInstances[9].redraw();
    }

    chartInstances[10] = Highcharts.chart(workChartRefs.value[2], createChartOptions(
      workChartsData.value.find(chart => chart.id === 'fuel_volume')?.title || 'Расход топлива по парку, литров',
      chartData11.categories,
      chartData11.data,
      321, 172, '14px', true, true, [
        { data: chartData11.data, color: '#00426A', borderColor: '#002b47' },
        { data: chartData11.columnVals, color: '#1E9764', borderColor: '#166d47' }
      ], false, 'fuelMove', false, null, chartData11.userCounts, null, 10, { data: chartData11.data, columnVals: chartData11.columnVals }, chart10MaxValue
    ));
    
    const maxThreshold10 = chart10MaxValue * 0.24;
    if (chartInstances[10] && chartData11.data && chartData11.columnVals) {
      const yAxis = chartInstances[10].yAxis[0];
      const blueSeries = chartInstances[10].series[0];
      const greenSeries = chartInstances[10].series[1];

      blueSeries.points.forEach((bluePoint, i) => {
        const greenPoint = greenSeries.points[i];

        if (bluePoint && greenPoint) {
          const blueValue = bluePoint.y;
          const greenValue = greenPoint.y;
          const blueSpaceAboveGreenValue = blueValue - greenValue;

          const blueYPix = yAxis.toPixels(blueValue, true);
          const greenYPix = yAxis.toPixels(greenValue, true);
          
          // Расстояние в пикселях от верха синей колонки до верха зеленой
          const pixelsToGreenTop = blueYPix - greenYPix;

          let labelConfig = {};

          // Сценарий 1: В зеленой колонке хватает места
          if (greenValue >= maxThreshold10) {
            labelConfig = {
              verticalAlign: 'bottom',
              inside: true,
              y: 0,
              style: { color: '#fff' }
            };
          }
          // Сценарий 2: В зеленой мало места, но в синей над ней пространства достаточно
          else if (-pixelsToGreenTop >= maxThreshold10) {
            labelConfig = {
              verticalAlign: 'top',
              inside: false,
              y: 0,
              style: { color: '#fff' }
            };
          }
          // Сценарий 3: И там, и там мало места — выносим текст НАД синей колонкой
          else {
            labelConfig = {
              verticalAlign: 'top',
              inside: false,
              y: 0 + pixelsToGreenTop,
              style: { color: '#000' }
            };
          }

          greenPoint.update({
            dataLabels: labelConfig
          }, false);
        }
      });

      chartInstances[10].redraw();
    }

    chartInstances[11] = Highcharts.chart(workChartRefs.value[3], createChartOptions(
      'Расход топлива по парку, литров',
      chartData12.categories,
      chartData12.data,
      321, 172, '14px', true, true, [
        { data: chartData12.data, color: '#00426A', borderColor: '#002b47' },
        { data: chartData12.columnVals, color: '#1E9764', borderColor: '#166d47' }
      ], false, 'fuelMoveVolume', false, null, chartData12.userCounts, null, 11, { data: chartData12.data, columnVals: chartData12.columnVals }, chart11MaxValue
    ));
    
    const maxThreshold11 = chart11MaxValue * 0.24;
    if (chartInstances[11] && chartData12.data && chartData12.columnVals) {
      const yAxis = chartInstances[11].yAxis[0];
      const blueSeries = chartInstances[11].series[0];
      const greenSeries = chartInstances[11].series[1];

      blueSeries.points.forEach((bluePoint, i) => {
        const greenPoint = greenSeries.points[i];

        if (bluePoint && greenPoint) {
          const blueValue = bluePoint.y;
          const greenValue = greenPoint.y;
          const blueSpaceAboveGreenValue = blueValue - greenValue;

          const blueYPix = yAxis.toPixels(blueValue, true);
          const greenYPix = yAxis.toPixels(greenValue, true);
          
          // Расстояние в пикселях от верха синей колонки до верха зеленой
          const pixelsToGreenTop = blueYPix - greenYPix;

          let labelConfig = {};

          // Сценарий 1: В зеленой колонке хватает места
          if (greenValue >= maxThreshold11) {
            labelConfig = {
              verticalAlign: 'bottom',
              inside: true,
              y: 0,
              style: { color: '#fff' }
            };
          }
          // Сценарий 2: В зеленой мало места, но в синей над ней пространства достаточно
          else if (-pixelsToGreenTop >= maxThreshold11) {
            labelConfig = {
              verticalAlign: 'top',
              inside: false,
              y: 0,
              style: { color: '#fff' }
            };
          }
          // Сценарий 3: И там, и там мало места — выносим текст НАД синей колонкой
          else {
            labelConfig = {
              verticalAlign: 'top',
              inside: false,
              y: 0 + pixelsToGreenTop,
              style: { color: '#000' }
            };
          }

          greenPoint.update({
            dataLabels: labelConfig
          }, false);
        }
      });

      chartInstances[11].redraw();
    }

    chartInstances[12] = Highcharts.chart(workChartRefs.value[4], createChartOptions(
      'Время работы ДВС',
      chartData13.categories,
      chartData13.rawNumericData,  // Use raw numeric values for chart
      321, 172, '14px', true, true, [
        { data: chartData13.rawNumericData, color: '#00426A', borderColor: '#002b47' },  // Use raw values for chart
        { data: chartData13.rawEngineTimeInMotionData, color: '#1E9764', borderColor: '#166d47' }  // Use raw values for chart
      ], false, 'engineTimeInMotion', false, null, null, null, 12, { data: chartData13.data, engineTimeInMotionData: chartData13.engineTimeInMotionData }, chart12MaxValue
    ));
    
    const maxThreshold12 = chart12MaxValue * 0.24;
    if (chartInstances[12] && chartData13.data) {
      const yAxis = chartInstances[12].yAxis[0];
      const blueSeries = chartInstances[12].series[0];
      const greenSeries = chartInstances[12].series[1];

      blueSeries.points.forEach((bluePoint, i) => {
        const greenPoint = greenSeries.points[i];

        if (bluePoint && greenPoint) {
          const blueValue = bluePoint.y;
          const greenValue = greenPoint.y;
          const blueSpaceAboveGreenValue = blueValue - greenValue;

          const blueYPix = yAxis.toPixels(blueValue, true);
          const greenYPix = yAxis.toPixels(greenValue, true);
          
          // Расстояние в пикселях от верха синей колонки до верха зеленой
          const pixelsToGreenTop = blueYPix - greenYPix;

          let labelConfig = {};

          // Сценарий 1: В зеленой колонке хватает места
          if (greenValue >= maxThreshold12) {
            labelConfig = {
              verticalAlign: 'bottom',
              inside: true,
              y: 0,
              style: { color: '#fff' }
            };
          }
          // Сценарий 2: В зеленой мало места, но в синей над ней пространства достаточно
          else if (-pixelsToGreenTop >= maxThreshold12) {
            labelConfig = {
              verticalAlign: 'top',
              inside: false,
              y: 0,
              style: { color: '#fff' }
            };
          }
          // Сценарий 3: И там, и там мало места — выносим текст НАД синей колонкой
          else {
            labelConfig = {
              verticalAlign: 'top',
              inside: false,
              y: 0 + pixelsToGreenTop,
              style: { color: '#000' }
            };
          }

          greenPoint.update({
            dataLabels: labelConfig
          }, false);
        }
      });

      chartInstances[12].redraw();
    }

    chartInstances[13] = Highcharts.chart(workChartRefs.value[5], createChartOptions(
      workChartsData.value.find(chart => chart.id === 'fuel_out')?.title || 'Объем сливов, литров',
      chartData14.categories,
      chartData14.data,
      321, 172, '14px', true, false, null, false, 'sumFuelsOut', false, chartData14.columnVals, chartData14.userCounts, chartData14.actualValues, 13, null, chart13MaxValue
    ));
  }
};

onBeforeMount(() => {
  isRequestingReport.value = false;

  // Очищаем innerHTML у #section-violations перед teleport
  const sectionViolations = document.getElementById('section-violations');
  if (sectionViolations) {
    sectionViolations.innerHTML = '';
  }
});

onMounted(() => {
  console.log("testdata", testData.value, props.data);
  testData.value = props.data.data;

  // Добавляем задержку 0.3 секунды для tooltip Highcharts
  // Tooltip показывается только если курсор находится над точкой более 0.3с
  Highcharts.wrap(Highcharts.Tooltip.prototype, 'refresh', function(proceed, ...args) {
    const tooltip = this;
    if (tooltip.refreshTimeout) {
      clearTimeout(tooltip.refreshTimeout);
    }
    tooltip.refreshTimeout = setTimeout(() => {
      proceed.apply(tooltip, args);
    }, 200);
  });

  // Очищаем таймер при скрытии tooltip (курсор ушёл с точки)
  Highcharts.wrap(Highcharts.Tooltip.prototype, 'hide', function(proceed) {
    const tooltip = this;
    if (tooltip.refreshTimeout) {
      clearTimeout(tooltip.refreshTimeout);
    }
    proceed.call(this);
  });

  if (props.form_desc?.objects && props.form_desc.objects.length > 0 &&
    Object.keys(globalObjectsList).length > 0) {
    selectedTsListSync.value = [...props.form_desc.objects];
    objectsListUpdateTrigger.value = Date.now();
  }

  if (testData.value && testData.value.length > 0 && testData.value[0].data) {
    const firstData = testData.value[0].data;
    if (firstData.interval_begin && firstData.interval_end) {
      dateRange.value = [new Date(firstData.interval_begin * 1000), new Date(firstData.interval_end * 1000)];
    }
  }
  buttonDone()
  clearScreen();
  displayTemplate()
  if (isViolationsActive.value) {
    console.log("[initHeatmap]");
    initHeatmap();
    heatmapInitialized.value = true;
  }
});

onBeforeUnmount(() => {
  chartInstances.forEach((instance, index) => {
    if (instance) {
      instance.destroy();
      chartInstances[index] = null;
    }
  });
});

const buttonDone = () => {
  const button = document.getElementById('get-template-button');
  const targetSpan = getNeighborByClass_helper(button, 'target-show-span');
  if (!button || !targetSpan) return;
  targetSpan.innerHTML = 'Отчет выполнен';
  setElementColor_helper(button, 'green');
}

const displayTemplate = async () => {
  console.log("displayTemplate", props.data);

  await nextTick();

  if (Highcharts && props.data && props.data.data) {
    initCharts();
  }
};

const clearScreen = () => {
  // удаляет только тест "Получен ответ 1 из 1 (100%)"
  const el = document.getElementById('section-violations');
  // templateContentElement.innerHTML = '';

  for (let i = el.childNodes.length - 1; i >= 0; i--) {
    const node = el.childNodes[i];
    // Если это текстовый узел — удаляем
    if (node.nodeType === Node.TEXT_NODE) {
      el.removeChild(node);
    }
  }
}

const currentViolationType = ref('dvs_cnt');

const isTrackRequestAllowed = computed(() => {
  return ['dvs_cnt', 'transmission_cnt', 'kom_cnt', 'bezop_cnt'].includes(currentViolationType.value);
});

const showHeatmapPopup = ref(false);
const popupVehicleName = ref('');
const popupObjectId = ref(null);
const popupTimeBegin = ref(0);
const popupTimeEnd = ref(0);
const popupHeatmapPositions = ref([]);

const violationIdsByType = {
  'dvs_cnt': [2, 4, 5, 20, 33, 34, 35],
  'transmission_cnt': [8, 9, 10, 11, 12, 13, 14, 15, 18, 19, 40, 42, 43, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 80, 81],
  'kom_cnt': [16, 17, 27, 28, 29, 30, 78, 79],
  'bezop_cnt': [2, 4, 5, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 27, 28, 29, 30, 33, 34, 35, 40, 42, 43, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 78, 79, 80, 81],
};

const popupViolations = computed(() => {
  const type = showHeatmapPopup.value;
  if (!type) return [];
  const ids = violationIdsByType[type] || [];
  const desc = violationsDescriptions._desc || [];
  return desc.filter(v => ids.includes(Number(v.id)));
});

const openHeatmapPopup = async (type, item, date) => {
  console.log("openHeatmapPopup", type, item, date);
  const vehicleName = showVinColumn.value
    ? (item?.data?.objConf?.vin || 'Н/Д')
    : (item?.data?.objConf?.state_number || 'Н/Д');

  popupVehicleName.value = vehicleName;
  popupObjectId.value = item?.data?.objConf?.id;
  popupTimeBegin.value = date * 1000;
  popupTimeEnd.value = date * 1000 + 86400000;

  showHeatmapPopup.value = type;
  await loadPopupHeatmapData(type);
};

const closeHeatmapPopup = () => {
  showHeatmapPopup.value = false;
  popupHeatmapPositions.value = [];
};

const loadPopupHeatmapData = async (type) => {
  const apiType = violationTypeMapping[type];
  if (!apiType) return;

  if (mapDataCache.value[apiType]) {
    popupHeatmapPositions.value = mapDataCache.value[apiType].posArray || [];
    return;
  }

  try {
    const objectIds = testData.value
      .map(item => item.data?.objConf?.id)
      .filter(id => id);

    if (objectIds.length === 0) return;

    const isFuelOut = type === 'fuel_out';
    const allPositions = [];
    let combinedData = { posArray: [] };

    if (isFuelOut) {
      const BATCH_SIZE = 50;
      for (let i = 0; i < objectIds.length; i += BATCH_SIZE) {
        const batch = objectIds.slice(i, i + BATCH_SIZE);
        const params = new URLSearchParams({
          ids: batch.join(','),
          time_begin: Math.floor(dateRange.value[0] / 1000),
          time_end: Math.floor(dateRange.value[1] / 1000),
          tzh: getTzh(),
          type: apiType,
        });
        const data = await fetchJson((process.env.VUE_APP_BACKEND_URL || window.location.origin) + `/Api/getDashboardMapPositions?${params}`);
        if (data?.posArray) allPositions.push(...data.posArray);
      }
      combinedData.posArray = allPositions;
    } else {
      const MAX_CONCURRENT = 3;
      let currentIndex = 0;
      const fetchNext = async () => {
        while (currentIndex < objectIds.length) {
          const idx = currentIndex++;
          const params = new URLSearchParams({
            id: objectIds[idx],
            time_begin: Math.floor(dateRange.value[0] / 1000),
            time_end: Math.floor(dateRange.value[1] / 1000),
            tzh: getTzh(),
            type: apiType,
          });
          const data = await fetchJson((process.env.VUE_APP_BACKEND_URL || window.location.origin) + `/Api/getDashboardMapPositions?${params}`);
          if (data?.posArray) allPositions.push(...data.posArray);
        }
      };
      await Promise.all(Array.from({ length: MAX_CONCURRENT }, () => fetchNext()));
      combinedData.posArray = allPositions;
    }

    mapDataCache.value[apiType] = combinedData;
    popupHeatmapPositions.value = combinedData.posArray || [];
  } catch (e) {
    console.error('Ошибка загрузки данных для popup heatmap:', e);
  }
};

const hideViolationPanel = () => {
  showViolationPanel.value = false;
  // Сбрасываем сортировку и подробную таблицу при закрытии панели
  sortColumn.value = null;
  sortDirection.value = 'asc';
  showDetailedTable.value = false;
  selectedVehicle.value = null;
  isHeatmapExpanded.value = false;
};

const toggleHeatmapExpand = () => {
  if (!showViolationPanel.value) return;
  isHeatmapExpanded.value = !isHeatmapExpanded.value;
  // nextTick(() => {
  //   setTimeout(() => {
  //     heatmap.value?.invalidateSize();
  //   }, 350);
  // });
};

// Функции для модального окна с информацией о нарушениях ДВС
const showDvsInfoModalFunc = () => {
  showDvsInfoModal.value = true;
};

const hideDvsInfoModalFunc = () => {
  showDvsInfoModal.value = false;
};

// Функции для модального окна с информацией о нарушениях Трансмиссии
const showTransmissionInfoModalFunc = () => {
  showTransmissionInfoModal.value = true;
};

const hideTransmissionInfoModalFunc = () => {
  showTransmissionInfoModal.value = false;
};

// Функции для модального окна с информацией о нарушениях КОМ
const showKomInfoModalFunc = () => {
  showKomInfoModal.value = true;
};

const hideKomInfoModalFunc = () => {
  showKomInfoModal.value = false;
};

// Функции для модального окна с информацией о неисправностях Красная лампа
const showRedLampInfoModalFunc = () => {
  showRedLampInfoModal.value = true;
};

const hideRedLampInfoModalFunc = () => {
  showRedLampInfoModal.value = false;
};

// Функции для модального окна с информацией о неисправностях Жёлтая лампа
const showYellowLampInfoModalFunc = () => {
  showYellowLampInfoModal.value = true;
};

const hideYellowLampInfoModalFunc = () => {
  showYellowLampInfoModal.value = false;
};

// Функции для модального окна с информацией о неисправностях Не связана с электрикой
const showCo2InfoModalFunc = () => {
  showCo2InfoModal.value = true;
};

const hideCo2InfoModalFunc = () => {
  showCo2InfoModal.value = false;
};

// Функции для модального окна с информацией о неисправностях Выбросы СО2
const showNonElectronicInfoModalFunc = () => {
  showNonElectronicInfoModal.value = true;
};

const hideNonElectronicInfoModalFunc = () => {
  showNonElectronicInfoModal.value = false;
};

// Функции для модального окна с информацией о выходе ТС на линию
const showOnLineInfoModalFunc = () => {
  showOnLineInfoModal.value = true;
};

const hideOnLineInfoModalFunc = () => {
  showOnLineInfoModal.value = false;
};

// Функции для модального окна с информацией о среднесуточном пробеге
const showDistanceInfoModalFunc = () => {
  showDistanceInfoModal.value = true;
};

const hideDistanceInfoModalFunc = () => {
  showDistanceInfoModal.value = false;
};

// Функции для модального окна с информацией о расходе топлива по парку
const showFuelVolumeInfoModalFunc = () => {
  showFuelVolumeInfoModal.value = true;
};

const hideFuelVolumeInfoModalFunc = () => {
  showFuelVolumeInfoModal.value = false;
};

// Функции для модального окна с информацией о среднем расходе топлива
const showFuelConsumptionInfoModalFunc = () => {
  showFuelConsumptionInfoModal.value = true;
};

const hideFuelConsumptionInfoModalFunc = () => {
  showFuelConsumptionInfoModal.value = false;
};

// Функции для модального окна с информацией о времени работы ДВС
const showEngineTimeInfoModalFunc = () => {
  showEngineTimeInfoModal.value = true;
};

const hideEngineTimeInfoModalFunc = () => {
  showEngineTimeInfoModal.value = false;
};

// Функции для модального окна с информацией об объеме сливов
const showFuelOutInfoModalFunc = () => {
  showFuelOutInfoModal.value = true;
};

const hideFuelOutInfoModalFunc = () => {
  showFuelOutInfoModal.value = false;
};

// Массив полей для неисправностей ТС
const MALFUNCTION_FIELDS = [
  'sumRedLamp',
  'sumYellowLamp',
  'sumNonElectronic',
  'sumCo2Impact',
];

// Функция для кнопки "документ" - открывает панель с таблицей нарушений или неисправностей
const showViolationPanelFunc = (index = 0) => {
  // Сбрасываем сортировку и подробную таблицу при переключении между графиками
  sortColumn.value = null;
  sortDirection.value = 'asc';
  showDetailedTable.value = false;
  selectedVehicle.value = null;
  
  showViolationPanel.value = true;

  // Индексы 0-3: грубые нарушения, индекс 4-7: неисправности, индексы 8-13: работа ТС
  if (index >= 4 && index <= 7) {
    // Неисправности ТС
    isMalfunctionMode.value = true;
    isDistanceMode.value = false;
    isFuelMode.value = false;
    isFuel100Mode.value = false;
    isEngineTimeMode.value = false;
    isFuelOutMode.value = false;
    isOnLineMode.value = false;
    currentViolationType.value = MALFUNCTION_FIELDS[index - 4] || 'sumRedLamp';
  } else if (index >= 8 && index <= 13) {
    // Работа ТС
    isMalfunctionMode.value = false;
    isOnLineMode.value = index === 8; // Выход ТС на линию
    isDistanceMode.value = index === 9; // Среднесуточный пробег
    isFuelMode.value = index === 10; // Расход топлива по парку
    isFuel100Mode.value = index === 11; // Средний расход топлива л/100 км
    isEngineTimeMode.value = index === 12; // Время работы ДВС
    isFuelOutMode.value = index === 13; // Объем сливов
    currentViolationType.value = index === 10 ? 'distance' : (index === 11 ? 'fuel' : (index === 12 ? 'fuel100' : (index === 13 ? 'engineTime' : (index === 14 ? 'fuelOut' : (index === 9 ? 'onLine' : 'work')))));
  } else {
    // Грубые нарушения или сливы
    isMalfunctionMode.value = false;
    isDistanceMode.value = false;
    isFuelMode.value = false;
    isFuel100Mode.value = false;
    isEngineTimeMode.value = false;
    isFuelOutMode.value = false;
    isOnLineMode.value = false;
    currentViolationType.value = SUMPOINTSTABLE[index] || 'dvs_cnt';
  }
  // selectedTableType.value оставляем без изменений, т.к. это отдельная функция
};

// Функция для кнопки "карта" - загружает данные карты для выбранного типа нарушений
const showMapForViolationType = (index = 0) => {
  // Сбрасываем сортировку и подробную таблицу при переключении между графиками
  sortColumn.value = null;
  sortDirection.value = 'asc';
  showDetailedTable.value = false;
  selectedVehicle.value = null;
  
  // Закрываем графики панели нарушений
  showViolationPanel.value = false;

  // Сбрасываем все режимы отображения графиков
  isMalfunctionMode.value = false;
  isDistanceMode.value = false;
  isFuelMode.value = false;
  isFuel100Mode.value = false;
  isEngineTimeMode.value = false;
  isFuelOutMode.value = false;
  isOnLineMode.value = false;

  const violationType = SUMPOINTSTABLE[index] || 'dvs_cnt';
  selectedTableType.value = violationType;

  // Загружаем данные карты
  loadMapData(violationType);
};

// Получение заголовка в зависимости от режима
const getTableTitle = () => {
  if (isMalfunctionMode.value) {
    return malfunctionTitles[currentViolationType.value] || 'Неисправности ТС';
  } else if (isDistanceMode.value) {
    return 'Суточный пробег по парку ТС, км.'
  } else if (isFuelMode.value) {
    // if (groupingType.value !== 'day') {
    //   return 'Расход топлива по парку ТС по CAN данным, тысяч литров';
    // }
    return 'Расход топлива по парку ТС по CAN данным, литров';
  } else if (isFuel100Mode.value) {
    return 'Расход топлива по CAN данным, литров на 100 км.';
  } else if (isEngineTimeMode.value) {
    return 'Время работы ДВС';
  } else if (isFuelOutMode.value) {
    // if (groupingType.value !== 'day') {
    //   return 'Объем сливов, тысяч литров';
    // }
    return 'Объем сливов, литров';
  } else if (isOnLineMode.value) {
    return 'Выход ТС на линию';
  } else {
    return violationTypes[currentViolationType.value]?.title || 'Нарушения';
  }
};

const violationDates = computed(() => {
  if (!testData.value || !testData.value.length) return [];

  let currentViolationField = currentViolationType.value;

  const intervalsMap = new Map();

  testData.value.forEach(user => {
    if (user.data && user.data.posArray) {
      user.data.posArray.forEach(interval => {
        const beginTime = interval.interval_begin;
        const beginDate = new Date(beginTime * 1000);
        const day = String(beginDate.getDate()).padStart(2, '0');
        const month = String(beginDate.getMonth() + 1).padStart(2, '0');
        const dateStr = `${day}.${month}`;

        if (!intervalsMap.has(beginTime)) {
          intervalsMap.set(beginTime, {
            dateStr: dateStr,
            intervalBegin: beginTime,
            intervalEnd: interval.interval_end,
            totalValue: 0,
            columnVal: 0,
            userCount: 0,
            actualValue: 0,
            sumFieldValues: 0,
            sumDistanceValues: 0
          });
        }

        const sumDistance = interval.sumPositions?.sum_distance || 0;

        if (['dvs_cnt', 'transmission_cnt', 'kom_cnt', 'bezop_cnt'].includes(currentViolationField)) {
          if (sumDistance > minDistance) {
            const currentValue = interval.sumPositions[currentViolationField];
            const currentInterval = intervalsMap.get(beginTime);

            currentInterval.sumFieldValues += currentValue;
            currentInterval.sumDistanceValues += sumDistance;
            currentInterval.userCount += 1;
          }
        } else if (['sumRedLamp', 'sumYellowLamp', 'sumCo2Impact', 'sumNonElectronic'].includes(currentViolationField)) {
          // Для неисправностей ТС добавляем все даты, где есть значение
          if (sumDistance > minDistance && interval.sumPositions && interval.sumPositions[currentViolationField] !== undefined) {
            intervalsMap.get(beginTime).totalValue += interval.sumPositions[currentViolationField];
            intervalsMap.get(beginTime).userCount += 1;
          }
        } else if (currentViolationField === 'distance') {
          // Для среднесуточного пробега добавляем все даты, где есть sum_distance и sum_motoenginespd
          if (sumDistance > minDistance && interval.sumPositions &&
              interval.sumPositions.sum_distance !== undefined) {
            intervalsMap.get(beginTime).totalValue += interval.sumPositions.sum_distance;
            intervalsMap.get(beginTime).userCount += 1;
          }
        } else if (currentViolationField === 'fuel') {
          // Для расхода топлива добавляем все даты, где есть sum_canexpence
          if (sumDistance > minDistance && interval.sumPositions &&
              interval.sumPositions.sum_canexpence !== undefined) {
            intervalsMap.get(beginTime).totalValue += interval.sumPositions.sum_canexpence;
            intervalsMap.get(beginTime).userCount += 1;
          }
        } else if (currentViolationField === 'fuel100') {
          // Для расхода топлива на 100 км добавляем все даты, где есть sum_canexpence и sum_distance
          if (sumDistance > minDistance && interval.sumPositions &&
              (interval.sumPositions.sum_canexpence !== undefined ||
              interval.sumPositions.sum_distance !== undefined)) {
            intervalsMap.get(beginTime).totalValue += interval.sumPositions.sum_canexpence;
            intervalsMap.get(beginTime).userCount += 1;
          }
        } else if (currentViolationField === 'engineTime') {
          console.log("interval.sumPositions.sum_motoengine", interval.sumPositions);
          // Для времени работы ДВС добавляем все даты, где есть sum_motoengine
          if (sumDistance > minDistance && interval.sumPositions &&
              interval.sumPositions.sum_motoengine !== undefined) {
            intervalsMap.get(beginTime).totalValue += interval.sumPositions.sum_motoengine;
            intervalsMap.get(beginTime).userCount += 1;
          }
        } else if (currentViolationField === 'fuelOut') {
          // Для объема сливов добавляем все даты, где есть sumFuelsOut
          if (sumDistance > minDistance && interval.sumPositions &&
              interval.sumPositions.sumFuelsOut !== undefined) {
            intervalsMap.get(beginTime).totalValue += interval.sumPositions.sumFuelsOut;
            intervalsMap.get(beginTime).userCount += 1;
          }
        } else if (currentViolationField === 'onLine') {
          // Для выхода ТС на линию добавляем все даты, где есть on_line
          if (interval.sumPositions &&
              interval.sumPositions.on_line !== undefined) {
            intervalsMap.get(beginTime).totalValue += interval.sumPositions.on_line ? 1 : 0;
            intervalsMap.get(beginTime).userCount += 1;
          }
        } else {
          if (sumDistance > minDistance && interval.sumPositions && interval.sumPositions[currentViolationField] !== undefined) {
            intervalsMap.get(beginTime).totalValue += interval.sumPositions[currentViolationField];
            intervalsMap.get(beginTime).userCount += 1;
          }
        }
      });
    }
  });

  const sortedIntervals = Array.from(intervalsMap.values())
    .sort((a, b) => a.intervalEnd - b.intervalEnd);

  const res = sortedIntervals.map(item => item.intervalBegin)

  console.log("[new violationDates]", res)
  return res;
});

// Map для хранения интервалов (intervalBegin -> intervalEnd) для форматирования дат
const violationIntervalsMap = computed(() => {
  if (!testData.value || !testData.value.length) return new Map();

  const intervalsMap = new Map();

  testData.value.forEach(user => {
    if (user.data && user.data.posArray) {
      user.data.posArray.forEach(interval => {
        const beginTime = interval.interval_begin;
        if (!intervalsMap.has(beginTime)) {
          intervalsMap.set(beginTime, {
            intervalBegin: beginTime,
            intervalEnd: interval.interval_end
          });
        }
      });
    }
  });

  return intervalsMap;
});

const malfunctionLabels = computed(() => {
  if (!selectedVehicle.value) return [];
  return getMalfunctionLabels(selectedVehicle.value);
});

const formatDate = (dateString) => {
  // Форматируем дату в формат dd.mm
  if (!dateString) return '';

  let dateObj;
  if (typeof dateString === 'number') {
    // Если это timestamp
    dateObj = new Date(dateString * 1000);
  } else {
    // Если это уже объект даты или строка в другом формате
    dateObj = new Date(dateString);
  }

  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
  const year = String(dateObj.getFullYear()).slice(-2);

  return `${day}.${month}`;
};

const formatDate2 = (dateString) => {
  // Форматируем дату в формат dd.mm.yy
  if (!dateString) return '';

  let dateObj;
  if (typeof dateString === 'number') {
    // Если это timestamp
    dateObj = new Date(dateString * 1000);
  } else {
    // Если это уже объект даты или строка в другом формате
    dateObj = new Date(dateString);
  }

  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
  const year = String(dateObj.getFullYear()).slice(-2);

  return `${day}.${month}.${year}`;
};

const formatDateWithYear = (dateString) => {
  // Форматируем дату в формат dd.mm.yy
  if (!dateString) return '';

  let dateObj;
  if (typeof dateString === 'number') {
    // Если это timestamp
    dateObj = new Date(dateString * 1000);
  } else {
    // Если это уже объект даты или строка в другом формате
    dateObj = new Date(dateString);
  }

  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
  const year = String(dateObj.getFullYear()).slice(-2);

  return `${day}.${month}.${year}`;
};

// Форматирование даты из timestamp в формат dd.mm.yyyy (для сливов топлива)
const formatFuelOutDate = (timestamp) => {
  if (!timestamp) return '';

  const dateObj = new Date(timestamp * 1000);

  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = dateObj.getFullYear();

  return `${day}.${month}`;
};

// Форматирование даты с учетом типа группировки (для таблиц 1 и 2 уровня)
const formatDateByGroupingType = (dateString) => {
  if (!dateString) return '';

  const intervalData = violationIntervalsMap.value.get(dateString);
  if (!intervalData) {
    return formatDate(dateString);
  }

  const { intervalBegin, intervalEnd } = intervalData;
  return formatCategoryByGroupingType(intervalBegin, intervalEnd, groupingType.value);
};

// Функция для получения data-formatnum в зависимости от режима таблицы
const getDataFormatNum = () => {
  if (isMalfunctionMode.value) return 0;
  if (isDistanceMode.value) return 5;
  if (isFuelMode.value) return 5;
  if (isFuel100Mode.value) return 5;
  if (isEngineTimeMode.value) return 0;
  if (isFuelOutMode.value) return 5;
  return 12;
};

const getViolationValue = (item, date) => {

  let currentViolationField = currentViolationType.value;

  // Получаем значение для конкретного типа нарушений для конкретного автомобиля и даты
  if (!item.data || !item.data.posArray) {
    // if (isMalfunctionMode.value) return '0';
    // if (isDistanceMode.value) return 0;
    // if (isFuelMode.value) return 0;
    // if (isFuel100Mode.value) return 0;
    // if (isEngineTimeMode.value) return '0';
    // if (isFuelOutMode.value) return 0;
    // if (isOnLineMode.value) return 0;
    return 0;//'-';
  }

  // Ищем интервал с соответствующим timestamp
  const matchingPos = item.data.posArray.find(pos => {
    return pos.interval_begin === date;
  });

  const sumDistance = matchingPos?.sumPositions?.sum_distance || 0;

  // Для режимов расхода топлива и времени работы ДВС не применяем фильтр минимального пробега
  // Для остальных режимов — проверяем минимальный пробег
  if (!matchingPos) {
    return 0;
  }
  
  if (sumDistance < minDistance) {
    // Для режимов расхода топлива и времени работы ДВС продолжаем обработку
    if (isFuelMode.value || isEngineTimeMode.value) {
      // пропускаем проверку minDistance
    } else {
      // Для остальных режимов возвращаем 0
      if (isMalfunctionMode.value) return '0';
      if (isDistanceMode.value) return 0;
      if (isFuel100Mode.value) return 0;
      if (isFuelOutMode.value) return 0;
      if (isOnLineMode.value) return 0;
      return 0;
    }
  }

  // Для режима выхода ТС на линию
  if (isOnLineMode.value) {
    const onLine = matchingPos.on_line !== undefined ? (matchingPos.on_line ? 1 : 0) : 0;//'-';
    return onLine;
  }

  // Для режима среднесуточного пробега
  if (isDistanceMode.value) {
    const sumDistance = matchingPos.sumPositions?.sum_distance || 0;

    if (sumDistance > 0) {
      // sum_distance уже в километрах, округляем до десятых
      return Number(sumDistance.toFixed(1));
    }
    return 0;
  }

  // Для режима расхода топлива
  if (isFuelMode.value) {
    const sumCanExpence = matchingPos.sumPositions?.sum_canexpence || 0; //'-';

    if (sumCanExpence === '-') return '-';

    if (sumCanExpence > 0) {
      // sum_canexpence уже в литрах
      // Если groupingType не 'day', делим на 1000 для вывода в тысячах литров
      let value = sumCanExpence;
      if (groupingType.value !== 'day') {
        value = sumCanExpence / 1000;
      }
      return Number(value.toFixed(1));
    }
    return 0;
  }

  // Для режима расхода топлива на 100 км
  if (isFuel100Mode.value) {
    const sumCanExpence = matchingPos.sumPositions?.sum_canexpence || 0; //'-';
    const sumDistance = matchingPos.sumPositions?.sum_distance || 0; //'-';

    if (sumCanExpence === '-' || sumDistance === '-') return '-';

    if (sumDistance > 0 && sumCanExpence > 0) {
      // Расход на 100 км = (сумма топлива / сумма расстояния) * 100
      const fuelPer100km = (sumCanExpence / sumDistance) * 100;
      return Number(fuelPer100km.toFixed(1));
    }
    return 0;
  }

  // Для режима времени работы ДВС
  if (isEngineTimeMode.value) {
    const sumMotoEngine = matchingPos.sumPositions?.sum_motoengine || 0; //'-';

    if (sumMotoEngine === '-') return '-';

    if (sumMotoEngine > 0) {
      const hours = sumMotoEngine;
      return formatHoursToHHMM(hours);
    }
    return '0';
  }

  // Для режима объема сливов
  if (isFuelOutMode.value) {
    const sumFuelsOut = matchingPos.sumPositions?.sumFuelsOut || 0; //'-';

    if (sumFuelsOut === '-') return '-';

    if (sumFuelsOut > 0) {
      // sumFuelsOut уже в литрах
      // Если groupingType не 'day', делим на 1000 для вывода в тысячах литров
      let value = sumFuelsOut;
      // if (groupingType.value !== 'day') {
      //   value = sumFuelsOut / 1000;
      // }
      return Number(value.toFixed(1));
    }
    return 0;
  }

  const fieldValue = matchingPos.sumPositions?.[currentViolationField] || 0; //'-';

  if (fieldValue === '-') return '-';

  // Для режима неисправностей возвращаем время в формате hh:mm:ss
  if (isMalfunctionMode.value) {
    // fieldValue в секундах, преобразуем в часы и форматируем
    return formatHoursToHHMMSS(fieldValue / 3600);
  }

  // Для режима нарушений возвращаем целое количество нарушений
  return Math.round(fieldValue);
};

// Нарушения на 100 км для конкретного типа нарушений (для таблицы 1 уровня)
const getViolationPer100km = (item, date) => {
  if (!item?.data || !item.data.posArray) return '-';

  const matchingPos = item.data.posArray.find(pos => {
    return pos.interval_begin === date;
  });

  if (!matchingPos) return '-';

  const sumDistance = matchingPos.sumPositions?.sum_distance || 0;
  // Для режима расхода топлива на 100 км оставляем фильтр 10км
  // Для остальных режимов (расход топлива по парку, время работы ДВС) убираем фильтр
  if (!isFuelMode.value && !isEngineTimeMode.value && sumDistance < minDistance) return '-';

  const currentViolationField = currentViolationType.value;
  const fieldValue = matchingPos.sumPositions?.[currentViolationField] || 0;

  if (fieldValue === '-' || fieldValue === 0) return '-';

  const result = (fieldValue / sumDistance) * 100;
  return result;
};

// Функция для получения значения пробега для конкретного автомобиля и даты
const getMileageValue = (item, date, field = null) => {
  if (!item?.data || !item.data.posArray) return 0;

  // Ищем интервал с соответствующим timestamp
  const matchingPos = item.data.posArray.find(pos => {
    return pos.interval_begin === date;
  });

  if (!matchingPos) return 0;

  const sumDistance = matchingPos.sumPositions?.sum_distance || 0;

  // Для режимов расхода топлива и времени работы ДВС не применяем фильтр минимального пробега
  // Для остальных режимов — проверяем минимальный пробег
  if (sumDistance < minDistance) {
    if (!isFuelMode.value && !isEngineTimeMode.value) {
      return 0;
    }
  }

  // В любом случае возвращаем пробег (sum_distance)
  return Math.round(matchingPos.sumPositions?.sum_distance) || 0;
};

// Поля для таблицы с баллами на 100км
const SUMPOINTSTABLE = [
  'dvs_cnt',
  'transmission_cnt',
  'kom_cnt',
  'bezop_cnt',
  'fuel_out'
]

// Колонки для детальной таблицы расхода топлива (computed для динамического изменения заголовков)
const fuelDetailedColumns = computed(() => {
  const isThousandsMode = groupingType.value !== 'day';
  const unit = isThousandsMode ? 'тыс. л.' : 'л.';

  return [
    { label: `Общий расход топлива, ${unit}`, field: 'sum_canexpence', isCalculated: false, dataFormatNum: 12 },
    { label: `Расход топлива в движении, ${unit}`, field: 'sum_canexpencespd', isCalculated: false, dataFormatNum: 12 },
    { label: `Расход топлива на стоянке, ${unit}`, field: 'sum_canexpencenospd', isCalculated: false, dataFormatNum: 12 },
    { label: 'Доля расхода топлива на стоянке, %', field: 'fuelIdlePercent', isCalculated: true, dataFormatNum: 11 },
    { label: 'Средняя скорость при движении, км/ч', field: 'avgSpeed', isCalculated: true, dataFormatNum: 5 },
    { label: 'Количество остановок на 1 км/пути', field: 'sumStarts', isCalculated: true, dataFormatNum: 7 },
    { label: 'Общий расход топлива л/100км.', field: 'fuelPer100km', isCalculated: true, dataFormatNum: 5 },
    { label: 'Расход топлива л/100 км. при движении', field: 'fuelMovePer100km', isCalculated: true, dataFormatNum: 5 },
    { label: 'Расход топлива л/час на стоянке', field: 'fuelIdlePerHour', isCalculated: true, dataFormatNum: 5 },
    { label: 'Пробег, км.', field: 'sum_distance', isCalculated: false, toFixed: 1, dataFormatNum: 5 },
    { label: 'COM самосвала, число включений', field: 'sum_ptocnt', isCalculated: false, toFixed: false, dataFormatNum: 12 },
  ];
});

// Колонки для детальной таблицы времени работы ДВС
const engineTimeDetailedColumns = [
  { label: 'Общее время работы ДВС', field: 'sum_motoengine', isCalculated: false, dataFormatNum: 0 },
  { label: 'Время работы ДВС при движении', field: 'sum_motoenginespd', isCalculated: false, dataFormatNum: 0 },
  { label: 'Время работы ДВС на стоянке', field: 'sum_specificidling', isCalculated: false, dataFormatNum: 0 },
  { label: 'Доля работы ДВС на стоянке, %', field: 'engineIdlePercent', isCalculated: true, dataFormatNum: 11 },
  { label: 'Средняя скорость при движении, км/ч', field: 'avgSpeed', isCalculated: true, dataFormatNum: 5 },
  { label: 'Количество остановок на 1 км/пути', field: 'sumStarts', isCalculated: true, dataFormatNum: 7 },
  { label: 'Общий расход топлива л/100км.', field: 'fuelPer100km', isCalculated: true, dataFormatNum: 5 },
  { label: 'Расход топлива л/100 км при движении', field: 'fuelMovePer100km', isCalculated: true, dataFormatNum: 5 },
  { label: 'Расход топлива л/час на стоянке', field: 'fuelIdlePerHour', isCalculated: true, dataFormatNum: 5 },
  { label: 'Пробег, км.', field: 'sum_distance', isCalculated: false, toFixed: false, dataFormatNum: 12 },
  { label: 'COM самосвала, число включений', field: 'sum_ptocnt', isCalculated: true, toFixed: false, dataFormatNum: 12 },
];

// Колонки для детальной таблицы неисправностей ТС
const malfunctionDetailedColumns = [
  { label: 'Итого, общее время неисправности', field: 'malfunctionTotalTime', isCalculated: true },
  { label: 'Доля неисправности, от времени работы ДВС', field: 'malfunctionPercent', isCalculated: true },
  { label: 'Пробег, км', field: 'sum_distance', isCalculated: false, toFixed: false },
];

// Массивы с названиями и полями для разных типов нарушений
const violationTypes = {
  'dvs_cnt': {
    title: 'Грубые нарушения: ДВС, количество нарушений',
    title2: 'ДВС, количество нарушений',
    title3: 'ДВС',
    columns: [
      { label: 'Баллы на 100км.', field: 'dvs_cnt' }, // будет рассчитываться отдельно
      { label: 'ДВС > 2400 об/мин.', field: 't1_excessrpm' },
      { label: 'При движении ДВС <550 об/мин.', field: 't1_rpmspdless440cntg' }, 
      { label: 'ДВС под нагрузкой, заглох при движении', field: 't1_enginestalledspdcntg' },
      { label: 'При переключении МКПП ДВС <800 об/мин.', field: 't1_gearshiftrpm' },
      { label: 'ДВС > 1900 об/мин. без применения моторного тормоза', field: 't1_ineffectiverpmwithnomotobrake' },
      { label: 'Повышенные обороты ДВС при начале движения: МКПП > 1200 об/мин, АКПП>1400 об/мин.', field: 't1_rpmstartspdmore1200cnt' }
    ]
  },
  'transmission_cnt': {
    title: 'Грубые нарушения: Трансмиссия, количество нарушений',
    title2: 'Трансмиссия, количество нарушений',
    title3: 'Трансмиссия',
    columns: [
      { label: 'Баллы на 100км.', field: 'transmission_cnt' }, // будет рассчитываться отдельно
      { label: 'Начало движения, лишняя работа сцепления', field: 't1_clutchslipstart' },
      { label: 'Начало движения, пережег сцепл., темп. дисков >100 градусов', field: 't1_slipping' },
      { label: 'Начало движения, правильный выбор передачи в КПП', field: 't1_rightgearforstart' },
      { label: 'Начало движения, переключение КПП с переднего на задний ход при > 0 км/ч.', field: 't1_swithgearboxrewersspdcnt' },
      { label: 'Вкл./выкл блок мостов/колес при >7км/ч. или газ >0', field: 't1_switchlock' },
      { label: 'Вкл./выкл пониженной РКП при >0 км/ч. или газ >0', field: 't1_switchlower' },
      { label: 'Движение с вкл. межколесной блокировкой при >10 км/ч.', field: 't1_movelockcrosswheel' },
      { label: 'Работа дифференциалов мостов/колес при 0 км/ч.', field: 't1_difftransmoverload' },
      // { label: 'Движение с нажатой педалью сцепления', field: 't1_moveclutchopen' }, // баллы
      { label: 'МКПП: движение с нажатой педалью сцепления', field: 't1_moveclutchopen_violations' }, // фиксации
      // { label: 'Движение накатом на нейтральной передаче', field: 't1_rollforwardneutral' }, // баллы
      { label: 'МКПП: движение накатом на нейтральной передаче КПП', field: 't1_rollforwardneutral_violations' }, // фиксации
      { label: 'Температура масла ретардера 130 и более градусов', field: 't1_retarderhitmpr' },
    ]
  },
  'kom_cnt': {
    title: 'Грубые нарушения: Работа КОМ самосвала, количество нарушений',
    title2: 'COM, количество нарушений',
    title3: 'Работа КОМ самосвала',
    columns: [
      { label: 'Баллы на 100км.', field: 'kom_cnt' }, // будет рассчитываться отдельно
      { label: 'Крен при работе COM > 5 градусов', field: 't1_ptokrenunload' },
      { label: 'Движение с включенным COM', field: 't1_ptospddistanceg' },
      { label: 'Движение с поднятым кузовом', field: 't1_backraisedspddistance' },
      // { label: 'Интервал оборотов ДВС', field: 't1_ptorpmviolation' }, // баллы
      { label: 'Обороты ДВС >1000 или <800 при работе COM', field: 't1_ptorpmviolation_violations' }, // фиксации
    ]
  },
  'bezop_cnt': {
    title: 'Грубые нарушения: ДВС, Трансмиссия, Работа КОМ самосвала',
    title2: 'Количество нарушений',
    columns: [
      { label: 'Баллы на 100км.', field: 'dvs_cnt' }, // будет рассчитываться отдельно
      // ДВС
      { label: 'ДВС > 2400 об/мин.', field: 't1_excessrpm' },
      { label: 'При движении ДВС <550 об/мин.', field: 't1_rpmspdless440cntg' }, 
      { label: 'ДВС под нагрузкой, заглох при движении', field: 't1_enginestalledspdcntg' },
      { label: 'При переключении МКПП ДВС <800 об/мин.', field: 't1_gearshiftrpm' },
      { label: 'ДВС > 1900 об/мин. без применения моторного тормоза', field: 't1_ineffectiverpmwithnomotobrake' },
      { label: 'Повышенные обороты ДВС при начале движения: МКПП > 1200 об/мин, АКПП>1400 об/мин.', field: 't1_rpmstartspdmore1200cnt' },
      // Итого, количество нарушений ДВС
      // Нарушений на 100км., ДВС
      // Трансмиссия
      { label: 'Начало движения, лишняя работа сцепления', field: 't1_clutchslipstart' },
      { label: 'Начало движения, пережег сцепл., темп. дисков >100 градусов', field: 't1_slipping' },
      { label: 'Начало движения, правильный выбор передачи в КПП', field: 't1_rightgearforstart' },
      { label: 'Начало движения, переключение КПП с переднего на задний ход при > 0 км/ч.', field: 't1_swithgearboxrewersspdcnt' },
      { label: 'Вкл./выкл блок мостов/колес при >7км/ч. или газ >0', field: 't1_switchlock' },
      { label: 'Вкл./выкл пониженной РКП при >0 км/ч. или газ >0', field: 't1_switchlower' },
      { label: 'Движение с вкл. межколесной блокировкой при >10 км/ч.', field: 't1_movelockcrosswheel' },
      { label: 'Работа дифференциалов мостов/колес при 0 км/ч.', field: 't1_difftransmoverload' },
      { label: 'МКПП: движение с нажатой педалью сцепления', field: 't1_moveclutchopen_violations' },
      { label: 'МКПП: движение накатом на нейтральной передаче КПП', field: 't1_rollforwardneutral_violations' },
      { label: 'Температура масла ретардера 130 и более градусов', field: 't1_retarderhitmpr' },
      // Итого, количество нарушений Трансмиссия
      // Нарушений на 100км., Трансмиссия
      // Работа КОМ самосвала
      { label: 'Крен при работе COM > 5 градусов', field: 't1_ptokrenunload' },
      { label: 'Движение с включенным COM', field: 't1_ptospddistanceg' },
      { label: 'Движение с поднятым кузовом', field: 't1_backraisedspddistance' },
      { label: 'Обороты ДВС >1000 или <800 при работе COM', field: 't1_ptorpmviolation_violations' },
      // Итого, количество нарушений КОМ
      // Нарушений на 100км., КОМ
      // Итого, общее число нарушений
      // Пробег, км
      // Нарушений на 100 км. пробега, общее
    ]
  }
};

const malfunctionTitles = {
  sumRedLamp: 'Красная лампа, среднее время',
  sumYellowLamp: 'Жёлтая лампа, среднее время',
  sumNonElectronic: 'Не связана с электрикой, среднее время',
  sumCo2Impact: 'Выбросы СО2, среднее время'
};

const malfunctionTitles2 = {
  sumRedLamp: 'Неисправности ТС: красная лампа (требуется остановка ТС), время',
  sumYellowLamp: 'Неисправности ТС: желтая лампа (предупреждение, требуется проверка узла), время',
  sumNonElectronic: 'Неисправности ТС: время ошибки, не связаной с электронной подсистемой, время',
  sumCo2Impact: 'Неисправности ТС: время ошибки влияющей на выбросы СО2, время'
};

// Получение заголовка для таблицы 2 уровня
const getDetailedTableTitle2 = () => {
  if (isMalfunctionMode.value) {
    return malfunctionTitles2[currentViolationType.value] || 'Неисправности ТС';
  }
  if (isFuelMode.value || isFuel100Mode.value) {
    return 'Расход топлива по CAN данным';
  }
  if (isEngineTimeMode.value) {
    return 'Время работы ДВС';
  }
  return violationTypes[currentViolationType.value]?.title2 || 'Нарушения';
};

// Функция для получения значений для detailed table
const getFieldValue = (item, date, field, integerOnly = false) => {
  if (!item.data || !item.data.posArray) return '0';

  // Ищем интервал с соответствующим timestamp
  const matchingPos = item.data.posArray.find(pos => {
    return pos.interval_begin === date;
  });

  if (!matchingPos) return '0';

  const sumDistance = matchingPos.sumPositions?.sum_distance || 0;

  // возвращаем значение поля / пробег
  let rawValue = 0;
  const fieldValue = matchingPos.sumPositions?.[field] || 0;

  if (sumDistance > 0) {
    rawValue = (fieldValue / sumDistance) * 100;
  }

  let roundedValue;
  if (rawValue >= 100 || integerOnly) {
    roundedValue = Math.round(rawValue);
  } else {
    roundedValue = Math.round(rawValue * 10) / 10;
  }

  const integerValue = Math.floor(roundedValue);
  const decimalValue = Math.round((roundedValue - integerValue) * 10);

  if (decimalValue === 0) {
    return `${integerValue}`;
  }

  return `${integerValue},${decimalValue}`;
};

// Вычисляемое свойство для сортировки данных основной таблицы
const sortedTableData = computed(() => {
  if (!testData.value || !violationDates.value) return [];

  const data = [...testData.value];

  if (!sortColumn.value) {
    return data;
  }

  // Сортировка по гос номеру или VIN
  if (sortColumn.value === 'state_number' || sortColumn.value === 'vin') {
    data.sort((a, b) => {
      const valueA = sortColumn.value === 'vin'
        ? (a.data.objConf?.vin || '')
        : (a.data.objConf?.state_number || '');
      const valueB = sortColumn.value === 'vin'
        ? (b.data.objConf?.vin || '')
        : (b.data.objConf?.state_number || '');

      if (sortDirection.value === 'asc') {
        return valueA.localeCompare(valueB, 'ru');
      } else {
        return valueB.localeCompare(valueA, 'ru');
      }
    });
    return data;
  }

  // Сортировка по дате (нарушениям или неисправностям)
  if (sortColumn.value.startsWith('date_')) {
    const dateIndex = parseInt(sortColumn.value.replace('date_', '').replace('_desc', ''));
    const date = violationDates.value[dateIndex];

    data.sort((a, b) => {
      const valueA = getViolationValue(a, date);
      const valueB = getViolationValue(b, date);

      // Функция для преобразования значения в число для сортировки
      // "-" считается как -Infinity (ниже, чем 0)
      const toSortableValue = (val) => {
        // Сначала проверяем на "-"
        if (val === '-') {
          return -Infinity;
        }
        if (val === null || val === undefined) {
          return -Infinity;
        }
        if (typeof val === 'string') {
          // Для формата hh:mm:ss или hh:mm
          if (val.includes(':')) {
            const parts = val.split(':');
            if (parts.length === 3) { // чч:мм:сс
              const h = parseInt(parts[0], 10) || 0;
              const m = parseInt(parts[1], 10) || 0;
              const s = parseInt(parts[2], 10) || 0;
              return h * 3600 + m * 60 + s;
            } else if (parts.length === 2) { // чч:мм
              const h = parseInt(parts[0], 10) || 0;
              const m = parseInt(parts[1], 10) || 0;
              return h * 3600 + m * 60;
            }
          }
          // Для процентов (с %)
          if (val.includes('%')) {
            const num = parseFloat(val.replace('%', ''));
            return isNaN(num) ? -Infinity : num;
          }
          // Обычное число
          const num = parseFloat(val);
          return isNaN(num) ? -Infinity : num;
        }
        return val;
      };

      const numA = toSortableValue(valueA);
      const numB = toSortableValue(valueB);

      if (sortColumn.value.endsWith('_desc')) {
        return numB - numA;
      } else {
        return numA - numB;
      }
    });
    return data;
  }

  return data;
});

// Функция для переключения VIN/гос номер
const toggleVinColumn = () => {
  showVinColumn.value = !showVinColumn.value;
};

// Функция для сортировки по дате
const sortTableByDate = (dateIndex, direction) => {
  const currentKey = `date_${dateIndex}`;
  const currentKeyDesc = `date_${dateIndex}_desc`;
  
  if (direction === 'asc') {
    if (sortColumn.value === currentKey) {
      // Если уже сортируем по возрастанию, сбрасываем сортировку
      sortColumn.value = null;
      sortDirection.value = 'asc';
    } else {
      // Сортируем по новой колонке по возрастанию
      sortColumn.value = currentKey;
      sortDirection.value = 'asc';
    }
  } else if (direction === 'desc') {
    if (sortColumn.value === currentKeyDesc) {
      // Если уже сортируем по убыванию, сбрасываем сортировку
      sortColumn.value = null;
      sortDirection.value = 'asc';
    } else {
      // Сортируем по новой колонке по убыванию
      sortColumn.value = currentKeyDesc;
      sortDirection.value = 'desc';
    }
  }
};

// Функция для показа детальной таблицы
const showDetailedTableFunc = (item) => {
  // Для режима среднесуточного пробега и выхода на линию таблицу 2 уровня не открываем
  // Для режима расхода топлива (isFuelMode и isFuel100Mode), времени работы ДВС (isEngineTimeMode), неисправностей (isMalfunctionMode) и объема сливов (isFuelOutMode) таблицу 2 уровня ОТКРЫВАЕМ
  if (isDistanceMode.value || isOnLineMode.value) {
    return;
  }

  // Проверяем, что у item есть данные
  if (!item || !item.data || !item.data.posArray || item.data.posArray.length === 0) {
    return;
  }

  // Для режима объема сливов загружаем данные только для выбранного объекта
  if (isFuelOutMode.value) {
    loadFuelOutDetailsForObject(item);
  }

  showDetailedTable.value = true;
  selectedVehicle.value = item;
};

// Функция для скрытия детальной таблицы
const hideDetailedTable = () => {
  showDetailedTable.value = false;
  selectedVehicle.value = null;
};

// Функция для получения значения поля в детальной таблице
const getDetailedFieldValue = (item, date, field) => {
  if (!item?.data || !item.data.posArray) return 0;

  const matchingPos = item.data.posArray.find(pos => {
    return pos.interval_begin === date;
  });

  const sumDistance = matchingPos?.sumPositions?.sum_distance || 0;

  if (!matchingPos || sumDistance < minDistance) return 0;

  const fieldValue = matchingPos.sumPositions?.[field] || 0 ;//'-';

  if (fieldValue === '-') return '-';

  // Возвращаем целое количество нарушений
  return Math.round(fieldValue);
};

// Функция для получения значения поля в детальной таблице расхода топлива
const getFuelDetailedFieldValue = (item, date, field, isCalculated = false, toFixed = false) => {
  if (!item?.data || !item.data.posArray) return 0;

  const matchingPos = item.data.posArray.find(pos => {
    return pos.interval_begin === date;
  });

  if (!matchingPos) return 0;

  const sumDistance = matchingPos.sumPositions?.sum_distance || 0;
  const sumCanExpence = matchingPos.sumPositions?.sum_canexpence || 0;
  const sumCanExpenceSpd = matchingPos.sumPositions?.sum_canexpencespd || 0;
  const sumCanExpenceNoSpd = matchingPos.sumPositions?.sum_canexpencenospd || 0;
  const sumMotoEngineSpd = matchingPos.sumPositions?.sum_motoenginespd || 0;
  const sumMotoEngineNoSpd = matchingPos.sumPositions?.sum_specificidling || 0;
  const sumClutchUseMoveStartCnt = matchingPos.sumPositions?.sum_clutch_use_move_start_cnt || 0;

  // Для рассчитываемых полей
  if (isCalculated) {
    switch (field) {
      case 'fuelIdlePercent':
        // Доля расхода топлива на стоянке, %
        if (sumCanExpence > 0 && sumDistance >= minDistance) {
          return Number(Math.round((sumCanExpenceNoSpd / sumCanExpence) * 100)) + '%';
        }
        return '0%';
      case 'avgSpeed':
        // Средняя скорость при движении, км/ч
        if (sumMotoEngineSpd > 0 && sumDistance >= minDistance) {
          const hours = sumMotoEngineSpd; // / (1000 * 60 * 60);
          const avgSpeed = sumDistance / hours;
          return Number(avgSpeed.toFixed(1));
        }
        return 0;
      case 'fuelPer100km':
        // Общий расход топлива л/100км.
        if (sumDistance >= minDistance) {
          return Number(((sumCanExpence / sumDistance) * 100).toFixed(1));
        }
        return 0;
      case 'fuelMovePer100km':
        // Расход топлива л/100 км при движении
        if (sumDistance >= minDistance) {
          return Number(((sumCanExpenceSpd / sumDistance) * 100).toFixed(1));
        }
        return 0;
      case 'sumStarts':
        // Количество остановок на 1 км/пути
        if (sumDistance >= minDistance) {
          return Number((sumClutchUseMoveStartCnt / sumDistance).toFixed(2));
        }
        return 0;
      case 'fuelIdlePerHour':
        // Расход топлива л/час на стоянке
        if (sumMotoEngineNoSpd > 0 && sumDistance >= minDistance) {
          return Number((sumCanExpenceNoSpd / sumMotoEngineNoSpd).toFixed(1));
        }
        return 0;
    }
  }

  // Для обычных полей — не применяем фильтр minDistance для детальной таблицы расхода топлива
  const fieldValue = matchingPos.sumPositions?.[field] || 0;//'-';
  if (fieldValue === '-') {
    return '-';
  }

  // Для полей расхода топлива делим на 1000 если groupingType не 'day' (вывод в тысячах литров)
  let finalValue = fieldValue;
  if (groupingType.value !== 'day' && ['sum_canexpence', 'sum_canexpencespd', 'sum_canexpencenospd'].includes(field)) {
    finalValue = fieldValue / 1000;
  }

  if (toFixed) {
    return Number(finalValue.toFixed(toFixed));
  }
  return Number(Math.round(finalValue));
};

// Функция для получения значения поля в детальной таблице времени работы ДВС
const getEngineTimeDetailedFieldValue = (item, date, field, isCalculated = false, toFixed = false) => {
  if (!item?.data || !item.data.posArray) return 0;

  const matchingPos = item.data.posArray.find(pos => {
    return pos.interval_begin === date;
  });

  if (!matchingPos) return 0;

  const sumDistance = matchingPos.sumPositions?.sum_distance || 0;
  const sumCanExpence = matchingPos.sumPositions?.sum_canexpence || 0;
  const sumCanExpenceSpd = matchingPos.sumPositions?.sum_canexpencespd || 0;
  const sumCanExpenceNoSpd = matchingPos.sumPositions?.sum_canexpencenospd || 0;
  const sumMotoEngine = matchingPos.sumPositions?.sum_motoengine || 0;
  const sumMotoEngineSpd = matchingPos.sumPositions?.sum_motoenginespd || 0;
  const sumMotoEngineNoSpd = matchingPos.sumPositions?.sum_specificidling || 0;
  const sumClutchUseMoveStartCnt = matchingPos.sumPositions?.sum_clutch_use_move_start_cnt || 0;

  // Для рассчитываемых полей
  if (isCalculated) {
    switch (field) {
      case 'engineIdlePercent':
        // Доля работы ДВС на стоянке, %
        if (sumMotoEngine > 0 && sumDistance >= minDistance) {
          return Number(Math.round((sumMotoEngineNoSpd / sumMotoEngine) * 100)) + '%';
        }
        return '0%';
      case 'avgSpeed':
        // Средняя скорость при движении, км/ч
        if (sumMotoEngineSpd > 0 && sumDistance >= minDistance) {
          const hours = sumMotoEngineSpd; // / (1000 * 60 * 60);
          const avgSpeed = sumDistance / hours;
          return Number(avgSpeed.toFixed(1));
        }
        return 0;
      case 'fuelPer100km':
        // Общий расход топлива л/100км.
        if (sumDistance > 0 && sumDistance >= minDistance) {
          return Number(((sumCanExpence / sumDistance) * 100).toFixed(1));
        }
        return 0;
      case 'fuelMovePer100km':
        // Расход топлива л/100 км при движении
        if (sumDistance > 0 && sumDistance >= minDistance) {
          return Number(((sumCanExpenceSpd / sumDistance) * 100).toFixed(1));
        }
        return 0;
      case 'sumStarts':
        // Количество остановок на 1 км/пути
        if (sumDistance > 0 && sumDistance >= minDistance) {
          return Number((sumClutchUseMoveStartCnt / sumDistance).toFixed(2));
        }
        return 0;
      case 'fuelIdlePerHour':
        // Расход топлива л/час на стоянке
        if (sumMotoEngineNoSpd > 0 && sumDistance >= minDistance) {
          return Number((sumCanExpenceNoSpd / sumMotoEngineNoSpd).toFixed(1));
        }
        return 0;
    }
  }

  // Для обычных полей (время работы ДВС в часах) — не применяем фильтр minDistance для детальной таблицы времени работы ДВС
  const fieldValue = matchingPos.sumPositions?.[field] || 0;//'-';
  if (fieldValue === '-') {
    return '-';
  }

  if (field === 'sum_distance' || field === 'sum_ptocnt') {
    return Number(Math.round(fieldValue));
  }
  // Преобразуем из часов в формат hh:mm
  return formatHoursToHHMM(fieldValue);
};

// Функция для получения значения поля в детальной таблице неисправностей ТС
const getMalfunctionDetailedFieldValue = (item, date, field, isCalculated = false, toFixed = false) => {
  if (!item?.data || !item.data.posArray) return 0;

  const matchingPos = item.data.posArray.find(pos => {
    return pos.interval_begin === date;
  });

  if (!matchingPos) return 0;

  const sumDistance = matchingPos.sumPositions?.sum_distance || 0;
  const sumMotoEngine = matchingPos.sumPositions?.sum_motoengine || 0;
  const currentViolationField = currentViolationType.value;
  let malfunctionTime = matchingPos.sumPositions?.[currentViolationField] || 0;
  malfunctionTime = malfunctionTime / 3600;
  console.log("malfunctionTime", currentViolationField, malfunctionTime);

  // Для рассчитываемых полей
  if (isCalculated) {
    switch (field) {
      case 'malfunctionTotalTime':
        // Итого, общее время неисправности (в часах)
        // Время неисправности показываем независимо от пробега
        return formatHoursToHHMMSS(malfunctionTime);
      case 'malfunctionPercent':
        // Доля неисправности, от времени работы ДВС, %
        if (sumMotoEngine > 0) {
          return Number(Math.round((malfunctionTime / sumMotoEngine) * 100)) + '%';
        }
        return '0%';
    }
  }

  if (sumDistance < minDistance) return 0;

  // Для обычных полей
  const fieldValue = matchingPos.sumPositions?.[field] || 0;//'-';
  if (fieldValue === '-') {
    return '-';
  }
  return Number(fieldValue).toFixed(1);
};

// Функция для форматирования объема слива (из мл в литры)
const formatFuelVol = (vol) => {
  if (!vol && vol !== 0 && vol !== '0') return '0.0';

  const volNum = typeof vol === 'string' ? parseFloat(vol) : Number(vol);
  if (isNaN(volNum)) return '0.0';
  
  // Если объем > 1000, предполагаем, что это мл и конвертируем в литры
  if (volNum > 1000) {
    return (volNum / 1000).toFixed(1);
  }

  return volNum.toFixed(1);
};

// Парсинг bool-значения из ответа Api/fuelInOut/get ('t'/'f'/true/false/'1'/'0')
const parseFuelInOutBool = (val) => {
  if (val === 'f' || val === 'false' || val === '0' || !val) {
    return false;
  }
  return true;
};

// Функция для загрузки детальных данных о сливах только для одного объекта
// Использует тот же эндпоинт, что и "Отчет по заправкам и сливам" (Api/fuelInOut/get
// с summ_levels_only=1), чтобы в таблицу попадали сливы только суммарного бака
const loadFuelOutDetailsForObject = async (item) => {
  const objId = item?.data?.objConf?.id;
  if (!objId) return;

  const key = String(objId);

  // Если данные уже есть в детальном кэше – повторно не загружаем
  if (fuelOutDetailsCache.value[key]) {
    return;
  }

  try {
    loading.value = true;

    const timeBegin = Math.floor(dateRange.value[0] / 1000);
    const timeEnd = Math.floor(dateRange.value[1] / 1000);

    const params = new URLSearchParams({
      id: key,
      time_begin: timeBegin,
      time_end: timeEnd,
      template_name: 'fuelInOut',
      summ_levels_only: 1,
      cistern: 1
    });

    const data = await fetchJson(
      (process.env.VUE_APP_BACKEND_URL || window.location.origin) +
      `/Api/fuelInOut/get?${params}`
    );

    const lines = data && !data.error && Array.isArray(data.lines) ? data.lines : [];

    // Оставляем только сливы (out === true) суммарного бака
    const posArray = lines
      .filter(line => parseFuelInOutBool(line.out))
      .filter(line => !(Number(line.lv_importance) > 0))
      .map(line => ({
        obj_id: key,
        time: parseInt(line.time, 10),
        begin: parseInt(line.begin, 10),
        end: parseInt(line.end, 10),
        vol: parseInt(line.vol, 10),
        lv_importance: parseInt(line.lv_importance, 10) || 0,
        lat: line.lat,
        lon: line.lon
      }));

    fuelOutDetailsCache.value[key] = {
      posArray
    };
  } catch (e) {
    console.error('Ошибка при загрузке детальных данных по сливам для объекта', key, e);
    // Кэшируем пустой результат, чтобы не дергать сервер каждый раз при ошибке
    fuelOutDetailsCache.value[key] = {
      posArray: []
    };
  } finally {
    loading.value = false;
  }
};

// Функция для получения данных о сливах для таблицы 2 уровня
// Использует детальный кэш по объектам, при его отсутствии – общий кэш карты
const getFuelOutData = (item, date) => {
  if (!item?.data || !item.data.objConf) return [];

  const objId = item.data.objConf.id || item.id;
  if (!objId) return [];

  const key = String(objId);

  let sourceArray = [];

  // Сначала пробуем взять из детального кэша по объекту
  if (fuelOutDetailsCache.value[key] && Array.isArray(fuelOutDetailsCache.value[key].posArray)) {
    sourceArray = fuelOutDetailsCache.value[key].posArray;
  } else {
    // Если детальных данных нет – используем общий кэш карты (чтобы не ломать текущую логику карты)
    const fuelOutData = mapDataCache.value['fuel_out'];
    if (!fuelOutData || !fuelOutData.posArray || !Array.isArray(fuelOutData.posArray)) {
      return [];
    }
    sourceArray = fuelOutData.posArray;
  }

  const matchingPos = item.data.posArray.find(pos => {
    return pos.interval_begin === date;
  });

  if (!matchingPos) return [];

  // Фильтруем сливы для выбранного ТС по дате
  const dayStart = matchingPos.interval_begin;
  const dayEnd = matchingPos.interval_end;

  const filteredSlips = sourceArray.filter(slip => {
    if (slip.obj_id !== String(objId)) return false;

    // Отсекаем сливы с дополнительных уровнемеров (не суммарного бака),
    // если бэкенд вернул признак важности датчика
    if (Number(slip.lv_importance) > 0) return false;

    const slipTime = slip.time;
    return slipTime >= dayStart && slipTime < dayEnd;
  });

  return filteredSlips.map(slip => ({
    time: slip.time || slip.begin,
    vol: formatFuelVol(slip.vol),
    begin: slip.begin,
    end: slip.end,
    obj_id: slip.obj_id
  }));
};

// Функция для получения значения исправности ДУТ (%)
// Для fuel_out режима проверяем наличие данных о сливах в mapDataCache
const getDutHealthValue = (item, date) => {
  const matchingPos = item.data.posArray.find(pos => {
    return pos.interval_begin === date;
  });

  if (!matchingPos) return 0;

  const percent = matchingPos.ts_incorrect_dut_persent || 0;

  return Math.round(100 - percent);
};

// Функция для получения значения нарушения для bezop_cnt
const getBezopValue = (item, date, field) => {
  if (!item?.data || !item.data.posArray) return 0;

  const matchingPos = item.data.posArray.find(pos => {
    return pos.interval_begin === date;
  });

  if (!matchingPos) return 0;

  const fieldValue = matchingPos.sumPositions?.[field] || 0;

  if (fieldValue === '-' || fieldValue === null || fieldValue === undefined) {
    return 0;
  }

  // Возвращаем целое количество нарушений
  return Math.round(fieldValue);
};

// Поля нарушений для каждой категории
const BEZOP_FIELDS = {
  dvs: ['t1_excessrpm', 't1_rpmspdless440cntg', 't1_enginestalledspdcntg', 't1_gearshiftrpm', 't1_ineffectiverpmwithnomotobrake', 't1_rpmstartspdmore1200cnt'],
  transmission: ['t1_clutchslipstart', 't1_slipping', 't1_rightgearforstart', 't1_swithgearboxrewersspdcnt', 't1_switchlock', 't1_switchlower', 't1_movelockcrosswheel', 't1_difftransmoverload', 't1_moveclutchopen_violations', 't1_rollforwardneutral_violations', 't1_retarderhitmpr'],
  kom: ['t1_ptokrenunload', 't1_ptospddistanceg', 't1_backraisedspddistance', 't1_ptorpmviolation_violations']
};

// Итого, количество нарушений (ДВС, Трансмиссия, КОМ, Все)
const getBezopTotal = (item, date, type = 'all') => {
  if (!item?.data || !item.data.posArray) return 0;

  const matchingPos = item.data.posArray.find(pos => {
    return pos.interval_begin === date;
  });

  if (!matchingPos) return 0;

  let total = 0;
  const fields = type === 'all' 
    ? [...BEZOP_FIELDS.dvs, ...BEZOP_FIELDS.transmission, ...BEZOP_FIELDS.kom]
    : BEZOP_FIELDS[type] || [];

  fields.forEach(field => {
    const fieldValue = matchingPos.sumPositions?.[field] || 0;
    if (fieldValue && fieldValue !== '-') {
      total += Math.round(fieldValue);
    }
  });

  return total;
};

// Нарушений на 100км. (ДВС, Трансмиссия, КОМ, Все)
const getBezopPer100km = (item, date, type = 'all') => {
  if (!item?.data || !item.data.posArray) return '-';

  const matchingPos = item.data.posArray.find(pos => {
    return pos.interval_begin === date;
  });

  if (!matchingPos) return '-';

  const sumDistance = matchingPos.sumPositions?.sum_distance || 0;
  if (sumDistance < minDistance) return '-';

  const total = getBezopTotal(item, date, type);
  const result = (total / sumDistance) * 100;

  return Math.round(result * 10) / 10;
};

// ==================== Конец функций для таблицы bezop_cnt ====================

// Получение поля меток в зависимости от типа неисправности
const getMalfunctionLabelsField = () => {
  switch (currentViolationType.value) {
    case 'sumRedLamp':
      return 'redLampLabels';
    case 'sumYellowLamp':
      return 'yellowLampLabels';
    case 'sumCo2Impact':
      return 'co2LampLabels';
    case 'sumNonElectronic':
      return 'nonElectronicLampLabels';
    default:
      return 'yellowLampLabels';
  }
};

// Функция для получения уникальных меток неисправностей
const getMalfunctionLabels = (item) => {
  if (!item?.data || !item.data.posArray) return [];

  const labelsField = getMalfunctionLabelsField();
  const uniqueLabelsMap = new Map();

  item.data.posArray.forEach(pos => {
    const labels = pos[labelsField] || [];
    labels.forEach(label => {
      const key = `${label.addr}_${label.spn}`;
      if (!uniqueLabelsMap.has(key)) {
        uniqueLabelsMap.set(key, {
          addr: label.addr,
          addr_description: label.addr_description || '',
          spn: label.spn,
          spn_description: label.spn_description || '',
        });
      }
    });
  });

  // Преобразуем Map в массив и сортируем по addr, затем по spn
  const uniqueLabels = Array.from(uniqueLabelsMap.values());
  uniqueLabels.sort((a, b) => {
    if (a.addr !== b.addr) return a.addr - b.addr;
    return a.spn - b.spn;
  });

  return uniqueLabels;
};

// Функция для получения значения value для даты и метки
const getMalfunctionLabelValue = (item, date, label) => {
  if (!item?.data || !item.data.posArray) return 0;

  const labelsField = getMalfunctionLabelsField();
  const matchingPos = item.data.posArray.find(pos => {
    return pos.interval_begin === date;
  });

  if (!matchingPos) return 0;

  const labels = matchingPos[labelsField] || [];
  const matchingLabel = labels.find(l => l.addr === label.addr && l.spn === label.spn);

  const res = matchingLabel ? matchingLabel.value : 0;
  if (res > 0) {
    return formatHoursToHHMMSS(res / 3600);
  }
  return 0
};

// Функция для получения общего количества нарушений за дату
const getTotalViolations = (item, date) => {
  if (!item?.data || !item.data.posArray) return 0;

  const matchingPos = item.data.posArray.find(pos => {
    return pos.interval_begin === date;
  });

  if (!matchingPos) return 0;

  if (matchingPos.sumPositions?.sum_distance < minDistance) return 0;

  const currentViolationField = currentViolationType.value;
  const totalViolations = matchingPos.sumPositions?.[currentViolationField] || 0;
  
  return totalViolations;
};

// Функция для получения нарушений на 100 км пробега с округлением до сотых
const getViolationsPer100km = (item, date) => {
  if (!item?.data || !item.data.posArray) return '0';

  const matchingPos = item.data.posArray.find(pos => {
    return pos.interval_begin === date;
  });

  if (!matchingPos) return '0';

  const currentViolationField = currentViolationType.value;
  const violationCnt = matchingPos.sumPositions?.[currentViolationField] || 0;
  const sumDistance = matchingPos.sumPositions?.sum_distance || 0;

  if (sumDistance < minDistance) return '0';

  const rawValue = (violationCnt / Math.round(sumDistance)) * 100;
  const roundedValue = Math.round(rawValue * 100) / 100; // Округление до сотых

  return roundedValue.toFixed(2).replace('.', ',');
};

// Функция для получения стиля ячейки "Итого, количество нарушений"
const getTotalViolationsStyle = (value, per100kmValue = null) => {
  const numValue = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;
  const numPer100km = per100kmValue !== null
    ? (typeof per100kmValue === 'string' ? parseFloat(per100kmValue.replace(',', '.')) : per100kmValue)
    : numValue;

  if (numPer100km >= 11) {
    return {
      backgroundColor: '#FECECE',
      fontWeight: '700'
    };
  } else if (numPer100km >= 6) {
    return {
      fontWeight: '700'
    };
  }
  return {};
};

// Функция для получения класса нарушения "Итого, количество нарушений"
const getTotalViolationsClass = (value, per100kmValue = null) => {
  const numValue = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;
  const numPer100km = per100kmValue !== null
    ? (typeof per100kmValue === 'string' ? parseFloat(per100kmValue.replace(',', '.')) : per100kmValue)
    : numValue;

  if (numPer100km >= 11) {
    return 'violation-high-violation';
  } else if (numPer100km >= 6) {
    return 'violation-medium-violation';
  }
  return '';
};

// Функция для получения стиля ячейки "Нарушения на 100 км. пробега"
const getViolationsPer100kmStyle = (value) => {
  const numValue = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;

  if (numValue >= 11) {
    return {
      backgroundColor: '#FECECE',
      fontWeight: '700'
    };
  } else if (numValue >= 6) {
    return {
      fontWeight: '700'
    };
  }
  return {};
};

// Функция для получения класса нарушения "Нарушения на 100 км. пробега"
const getViolationsPer100kmClass = (value) => {
  const numValue = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;

  if (numValue >= 11) {
    return 'violation-high-violation';
  } else if (numValue >= 6) {
    return 'violation-medium-violation';
  }
  return '';
};

// Функция для получения класса нарушения
const getViolationClass = (value, per100kmValue = null) => {
  // Для режима неисправностей, среднесуточного пробега, расхода топлива, расхода на 100 км, времени работы ДВС, объема сливов и выхода на линию возвращаем пустой класс
  if (isMalfunctionMode.value || isDistanceMode.value || isFuelMode.value || isFuel100Mode.value || isEngineTimeMode.value || isFuelOutMode.value || isOnLineMode.value) {
    return '';
  }

  // Если передано значение per100kmValue, используем его для определения класса
  if (per100kmValue !== null && per100kmValue !== '-') {
    const numPer100km = typeof per100kmValue === 'number' ? per100kmValue : (parseFloat(per100kmValue) || 0);
    if (numPer100km >= 11) {
      return 'violation-high-violation';
    } else if (numPer100km >= 6) {
      return 'violation-medium-violation';
    }
    return '';
  }

  // Иначе используем старую логику (по значению нарушения)
  const numValue = typeof value === 'number' ? value : (parseInt(value) || 0);
  if (numValue >= 11) {
    return 'violation-high-violation';
  } else if (numValue >= 6) {
    return 'violation-medium-violation';
  }
  return '';
};

// Функция для получения стиля ячейки с нарушением в основной таблице
const getViolationCellStyle = (value, per100kmValue = null) => {
  // Для режима неисправностей, среднесуточного пробега, расхода топлива, расхода на 100 км, времени работы ДВС, объема сливов и выхода на линию возвращаем пустой стиль
  if (isMalfunctionMode.value || isDistanceMode.value || isFuelMode.value || isFuel100Mode.value || isEngineTimeMode.value || isFuelOutMode.value || isOnLineMode.value) {
    return {};
  }

  // Если передано значение per100kmValue, используем его для определения стиля
  if (per100kmValue !== null && per100kmValue !== '-') {
    const numPer100km = typeof per100kmValue === 'number' ? per100kmValue : (parseFloat(per100kmValue) || 0);
    if (numPer100km >= 11) {
      return {
        fontWeight: '900',
        backgroundColor: '#FECECE',
      };
    } else if (numPer100km >= 6) {
      return {
        fontWeight: '700'
      };
    }
    return {};
  }

  // Иначе используем старую логику (по значению нарушения)
  const numValue = typeof value === 'number' ? value : (parseInt(value) || 0);
  if (numValue >= 11) {
    return {
      fontWeight: '900',
      backgroundColor: '#FECECE',
    };
  } else if (numValue >= 6) {
    return {
      fontWeight: '700'
    };
  }
  return {};
};

// Вычисляемое свойство для генерации данных таблицы в детальном режиме
const detailedTableData = computed(() => {
  if (!testData.value || !violationDates.value) return [];

  return testData.value.map(item => {
    const row = {
      id: item.id,
      index: item.index,
      state_number: item.data.objConf?.state_number || 'Н/Д',
      gearbox_type: item.data.objConf?.gearbox_name?.includes('АКПП') ? 'АКПП' : 'МКПП',
      data: []
    };

    violationDates.value.forEach(date => {
      violationTypes[currentViolationType.value].columns.forEach(col => {
        row.data.push(getFieldValue(item, date, col.field));
      });
    });

    return row;
  });
});

// Вычисляемое свойство для получения максимального количества строк сливов
const maxFuelOutRows = computed(() => {
  if (!violationDates.value || !selectedVehicle.value) return 1;

  let maxRows = 1;
  violationDates.value.forEach(date => {
    const fuelOutData = getFuelOutData(selectedVehicle.value, date);
    if (fuelOutData && fuelOutData.length > maxRows) {
      maxRows = fuelOutData.length;
    }
  });

  return maxRows;
});

// Вычисляемое свойство для генерации заголовков в детальном режиме
const detailedHeaders = computed(() => {
  if (!violationDates.value) return [];

  const headers = [];
  violationDates.value.forEach(date => {
    violationTypes[currentViolationType.value].columns.forEach((col, colIndex) => {
      let label = col.label;

      if (colIndex === 0 && showMileageRow.value) {
        label = col.label + ' Пробег, км.';
      }

      headers.push({
        date: date,
        label: label,
        field: col.field
      });
    });
  });

  return headers;
});

const totalFuelOutColumns = computed(() => {
  if (!violationDates.value) return 1;
  const colsPerDate = groupingType2.value !== 'day' ? 4 : 3;
  return 1 + violationDates.value.length * colsPerDate;
});
</script>

<style lang="scss" scoped>
// // Убираем горизонтальный скролл на уровне страницы при ширине < 1930px
// @media (max-width: 1929px) {
//   body {
//     overflow-x: hidden;
//   }
// }

.text-center {
  text-align: center;
}

.font-weight-bold {
  font-weight: bold;
}

.bg-white {
  background-color: white;
}

.rounded-xl {
  border-radius: 0.75rem;
}

.flex {
  display: flex;
}

.charts-container button {
  border: none;
  background-color: white;
  margin: 0 5px;
}

.justify-between {
  justify-content: space-between;
}

.items-start {
  align-items: flex-start;
}

.items-center {
  align-items: center;
  margin-top: auto;
  margin-bottom: auto;
}

.gap-2 {
  gap: 0.5rem;
}

.text-xl {
  font-size: 1.25rem;
}

.font-semibold {
  font-weight: 600;
}

.text-gray-800 {
  color: #1f2937;
}

.group {
  position: relative;
}

.relative {
  position: relative;
}

.justify-center {
  justify-content: center;
}

.cursor-help {
  cursor: help;
}

.text-gray-400 {
  color: #9ca3af;
}

.text-gray-600 {
  color: #4b5563;
}

.text-gray-900 {
  color: #111827;
}

.absolute {
  position: absolute;
}

.bottom-full {
  bottom: 100%;
}

.left-1-2 {
  left: 50%;
}

.transform {
  transform: translateX(-50%);
}

.hidden {
  display: none;
}

.bg-gray-800 {
  background-color: #1f2937;
}

.text-white {
  color: white;
}

.text-xs {
  font-size: 0.75rem;
}

.rounded {
  border-radius: 0.25rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.z-10 {
  z-index: 10;
}

.w-0 {
  width: 0;
}

.h-0 {
  height: 0;
}

.border-l-4 {
  border-left-width: 4px;
}

.border-r-4 {
  border-right-width: 4px;
}

.border-t-4 {
  border-top-width: 4px;
}

.border-l-transparent {
  border-left-color: transparent;
}

.border-r-transparent {
  border-right-color: transparent;
}

.border-t-gray-800 {
  border-top-color: #1f2937;
}

.p-1 {
  padding: 0.25rem;
}

.transition-colors {
  transition: color 0.2s;
}

/* Hover effects */
.hover\:text-gray-600:hover {
  color: #4b5563;
}

.hover\:text-gray-900:hover {
  color: #111827;
}

.hover\:bg-gray-100:hover {
  background-color: #f3f4f6;
}

.group:hover .group-hover\:block {
  display: block;
}

/* Utility classes */
.float-left {
  float: left;
}

.h-5 {
  height: 1.25rem; /* 20px */
}

.w-5 {
  width: 1.25rem; /* 20px */
}

.m-0-5 {
  margin: 0.125rem; /* 2px - this is the closest common size for m-0-5 */
}

/* Existing styles */
* {
  font-family: Arial, sans-serif !important;
  text-align: start;
}

p {
  color: unset;
}

.footer-desc {
  &_period-label {
    font-weight: 700;
  }  
  &_period-val {
    border: 1px solid black;
    padding: 1px;
    font-weight: 400;
    margin-left: 5px;
  } 
  &_group-label {
    font-weight: 700;
    margin-left: 32px;
  }
  &_group-val {
    border-radius: 3px;
    background: none;
    padding: 1px;
    font-weight: 400;
    margin-left: 10px;
    height: 26px;
    width: 122px;
    line-height: 0.9;
    font-size: 18px;

    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: none;
  }
}

.park-dut-name,
.park-work-name,
.park-dutcorrect-name {
  margin-left: 102px;
}

.park-work-name {
  margin-left: 88px !important;
}

.park-dutcorrect-name {
  margin-left: 105px !important;
}

.park-dut-count {
  margin-left: 27px !important;
}

.park-work-count {
  margin-left: 26px !important;
}

.park-dutcorrect-count {
  margin-left: 26px !important;
}

.park-count,
.park-dut-count,
.park-work-count,
.park-dutcorrect-count {
  margin-left: 30px;
  font-size: 20px;
}

.sub-container-title {
  padding-left: 10px;
  font-weight: 900;
  font-size: 18px;
  margin: 0 0 5px 0 !important;
  strong {
    font-size: 20px;
    font-weight: 900;
    line-height: 110%;
    letter-spacing: 0.3px;
  }
}

.mw-unset {
  max-width: unset !important;
}

.of-unset {
  overflow: unset !important;
}

.flex-unset {
  flex: unset !important;
}

.jc-center {
  justify-content: center !important;
}

.table-2 {
  width: 1910px !important;
  min-width: unset;
  margin: 0 auto;
  margin-bottom: 51px;
  position: relative;
}

.charts-container {
  width: 1910px;
  margin: 0 auto;
  // margin-bottom: 20px;
  // height: 337px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
}

.sub-container {
  display: inline-block;
  // border: 1px solid silver;
  font-size: 12px !important;
  height: 100%;
  vertical-align: bottom; 
  box-sizing: border-box; 
}

.chart-wrapper {
  display: inline-block;
  margin-right: 5px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  &.chartContainer {
    display: inline-block;
  }
  
}

.ml-25 {
  margin-left: 25px !important;
}

.ml-15 {
  margin-left: 15px !important;
}

.ml-5 {
  margin-left: 5px !important;
}

.mr-5 {
  margin-right: 5px !important;
}

.date-controls {
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
}

.date-input {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.date-input .dp__main {
  margin: 0 !important;
}

.footer-desc :deep(.dp__input) {
  padding: 0 12px !important;
  // font-size: 12px !important;
  // border: 1px solid #ccc !important;
  // border-radius: 3px !important;
  // width: 100px !important;
}

.grouping-select {
  padding: 2px 5px;
  font-size: 12px;
  border: 1px solid #ccc;
  border-radius: 3px;
}

@media print {
  body * {
    visibility: hidden !important;
  }
  .toasts * {
    visibility: hidden !important;
  }
  // body,
  // #app,
  // #section-reports,
  // .monitoring-content {
  //   width: 1920px !important;
  // }
  #vehicle-dashboard-template-content,
  #vehicle-dashboard-template-content * {
    visibility: visible !important;
  }
  .charts-container,
  .sub-container,
  .bg-white {
    page-break-inside: avoid !important;
  }
  #vehicle-dashboard-template-content {
    position: absolute;
    left: 50% !important;
    top: 0;
    width: 1920px !important;
    box-sizing: border-box;
    transform: scale(0.85);
    transform-origin: top center;
    margin-left: -960px !important; /* Move left by half of the original width to center it */
    zoom: 0.72;
  }

  .highcharts-tooltip-box {
    fill: rgba(255, 255, 255, 0.98) !important;
    stroke: #e5e7eb !important;
    stroke-width: 1px !important;
    filter: drop-shadow(0 4px 6px -1px rgba(0, 0, 0, 0.1));
  }

  .highcharts-tooltip {
    padding: 0 !important;
  }
  
  @page {
    size: A4 landscape;
    margin: 0.5cm;
  }
  
  body {
    margin: 0;
    padding: 0;
  }
}

.chart_header {
  height: 33px;
  margin-bottom: 15px;
}

.sub-container.lampss .chart_header {
  margin-bottom: 0;
}

.excel-bottom-indent {
  margin-top: 13px !important;
  font-size: 18px;
  > span {
    display: inline-block;
    width: 267px;
  }
}

.icons {
  margin: auto 0;
  margin-right: 10px;
  margin-bottom: 3px;
}

.refresh-btn {
    padding: 0 12px;
    font-size: 18px;
    font-weight: 500;
    color: black;
    background: none;
    border: 0.5px solid black;
    height: 26px;
    border-radius: 3px;
    cursor: pointer;
    /* transition: all 0.2s; */
    margin-left: 8px;
}

.refresh-btn:hover {
  background-color: #0056b3;
}

.chart-container-border {
  position: relative !important;
  display: inline-block !important;
}

.chart-container-border::after {
  content: "";
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  border: 1px solid black !important;
  border-radius: 6px !important;
  margin: 0px 10px 57px 10px !important;
  pointer-events: none !important;
}

.bottomlamps {
  position: relative;
  bottom: 39px;
}

.footer-desc_period-label > strong {
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
}

// .footer-desc_period-label :deep(.dp__pointer.dp__input_readonly.dp__input.dp__input_icon_pad.dp__input_reg.dp-custom-input) {
//   border: none !important;
//   position: relative;
//   bottom: 3px;
//   font-size: 18px;
//   padding: 0;
//   // padding-left: 5px;
// }

// .footer-desc_period-label :deep(.dp__main.dp__theme_light) {
//   width: 71px;
//   display: inline-block;
// }

.footer-desc_period-label :deep(span.line) {
  position: relative;
  top: 7px;
}

.footer-desc_period-label > span >div {
  display: flex;
  margin-left: 9px;
  width: 244px;
  // height: 20px;
  padding-left: 8px;

  // border: 1px solid black;
  vertical-align: sub;
}

.footer-desc_period-label :deep(.dp__main.dp__theme_light) {
  display: inline-block;
}

.footer-desc_period-label :deep(.dp__input_icon_pad) {
  padding-left: 23px !important;
}

// .footer-desc_period-label :deep(.dp__instance_calendar .dp__button.dp__button_bottom) {
//   display: none !important;
// }

.sub-container.lampss :deep(.highcharts-axis-labels.highcharts-xaxis-labels > span) {
  top: 45px !important;
}

.sub-container.grub :deep(.highcharts-axis-labels.highcharts-xaxis-labels > span) {
  top: 124px !important;
}

.sub-container.rabts :deep(.highcharts-axis-labels.highcharts-xaxis-labels > span) {
  top: 125px !important;
}

.error {
  color: red;
  margin-left: 5px;
}

.fix_grub_border-bottom-right {
  width: 10px;
  height: 10px;
  // background: red;
  position: absolute;
  right: 6px;
  bottom: 53.5px;
  z-index: 1;
  // background: radial-gradient(circle at -6% 0%, transparent 6px, white 6.5px);
}
.fix_grub_border-bottom-left {
  width: 10px;
  height: 10px;
  // background: red;
  position: absolute;
  left: 6px;
  bottom: 53.5px;
  z-index: 1;
  // background: radial-gradient(circle at 106% 0%, transparent 6px, white 6.5px);
}

.fix_lamps_border-bottom-right {
  width: 10px;
  height: 10px;
  // background: red;
  position: absolute;
  right: 6px;
  bottom: 53.5px;
  z-index: 1;
  // background: radial-gradient(circle at -6% 0%, transparent 6px, white 6.5px);
}

.fix_lamps_border-bottom-left {
  width: 10px;
  height: 10px;
  // background: red;
  position: absolute;
  left: 6px;
  bottom: 53.5px;
  z-index: 1;
  // background: radial-gradient(circle at 106% 0%, transparent 6px, white 6.5px);
}

.fix_rabts_border-bottom-right {
  width: 10px;
  height: 10px;
  // background: red;
  position: absolute;
  right: 6px;
  bottom: 53.5px;
  z-index: 1;
  // background: radial-gradient(circle at -6% 0%, transparent 6px, white 6.5px);
}

.fix_rabts_border-bottom-left {
  width: 10px;
  height: 10px;
  // background: red;
  position: absolute;
  left: 6px;
  bottom: 53.5px;
  z-index: 1;
  // background: radial-gradient(circle at 106% 0%, transparent 6px, white 6.5px);
}

.charts-container .btn-violation-type-icon,
.charts-container .btn-mileage-icon {
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.25);
}

.footer-desc_group-val :deep(.selected) {
  text-align: center;
  padding: unset;
  padding-top: 4px;
  border: 0.5px solid black;
}

.footer-desc_group-val :deep(li) {
  text-align: center;
  display: grid;
  background: white;
}

.footer-desc_group-val :deep(ul) {
  background: white;
}

.s2_footer-desc_group-val {
  padding: 1px;
  font-weight: 400;
  margin-left: 19px;
  height: 19px;
  width: 189px;
  font-size: 12px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: none;
}

.s2_footer-desc_group-val :deep(.selected) {
  text-align: center;
  padding: unset;
  padding-top: 3px;
  border: 0.5px solid black;
}

.s2_footer-desc_group-val :deep(li) {
  text-align: center;
  display: grid;
  background: white;
}

.s2_footer-desc_group-val :deep(ul) {
  background: white;
}

.heatmap-panel {
  position: relative;
  width: 1861px;
  border-radius: 5px;
  margin: 0 15px;
  padding: 0 8px;
  padding-bottom: 8px;
  border: 1px solid black;
  background-color: white;
  box-sizing: border-box;
  transition: width 0.3s ease, height 0.3s ease;
}

.heatmap-panel--expanded {
    // width: 1868px;
    // height: 934px;
    // bottom: 553px;
    // right: -10px;
    z-index: 2;
    margin: 0;
    // transition: width 0.3s ease, height 0.3s ease;
}

.heatmap-expand-btn {
  position: absolute;
  top: 4px;
  right: 40px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.leaflet-map {
  width: 100%;
  height: 339px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 7px;
  position: relative;
  overflow: hidden;
  transition: height 0.3s ease;
}

.heatmap-panel--expanded .violation-panel-overlay {
  height: 938px;
  top: -556px;
  width: 1879px;
  right: -18px;
  // transition: width 0.3s ease, height 0.3s ease;
}

@media print {
  .heatmap-panel {
    page-break-inside: avoid;
    margin: 20px auto 0 auto;
  }
}

.map-blur {
  filter: blur(5px);
}

.preloader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 1001;
}

.violation-panel-overlay {
  position: absolute;
  top: 31px;
  height: 339px;
  width: 1843px;
  // position: relative;
  // top: 8px;
  // left: 8px; 
  // width: calc(100% - 16px); 
  // height: calc(100% - 16px);
  z-index: 1002;
  background: white;
  border: 1px solid black;
  border-radius: 5px;
  // padding: 0 8px 8px 8px;
  box-sizing: border-box;
}

.violation-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // padding: 10px;
  // border-bottom: 1px solid #ccc;
}

.violation-table * {
  letter-spacing: 1.8px;
}

.header-left-buttons {
  display: flex;
  gap: 10px;
}

.btn-with-icon-and-text {
  display: flex;
  align-items: center;
  gap: 5px;
}

.btn-violation-type-icon {
  margin-left: 11px !important;
  margin-right: 2px !important;
}

.btn-mileage-icon {
  margin-left: 16px !important;
  margin-right: 10px !important;
}

.btn-violation-type-icon, .btn-mileage-icon, .btn-violation-count-icon {
  background-color: white !important;
  border: 1px solid #ccc !important;
  border-radius: 5px;
  width: 40px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-violation-type-icon.active, .btn-mileage-icon.active {
  background-color: rgba(245, 245, 245, 1) !important;
}

.btn-text {
  font-size: 12px;
  margin-bottom: 9px;
}

.hidden {
  display: none;
}

.btn-mileage-only-icon {
  background-color: white !important;
  border: 1px solid #ccc !important;
  border-radius: 5px;
  padding: 0 5px;
  height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-center-title {
  flex-grow: 1;
  // margin-left: 517px;
  text-align: center;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 1.8px;
}

.close-panel-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #999;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-panel-btn:hover {
  color: #333;
}

.violation-table-container {
  // padding: 10px;
  overflow-x: auto;
  height: 310px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}

.heatmap-panel--expanded .violation-table-container {
  height: 908px;
}

.violation-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}

.violation-table > thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.violation-table th,
.violation-table td {
  text-align: center;
}

.violation-table td {
  border-left: none;
  border-right: none;
  text-align: right;
  font-size: 18px;
}

.violation-table th {
  background-color: white;
  border-top: 2px solid black;
  border-bottom: 2px solid black;
  border-left: none;
  border-right: none;
  top: 0;
  padding: 5px;
  font-size: 18px;
  font-weight: 700;
  text-align: right;
}

/* Стиль для точки "запросить трек" */
.track-request-dots {
  color: #180CF9;
  cursor: pointer;
  margin-right: 2px;
  font-weight: 700;
  position: relative;
  display: inline-block;
  opacity: 0.5;
}

.track-request-dots::after {
  content: 'запросить трек';
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  background: white;
  color: black;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.1px;
  padding: 4px 8px;
  border: 1px solid #180CF9;
  border-radius: 5px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 10;
}

.track-request-dots::before {
  content: '';
  position: absolute;
  bottom: calc(100% + 2px);
  left: 50%;
  transform: translateX(-50%);
  border: 4px solid transparent;
  border-top-color: #333;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 10;
}

.track-request-dots:hover::after,
.track-request-dots:hover::before {
  opacity: 1;
}

/* Стиль для строки с пробегом */
.violation-table tr.mileage-row {
  font-size: 12px;
}

.violation-table th[rowspan] {
  vertical-align: middle;
  text-align: center;
}

/* Поворот стрелок на 180 градусов */
.rotated {
  transform: rotate(180deg);
}

/* Стили для детальной таблицы (отдельная панель) */
.detailed-table-overlay {
  position: absolute;
  top: 28px;
  left: 0;
  right: 0;
  bottom: 0;
  // background-color: rgba(0, 0, 0, 0.5);
  z-index: 1002;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detailed-table-overlay-bezop {
  bottom: 8px !important;
  top: unset;
}

.detailed-table-overlay-transmission {
  top: -287px;
}

.detailed-table-panel {
  background-color: white;
  border-radius: 5px;
  // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  width: 892px;
  max-height: 334px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 2px solid #2430D3;
  &-malfunction {
    width: 1187px;
  }
}

.detailed-table-panel-bezop {
  max-height: unset !important;
  width: 900px;
}

.detailed-table-panel-transmission {
  max-height: 652px;
}

.detailed-table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #e5e7eb;
  background-color: #f9fafb;
}

.detailed-table-title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.detailed-table-close {
  float: right;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  width: 20px;
  height: 20px;
  position: absolute;
  right: 0;
  top: 3px;
  z-index: 1;
}

.detailed-table-close:hover {
  background-color: #e5e7eb;
}

.detailed-table-content {
  overflow: auto;
}

.detailed-table-inner {
  width: 100%;
  border-collapse: collapse;
}

.detailed-table-inner th {
  background-color: white;
}

.detailed-table-inner tr:nth-child(2) th {
  top: 50px;
  z-index: 4;
}

/* Стили для иконок сортировки */
.sort-icon {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
}

/* Стили для кнопки назад */
.back-button:hover {
  opacity: 0.8;
}

/* Стили для активных кнопок сортировки */
th[style*="cursor: pointer"]:hover {
  background-color: #f5f5f5;
}

/* Стили для таблицы объема сливов (таблица 2 уровня) */
.fuel-out-detailed-overlay {
  position: absolute;
  top: 32px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1002;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fuel-out-detailed-panel {
  background-color: white;
  border-radius: 5px;
  position: relative;
  width: 1340px;
  max-height: 400px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 2px solid #2430D3;
}

.fuel-out-detailed-note {
  font-size: 12px;
  padding: 0 15px;
  padding-top: 10px;
  line-height: 1.4;
  font-weight: 400;
  margin: 0;
}

.progress-text {
  position: absolute;
  top: 150px;
  color: black;
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
}

/* Стили для кнопок выбора ТС и выполнения отчета */
.select-ts-btn {
  padding: 0 12px;
  background: none;
  color: black;
  font-size: 18px;
  font-weight: 500;
  height: 26px;
  border: 0.5px solid black;
  border-radius: 3px;
  cursor: pointer;
  // transition: all 0.2s;
  margin-right: 8px;
  position: relative;
  top: 1px;
}

.footer-desc :deep(.target-show > input) {
  background: none;
  color: black;
  padding: 0 .5rem;
  height: 26px;
  font-size: 18px;
  border: 0.5px solid black;
  border-radius: 3px;
  position: relative;
  bottom: 2px;
}

.select-ts-btn:hover {
  background-color: #e5e7eb;
}

.execute-report-btn {
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  color: white;
  background-color: #2563eb;
  border: 1px solid #2563eb;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.execute-report-btn:hover {
  background-color: #1d4ed8;
}

// .refresh-btn {
//     padding: 0 12px;
//     font-size: 18px;
//     font-weight: 500;
//     color: black;
//     background: none;
//     border: 0.5px solid black;
//     border-radius: 3px;
//     cursor: pointer;
//     /* transition: all 0.2s; */
//     margin-left: 8px;
// }

.refresh-btn:hover {
  background-color: #e5e7eb;
}

// Стили для модального окна с информацией о нарушениях ДВС
.dvs-info-modal-overlay {
  position: absolute;
  // top, left, right, bottom задаются индивидуально через конфиг в template
  // background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.dvs-info-modal {
  background-color: #ffffff;
  border: 2px solid #00426A;
  border-radius: 8px;
  max-width: 615px;
  // max-height задается индивидуально через конфиг в template
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 101;
}

.dvs-info-modal-transmission {
  max-width: 534px;
}

.dvs-info-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  background-color: #ffffff;
}

.dvs-info-modal-title {
  font-size: 16px;
  font-weight: 700;
  color: #00426A;
}

.dvs-info-modal-close {
  display: inline-block;
  float: right;
  position: sticky;
  top: 0;
  z-index: 1;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  // display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.dvs-info-modal-close:hover {
  opacity: 1;
}

.dvs-info-modal-content {
  padding: 5px;
}

.dvs-info-item {
  margin-bottom: 24px;
}

.dvs-info-item:last-child {
  margin-bottom: 0;
}

.dvs-info-item-title {
  font-size: 12px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 8px;
  line-height: 1.4;

  span {
    font-weight: 400;
    color: #4b5563;
  }
}

.dvs-info-item-consequences {
  list-style: none;
  padding: 0;
  margin: 0;
  padding-left: 16px;

  li {
    font-size: 12px;
    color: #4b5563;
    line-height: 1.5;
    margin-bottom: 4px;
    position: relative;

    &::before {
      content: '-';
      position: absolute;
      left: -12px;
      color: #6b7280;
    }
  }
}

#section-violations .violation-value {
  display: inline-block;
  width: 50px;
  // background: red;
  text-align: end;
}

// Адаптация под экраны с шириной < 1920px
@media (max-width: 1919px) {
  .temlate-report {
    transform: scale(0.879);
    transform-origin: top left;
    margin-left: calc((100vw - 1684px) / 2);
  }
}

// 2K (2560×1440) с масштабом Windows 150% (~1707px)
@media (max-width: 1707px) {
  .temlate-report {
    transform: scale(0.711); 
    transform-origin: top left;
    margin-left: calc((100vw - 1358px) / 2);
  }
}

// Full HD с масштабом Windows 125% (эффективное разрешение ~1536px)
// @media (max-width: 1536px) {
//   .temlate-report {
//     transform: scale(0.8); // 1536 / 1920 
//     transform-origin: top left;
//   }
// }

// HD экраны 1366×768
@media (max-width: 1366px) {
  .temlate-report {
    transform: scale(0.667);
    transform-origin: top left;
    margin-left: calc((100vw - 1273px) / 2);
  }
}

// Full HD с масштабом Windows 150% (~1280px), HD Ready 1280×720
@media (max-width: 1280px) {
  .temlate-report {
    transform: scale(0.533); // 1280 / 1920
    transform-origin: top left;
    margin-left: calc((100vw - 1018px) / 2);
  }
}

// Full HD с масштабом Windows 200% (~960px) и планшеты
// @media (max-width: 1024px) {
//   .temlate-report {
//     transform: scale(0.533); // 1024 / 1920
//     transform-origin: top left;
//   }
// }

.disabled-blurred {
  pointer-events: none;
  opacity: 0.5;
  filter: blur(3px);
  transition: all 0.3s ease;
}
</style>